import type { Dict } from '../types';

export const hu: Dict = {
  'chat.amrCard.switchTitle': 'Sikertelen modellhívás — ez a futtatás szünetel',
  'chat.amrCard.switchBody': 'Válts az Open Design hivatalos AMR modellszolgáltatására — nincs szükség API-kulcs beállítására. Bejelentkezés, engedélyezés és feltöltés után ez a futtatás automatikusan újraindul.',
  'chat.amrCard.chipOfficial': 'Hivatalos szolgáltatás',
  'chat.amrCard.chipNoKey': 'Nincs API-kulcs',
  'chat.amrCard.chipAutoRetry': 'Automatikus újrapróbálkozás bejelentkezés után',
  'chat.amrCard.switchCta': 'Váltás AMR-re és újrapróbálkozás',
  'chat.amrError.authMessage': 'Az AMR-fiókod még nincs engedélyezve. Engedélyezd, és ez a futtatás automatikusan újraindul.',
  'chat.amrError.balanceMessage': 'Az AMR-egyenleged elfogyott. Tölts fel a futtatás folytatásához.',
  'chat.amrError.authorizeCta': 'Engedélyezés és újrapróbálkozás',
  'chat.amrError.rechargeCta': 'AMR feltöltése',
  'chat.antigravityError.launchTerminalCta': 'Bejelentkezés terminálon keresztül',
  'chat.antigravityError.launchSwitchModelCta': 'Modellváltás a terminálban',
  'chat.connectionDropped': 'A modellszolgáltatáshoz való kapcsolat megszakadt a válasz befejezése előtt – általában instabil hálózat vagy proxy miatt. Kérjük, próbáld újra.',
  'chat.runError.title.authRequired': 'Engedélyezés szükséges',
  'chat.runError.title.balance': 'Nincs elég egyenleg',
  'chat.runError.title.connectionDropped': 'A kapcsolat megszakadt',
  'chat.runError.title.signInRequired': 'Bejelentkezés szükséges',
  'chat.runError.title.rateLimited': 'Elérted a használati korlátot',
  'chat.runError.title.generic': 'A feladat sikertelen',
  'chat.runError.signInMessage.amr': 'Az Open Design ügynök még nincs bejelentkezve – jelentkezz be a használatához.',
  'chat.runError.signInMessage.other': '{agent} nincs bejelentkezve. Ellenőrizd a bejelentkezési állapotát helyben. Az Open Design ügynököt ajánljuk – stabilabb és gazdaságosabb.',
  'chat.runError.agentFallback': 'az ügynök',
  'chat.runError.sourceLabel': 'Hibaforrás',
  'chat.runError.sourceExpandAria': 'Hibaforrás kibontása',
  'chat.runError.sourceCollapseAria': 'Hibaforrás összecsukása',
  'common.cancel': 'Mégse',
  'chat.selectFromLibrary': 'Importálás a könyvtárból',
  'chat.importFigma': 'Importálás Figmából',
  'designFiles.library.label': 'Importálás a könyvtárból',
  'designFiles.library.title': 'Importálás a könyvtárból',
  'libraryPicker.title': 'Importálás a könyvtárból',
  'libraryPicker.searchPlaceholder': 'Keresés a könyvtárban…',
  'libraryPicker.empty': 'Még nincsenek elemek a könyvtáradban',
  'libraryPicker.allKinds': 'Összes',
  'libraryPicker.add': 'Importálás',
  'libraryPicker.loading': 'Betöltés…',
  'common.save': 'Mentés',
  'common.close': 'Bezárás',
  'common.clear': 'Törlés',
  'common.delete': 'Törlés',
  'common.rename': 'Átnevezés',
  'common.edit': 'Szerkesztés',
  'common.preview': 'Előnézet',
  'common.share': 'Megosztás',
  'common.search': 'Keresés',
  'common.searchEllipsis': 'Keresés…',
  'common.loading': 'Betöltés…',
  'common.all': 'Összes',
  'common.none': 'Nincs',
  'common.default': 'Alapértelmezett',
  'common.installed': 'telepítve',
  'common.notInstalled': 'nincs telepítve',
  'common.active': 'aktív',
  'common.offline': 'offline',
  'common.selected': 'kiválasztva',
  'common.create': 'Létrehozás',
  'common.openPreview': 'Előnézet megnyitása',
  'common.exitFullscreen': 'Kilépés a teljes képernyőből',
  'common.fullscreen': 'Teljes képernyő',
  'common.openInNewTab': 'Megnyitás új lapon',
  'common.exportPdf': 'Exportálás PDF-ként',
  'common.exportZip': 'Letöltés .zip-ként',
  'common.exportHtml': 'Exportálás önálló HTML-ként',
  'common.exportImage': 'Exportálás képként',
  'common.exportImageFailed': 'A kép rögzítése sikertelen. Próbálja újra, vagy használja a böngésző képernyőkép eszközét.',
  'common.justNow': 'az imént',
  'common.minutesAgo': '{n} perce',
  'common.hoursAgo': '{n} órája',
  'common.daysAgo': '{n} napja',
  'common.weeksAgo': '{n} hete',
  'common.now': 'most',
  'common.minutesShort': '{n}p',
  'common.hoursShort': '{n}ó',
  'common.daysShort': '{n}n',
  'common.untitled': 'Cím nélkül',
  'plugins.availableDetails.provenance': 'Eredet',
  'plugins.availableDetails.provenanceLine': 'forrás: {source} · {trust} · {resolved}',
  'plugins.availableDetails.provenanceLineWithIntegrity': 'forrás: {source} · {trust} · {resolved} · {integrity}',
  'plugins.availableDetails.install': 'Telepítés',
  'plugins.availableDetails.version': 'Verzió',
  'plugins.availableDetails.pluginVersion': 'Plugin verzió',
  'plugins.availableDetails.copyInstallCommand': 'Telepítési parancs másolása',
  'plugins.availableDetails.copied': 'Másolva',
  'plugins.availableDetails.deprecatedPrefix': 'Elavult: {message}',
  'plugins.availableDetails.deprecatedFallback': 'Ezt a verziót elavultként jelölték meg.',
  'plugins.availableDetails.yanked': 'Visszavonva.',
  'plugins.availableDetails.yankedWithReason': 'Visszavonva: {reason}',
  'plugins.availableDetails.versionDeprecatedSuffix': ' (elavult)',
  'plugins.availableDetails.versionYankedSuffix': ' (visszavonva)',
  'plugins.availableDetails.ref': 'Ref',
  'plugins.availableDetails.integrity': 'Integrity',
  'plugins.availableDetails.permissions': 'Engedélyek',
  'plugins.availableDetails.capabilitySummary': 'Képességek összefoglalása',
  'plugins.actions.copyInstallCommand': 'Telepítési parancs másolása',
  'plugins.actions.copyPluginId': 'Pluginazonosító másolása',
  'plugins.actions.copyReadmeBadge': 'README jelvény másolása',
  'plugins.actions.openSourceGithub': 'Forrás megnyitása GitHubon',
  'plugins.actions.openSource': 'Forrás megnyitása',
  'plugins.actions.openHomepage': 'Honlap megnyitása',
  'plugins.actions.openMarketplace': 'Megnyitás a piactéren',
  'app.brand': 'Open Design',
  'app.brandPill': 'Kutatási előzetes',
  'app.brandSubtitle': 'a Nexu Labs-tól',
  'app.welcomeLoading': 'Munkaterület betöltése…',
  'settings.welcomeKicker': '',
  'settings.welcomeTitle': 'Üdvözöljük az Open Designban',
  'settings.welcomeSubtitle': '',
  'settings.onboardingCreateTitle': 'Kezdés egy leírásból',
  'settings.onboardingCreateBody': 'Írja le a kívánt webhelyet, alkalmazást, prezentációt, képet vagy videót. Az Open Design létrehoz egy projektet, és a munkát szerkeszthetően tartja.',
  'settings.onboardingMemoryTitle': 'Munkakontextus mentése',
  'settings.onboardingMemoryBody': 'Adjon hozzá beállításokat, projekttényeket és visszatérő szabályokat, hogy a jövőbeli beszélgetések a megfelelő kontextust vegyék át.',
  'settings.onboardingMemoryCalloutTitle': 'Elmentve a Memóriájába',
  'settings.onboardingMemoryCalloutBody': 'Ezek a válaszok adják a Memória-profilja alapját. Az Open Design minden feladatnál újra felhasználja – és folyamatosan tanul, miközben dolgozik.',
  'settings.onboardingMemoryBenefitIntent': 'Egy rövid kérésből is megérti, mire gondol',
  'settings.onboardingMemoryBenefitFewerQuestions': 'Kihagyja az ismétlődő beállítási kérdéseket',
  'settings.onboardingMemoryBenefitPersonalized': 'A kimenetet a szerepéhez, közönségéhez és ízléséhez igazítja',
  'settings.onboardingSystemsTitle': 'Hozza a saját designrendszerét',
  'settings.onboardingSystemsBody': 'Válasszon vagy hozzon létre egy márkarendszert, hogy a generált munka valós színeket, tipográfiát és terméknyelvet kövessen.',
  'settings.onboardingExecutionTitle': 'Válassza ki, hogyan fusson a generálás',
  'settings.onboardingExecutionBody': 'Hivatalos CLI egykattintásos beállítással és használatra kész alapértékekkel. Egyetlen kulccsal választhat számos modell közül, jobb árazással.',
  'settings.onboardingAmrCloudBenefitOfficial': 'Hivatalosan ajánlott',
  'settings.onboardingAmrCloudBenefitReady': 'Telepítés nélkül',
  'settings.onboardingAmrCloudBenefitModels': 'Támogatja a Claude Opus 4.8-at',
  'settings.onboardingAmrCloudBenefitPricing': 'SOTA Harness',
  'settings.onboardingAmrCloudUpcomingLabel': 'Hamarosan',
  'settings.onboardingAmrCloudUpcomingImageVideo': 'Kép és videó',
  'settings.onboardingAmrCloudUpcomingSkills': 'Sok Skill',
  'settings.onboardingAmrCloudUpcomingRouting': 'Intelligens útválasztás',
  'settings.onboardingAmrModelSourceLabel': 'AMR CLI',
  'settings.onboardingAmrCloudAuthorizeAction': 'AMR engedélyezése',
  'settings.onboardingAmrCloudAuthorizedAction': 'Engedélyezve',
  'settings.onboardingStepConnect': 'Connect',
  'settings.onboardingStepDesignSystem': 'Dizájnrendszer létrehozása',
  'settings.onboardingStepProfile': 'About you',
  'settings.onboardingStepNewsletter': 'Stay updated',
  'settings.onboardingNewsletterTitle': 'Stay in the loop',
  'settings.onboardingNewsletterBody': 'Get product updates, new templates, design-system drops, and ambassador work in your inbox. Optional — you can skip this.',
  'settings.onboardingConnectTitle': 'Choose a runtime',
  'settings.onboardingConnectBody': '',
  'settings.onboardingCloudTitle': 'Bejelentkezés az Open Designba',
  'settings.onboardingCloudBody': 'Jelentkezz be, és azonnal tervezz felhőalapú MI-vel – bonyolult beállítás nélkül.',
  'settings.onboardingCloudSignIn': 'Bejelentkezés az Open Design Cloudba',
  'settings.onboardingCloudContinue': 'Folytatás (bejelentkezve)',
  'settings.onboardingCloudAlternative': 'Helyi CLI vagy saját API-kulcs használata',
  'settings.onboardingCloudRights': 'Minden jog fenntartva.',
  'settings.onboardingCloudOr': 'vagy',
  'settings.onboardingGateTooltipNoRuntime': 'A következő lépések MI-n futnak — válassz futtatókörnyezetet a folytatáshoz.',
  'settings.onboardingGateTooltipAmr': 'A következő lépések MI-n futnak — jelentkezz be az Open Design AMR-be a folytatáshoz.',
  'settings.onboardingGateTooltipLocal': 'A következő lépések MI-n futnak — válassz egy elérhető helyi CLI-t a folytatáshoz.',
  'settings.onboardingGateTooltipByok': 'A következő lépések MI-n futnak — add meg és teszteld a modellkulcsodat a folytatáshoz.',
  'settings.onboardingRecommended': 'Recommended',
  'settings.onboardingAmrCloudOfficialBadge': 'Hivatalos',
  'settings.onboardingLocalTitle': 'Local coding agent',
  'settings.onboardingLocalBody': 'Use an installed CLI such as Claude Code, Codex, Cursor, Gemini, or OpenCode.',
  'settings.onboardingLocalAction': 'Open CLI settings',
  'settings.onboardingCliScanHint': 'This usually takes 5-10 seconds.',
  'settings.onboardingByokTitle': 'Bring your own key',
  'settings.onboardingByokBody': 'Use your own model provider credentials.',
  'settings.onboardingByokAction': 'Open BYOK settings',
  'settings.onboardingDesignTitle': 'Design system',
  'settings.onboardingDesignBody': 'Generate once, reuse everywhere.',
  'settings.onboardingDesignIntroGenerateTitle': 'Generate from existing work',
  'settings.onboardingDesignIntroGenerateBody': 'Upload your design system from GitHub or local code repositories, Figma files, images, and other content assets.',
  'settings.onboardingDesignIntroReuseTitle': 'Reuse in future work',
  'settings.onboardingDesignIntroReuseBody': 'Future prototypes, slides, and other content can reference your existing fonts, spacing, logo style, and color tone.',
  'settings.onboardingDesignIntroSkipTitle': 'Optional for now',
  'settings.onboardingDesignIntroSkipBody': 'Skip this step if you want to start without generating a design system.',
  'settings.onboardingGithubTitle': 'Import from GitHub',
  'settings.onboardingGithubBody': 'Use a frontend repository.',
  'settings.onboardingUploadTitle': 'Upload local files',
  'settings.onboardingUploadBody': 'Add project files, screenshots, CSS, docs, or assets.',
  'settings.onboardingPromptTitle': 'Generate from prompt',
  'settings.onboardingPromptBody': 'Describe the product or brand.',
  'settings.onboardingProfileTitle': 'About you',
  'settings.onboardingProfileBody': 'Optional details for better defaults.',
  'settings.onboardingRoleLabel': 'Your role',
  'settings.onboardingOrgSizeLabel': 'Organization size',
  'settings.onboardingUseCaseLabel': 'Use case',
  'settings.onboardingSourceLabel': 'Where did you hear about us?',
  'settings.onboardingSelectPlaceholder': 'Select one',
  'settings.onboardingSelectMultiplePlaceholder': 'Select one or more',
  'settings.onboardingOrgSolo': 'Solo / personal (1)',
  'settings.onboardingOrgTeam': 'Small team (2-10)',
  'settings.onboardingOrgStartup': 'Startup / SMB (11-50)',
  'settings.onboardingOrgGrowth': 'Growth company (51-200)',
  'settings.onboardingOrgMidMarket': 'Mid-market (201-1000)',
  'settings.onboardingOrgEnterprise': 'Enterprise (1000+)',
  'settings.onboardingRolePm': '📋 Product manager',
  'settings.onboardingRoleDesigner': '🎨 Designer',
  'settings.onboardingRoleEngineer': '💻 Engineer',
  'settings.onboardingRoleMarketing': '📣 Marketing',
  'settings.onboardingRoleAgency': '📣 Marketingügynökség',
  'settings.onboardingRoleGrowth': '📈 Growth',
  'settings.onboardingRoleOps': '⚙️ Operations',
  'settings.onboardingRoleFounder': '🚀 Founder / executive',
  'settings.onboardingRoleStudent': '🎓 Student / educator',
  'settings.onboardingRoleOther': '✨ Other',
  'settings.onboardingUseProduct': '🎨 Product design',
  'settings.onboardingUseDesignSystem': '🧩 Design system',
  'settings.onboardingUsePrototype': '📱 Prototype / app UI',
  'settings.onboardingUseLanding': '🌐 Landing pages',
  'settings.onboardingUseAds': '📣 Ads / social content',
  'settings.onboardingUseDashboard': '📊 Dashboards / internal tools',
  'settings.onboardingUseDeck': '🖥️ Presentation / deck',
  'settings.onboardingUseMarketing': '📈 Marketing / growth',
  'settings.onboardingUseEngineering': '🤝 Engineering handoff',
  'settings.onboardingUseAgency': '💼 Agency / client work',
  'settings.onboardingSourceGithub': '🐙 GitHub',
  'settings.onboardingSourceFriend': '👥 Friend or coworker',
  'settings.onboardingSourceSocial': '📱 Social media',
  'settings.onboardingSourceProductHunt': '🅿️ Product Hunt',
  'settings.onboardingSourceCommunity': '💬 Design / AI community',
  'settings.onboardingSourceYoutube': '▶️ YouTube',
  'settings.onboardingSourceBlog': '📰 Blog or newsletter',
  'settings.onboardingSourceAiTool': '✨ AI tool recommendation',
  'settings.onboardingSourceSearch': '🔍 Search',
  'settings.onboardingSourceEvent': '🎤 Event or community',
  'settings.onboardingBack': 'Back',
  'settings.onboardingContinue': 'Continue',
  'settings.onboardingFinish': 'Finish setup',
  'settings.kicker': 'Beállítások',
  'settings.title': 'Végrehajtási mód',
  'settings.subtitle': 'Válassz helyi CLI és BYOK között.',
  'settings.modeAria': 'Végrehajtási mód',
  'settings.protocolAria': 'API protokoll',
  'settings.modeDaemon': 'Helyi CLI',
  'settings.modeDaemonHelp': 'Futtatás a gépeden lévő code-agent CLI-n keresztül',
  'settings.modeDaemonOffline': 'A daemon nem fut',
  'settings.modeDaemonOfflineMeta': 'a daemon offline',
  'settings.modeDaemonInstalledMeta': '{count} telepítve',
  'settings.modeApi': 'API-szolgáltató',
  'settings.modeApiMeta': 'BYOK',
  'settings.byokNoFileToolsNotice': 'A BYOK nem tud projektfájlokat olvasni, írni vagy szerkeszteni. Ha kódmódosításra van szüksége, használja a Local CLI-t.',
  'settings.codeAgent': 'Kód Agent',
  'settings.codeAgentHint': 'A PATH átvizsgálásával észlelve. Válaszd ki a CLI-t, amelyen át a generálásokat szeretnéd futtatni.',
  'settings.rescan': '↻ Újraellenőrzés',
  'settings.rescanTitle': 'PATH újraellenőrzése',
  'settings.rescanRunning': 'Ellenőrzés...',
  'settings.rescanSuccess': 'Ellenőrzés kész. {count} elérhető.',
  'settings.designSystemRenameFailed': 'Az átnevezés sikertelen. Ellenőrizd a daemont, majd próbáld újra.',
  'settings.rescanFailed': 'Az ellenőrzés sikertelen. Ellenőrizd a daemont, majd próbáld újra.',
  'settings.test': 'Teszt',
  'settings.testTitle': 'Küldj egy apró tesztkérdést a kapcsolat ellenőrzéséhez',
  'settings.testRunning': 'Kapcsolat tesztelése…',
  'settings.byokReadyToTest': 'Tesztelésre kész',
  'settings.testCancel': 'Mégse',
  'settings.testRetry': 'Teszt újrapróbálása',
  'settings.required': 'kötelező',
  'settings.testMissingFields': 'Töltse ki a következőt a kapcsolat teszteléséhez: {fields}.',
  'settings.testSuccessApi': 'Csatlakozva. Válasz {ms} ms alatt — \'{sample}\'',
  'settings.testSuccessCli': '{agentName} {ms} ms alatt válaszolt — \'{sample}\'',
  'settings.testAuthFailed': 'A hitelesítés sikertelen. Ellenőrizd az API kulcsot.',
  'settings.testForbidden': 'A hozzáférés tiltott. Ellenőrizd a fiókot, régiót vagy szervezetet.',
  'settings.testNotFoundModel': 'A(z) \'{model}\' modell nem található ezen a végponton.',
  'settings.testInvalidModelId': 'A(z) \'{model}\' modellazonosító érvénytelen. Az egyéni azonosító betűvel vagy számmal kezdődjön, és ne tartalmazzon szóközt.',
  'settings.testInvalidBaseUrl': 'A Base URL érvénytelen vagy nem elérhető.',
  'settings.testRateLimited': 'A szolgáltató korlátozta a tesztet. A konfiguráció érvényesnek tűnik.',
  'settings.testUpstream': 'A szolgáltató {status} kódot adott vissza. Próbáld újra rövidesen.',
  'settings.testTimeout': 'A teszt {ms} ms után időtúllépéssel megszakadt.',
  'settings.testAgentMissing': 'A(z) {agentName} nincs telepítve vagy nincs a PATH-ban.',
  'settings.testAgentSpawn': 'Nem sikerült elindítani: {agentName} — {detail}.',
  'settings.testUnknown': 'Sikertelen teszt: {detail}',
  'settings.agentInstall.install': 'Telepítés',
  'settings.agentInstall.docs': 'Dokumentáció',
  'settings.agentInstall.pathHint': 'Ha npm-mel vagy Homebrew-val telepítettél egy CLI-t, de továbbra is nincs telepítve állapotban látszik, ellenőrizd, hogy az eszköz bin könyvtára benne van-e abban a PATH-ban, amit az Open Design daemon örököl (macOS-en a Terminal és a GUI appok PATH-ja eltérhet). Lásd a QUICKSTART.md "Local agent CLI and PATH" szakaszát.',
  'settings.agentInstall.stepOpenLinks': 'Nyisd meg a Telepítés vagy Dokumentáció hivatkozást a kívánt ügynöknél.',
  'settings.agentInstall.stepAuth': 'Hitelesíts a szolgáltató CLI-jében (bejelentkezés vagy API hitelesítő adatok megadása), mielőtt visszatérsz az Open Designhoz.',
  'settings.agentInstall.stepRescan': 'Kattints az Újraellenőrzés gombra ebben a szakaszban.',
  'settings.agentInstall.stepSelect': 'Válaszd ki az ügynök kártyáját, amint telepítettként jelenik meg.',
  'settings.noAgentsDetected': 'Még nincs észlelt ügynök. Telepítsd a Claude Code, Codex, Devin for Terminal, Gemini CLI, OpenCode, Cursor Agent, Qwen vagy GitHub Copilot CLI valamelyikét, majd kattints az Újraellenőrzésre.',
  'settings.agentInstalledGroup': 'Saját CLI-k ({count})',
  'settings.agentInstallGroup': 'Telepíthető ({count})',
  'settings.agentAuthRequired': 'Hitelesítés szükséges',
  'settings.agentAuthUnknown': 'A hitelesítési állapot ismeretlen',
  'settings.amrCloud': 'Open Design AMR',
  'settings.amrAuthorize': 'Engedélyezés',
  'settings.amrBenefitOfficial': 'Officially maintained',
  'settings.amrBenefitLowerPrice': 'Lower price',
  'settings.amrBenefitManyModels': 'Számos modell',
  'settings.amrPromoBonus': 'Korlátozott bónusz: +100%',
  'settings.amrSignInToContinue': 'Jelentkezzen be a folytatáshoz',
  'settings.amrSignIn': 'Bejelentkezés',
  'settings.amrSignedIn': 'Bejelentkezve',
  'settings.amrWalletBalance': 'Wallet balance',
  'settings.amrWalletUnavailable': 'Balance temporarily unavailable',
  'settings.amrWalletUpdatedAt': 'Updated {time}',
  'settings.amrWalletCached': 'cached',
  'settings.amrWalletRefresh': 'Refresh',
  'settings.amrWalletRefreshTitle': 'Refresh AMR wallet balance',
  'settings.amrNotSignedIn': 'Nincs bejelentkezve',
  'settings.amrSigningIn': 'Bejelentkezés…',
  'settings.amrActivationHint': 'Nem nyílt meg a bejelentkezési oldal? Az alábbi gombbal nyisd meg újra.',
  'settings.amrActivationBrowserFailed': 'A böngészőt nem sikerült automatikusan megnyitni. A folytatáshoz nyissa meg az alábbi bejelentkezési oldalt.',
  'settings.amrActivationOpen': 'Bejelentkezési oldal megnyitása',
  'settings.amrCancelSignIn': 'Bejelentkezés megszakítása',
  'settings.amrAccountStatus': 'AMR fiók állapota',
  'settings.amrConsole': 'AMR konzol',
  'settings.amrLoginErrorCompact': 'Az AMR bejelentkezés sikertelen.',
  'settings.advanced': 'Speciális',
  'settings.amrLogin': 'Bejelentkezés',
  'settings.amrLogout': 'Kijelentkezés',
  'settings.amrLoggingIn': 'Bejelentkezés…',
  'settings.amrLoggingOut': 'Kijelentkezés…',
  'settings.amrLoggedInAs': 'Bejelentkezve mint {email}',
  'settings.amrLoggedInWithPlan': 'Bejelentkezve mint {email} · {plan}',
  'settings.amrLoggedInPill': 'Bejelentkezve',
  'settings.amrNotLoggedIn': 'Nincs bejelentkezve',
  'settings.apiSection': 'Anthropic API',
  'settings.quickFillProvider': 'Szolgáltató gyors kitöltése',
  'settings.providerPreset': 'Átjáró-előbeállítás',
  'settings.protocolGroupProtocols': 'Protokollok',
  'settings.protocolGroupGateways': 'Átjárók',
  'settings.customProvider': 'Egyéni szolgáltató',
  'settings.apiKey': 'API-kulcs',
  'settings.apiKeyGetLink': 'Kulcs beszerzése ↗',
  'settings.showKey': 'Kulcs megjelenítése',
  'settings.hideKey': 'Kulcs elrejtése',
  'settings.show': 'Megjelenítés',
  'settings.hide': 'Elrejtés',
  'settings.model': 'Modell',
  'settings.apiKeyInvalid': 'Érvénytelen API key.',
  'settings.apiKeyCleaned': 'Felesleges szóköz eltávolítva az API key-ből.',
  'settings.modelsLoadedFromAccount': '✓ {count} modell betöltve a fiókodból.',
  'settings.modelsLoadedCount': '✓ {count} modell betöltve.',
  'settings.modelSourceAccount': 'A fiókjából',
  'settings.modelSourceSuggested': 'Javasolt',
  'settings.fetchModels': 'Modellek lekérése',
  'settings.fetchModelsTitle': 'Elérhető modellek lekérése ettől a szolgáltatótól',
  'settings.fetchModelsRunning': 'Modellek lekérése…',
  'settings.fetchModelsMissingFields': 'Töltse ki a következőt a modellek lekéréséhez: {fields}.',
  'settings.fetchModelsInvalidBaseUrl': 'Adjon meg egy érvényes Base URL-t a modellek lekéréséhez.',
  'settings.fetchModelsUnsupportedAzure': 'Az Azure OpenAI üzemelési neveket használ, ezért a modellfelderítés itt nem érhető el.',
  'settings.fetchModelsUnsupportedOllama': 'Az Ollama Cloud modellfelderítés még nem érhető el. Válasszon vagy írjon be egy modellt.',
  'settings.fetchModelsSuccess': '{count} modell lekérve.',
  'settings.fetchModelsEmpty': 'Nem érkezett vissza kompatibilis szövegmodell.',
  'settings.fetchModelsUnsupported': 'A modellfelderítés nem érhető el ehhez a protokollhoz.',
  'settings.fetchModelsFailed': 'Nem sikerült lekérni a modelleket: {detail}',
  'settings.suggestedModelsHint': 'Ezek a protokollhoz javasolt modellek. A szolgáltatód más modelleket is támogathat.',
  'settings.baseUrl': 'Base URL',
  'settings.baseUrlInvalid': 'Használj nyilvános http:// vagy https:// URL-t.',
  'settings.baseUrlCustomize': 'Testreszabás',
  'settings.baseUrlDefaultHint': 'Alapértelmezett végpont. Általában nem kell módosítani.',
  'settings.azureBaseUrlPlaceholder': 'https://my-resource.openai.azure.com',
  'settings.azureBaseUrlHint': 'Ezt az Azure portálon találod → az erőforrásod → Endpoint.',
  'settings.azureDeploymentModel': 'Deployment név',
  'settings.azureCustomDeploymentName': 'Egyéni üzemelési név',
  'settings.azureDeploymentModelHint': 'Azure OpenAI esetén ez a mező a /openai/deployments/<model> deployment neveként szerepel. Add meg az Azure-ban létrehozott deployment nevét.',
  'settings.azureModelFetchHint': 'Add meg a telepítés nevét az Azure-erőforrásodból. Az Azure-telepítések nem kérhetők le automatikusan.',
  'settings.apiVersion': 'API-verzió',
  'settings.byokImageModel': 'Képgenerálási modell',
  'settings.byokVideoModel': 'Videógenerálási modell',
  'settings.byokVideoI2vHint': 'Kép-videó modell: referenciakép szükséges (különben a projekt legújabb képét használja automatikusan)',
  'settings.byokSpeechModel': 'Beszédmodell',
  'settings.byokSpeechVoice': 'Hang',
  'settings.byokModelDefaultOption': 'Alapértelmezett',
  'settings.maxTokens': 'Max tokenek (opcionális)',
  'settings.maxTokensHint': 'A válasz hosszának felső határa. Minden modellnek van hangolt alapértelmezése (placeholderként látható); hagyd üresen az alkalmazásához, vagy adj meg számot a felülíráshoz.',
  'settings.apiHint': 'A hívások a helyi daemon proxyn keresztül mennek a beállított Base URL-re. A kulcs csak ebben a böngészőben tárolódik, és a szolgáltatói kérésekkel együtt kerül elküldésre.',
  'settings.skipForNow': 'Most kihagyom',
  'settings.getStarted': 'Kezdjük',
  'settings.envConfigure': 'Végrehajtási mód',
  'settings.localCli': 'Helyi CLI',
  'settings.anthropicApi': 'Anthropic API',
  'settings.noAgentSelected': 'nincs kiválasztott ügynök',
  'settings.language': 'Nyelv',
  'settings.languageHint': 'A felület nyelvének váltása. Ebben a böngészőben mentve.',
  'settings.appearance': 'Megjelenés',
  'settings.appearanceHint': 'Válassz világos, sötét, vagy kövesd a rendszer beállítását.',
  'settings.themeSystem': 'Rendszer',
  'settings.themeLight': 'Világos',
  'settings.themeDark': 'Sötét',
  'settings.agentModelHead': 'Modell ehhez:',
  'settings.modelPicker': 'Modell',
  'settings.modelSourceLive': 'Élőben a CLI-ből',
  'settings.modelSourceFallback': 'Beépített lista',
  'settings.reasoningPicker': 'Gondolkodási erőfeszítés',
  'settings.modelPickerHint': 'A CLI-tól kérdezi le, ha az közzéteszi a `models` parancsot. Az „Alapértelmezett" a CLI saját konfigjára bízza a választást; az „Egyedi…" tetszőleges, a CLI által elfogadott modell-id-t enged megadni.',
  'settings.modelPickerLiveHint': 'A modellek frissültek a telepített CLI-ből. Az Alapértelmezett továbbra is a CLI konfigurációját használja.',
  'settings.modelPickerLiveCatalogOnlyHint': 'A modellek frissültek a telepített CLI-ből.',
  'settings.modelPickerFallbackHint': 'A beépített alapértékek láthatók. Kattints az Újraellenőrzésre az élő CLI-modellek lekéréséhez.',
  'settings.cliEnvTitle': 'Speciális: proxy és egyéni útvonalak',
  'settings.cliEnvHint': 'Ezekkel írhatod felül a kiválasztott CLI környezetét: API-kulcsok, proxy base URL-ek, egyéni home-ok vagy nem szabványos bináris útvonalak. Base URL nélkül a CLI a saját alapértelmezett endpointját használja. A titkok a helyi alkalmazás-konfigurációban maradnak, és csak a kiválasztott CLI kapja meg őket.',
  'settings.cliEnvClaudeConfigDir': 'Claude Code konfigurációs könyvtár',
  'settings.cliEnvClaudeBaseUrl': 'Claude proxy Base URL',
  'settings.cliEnvClaudeApiKey': 'Claude CLI API-kulcs',
  'settings.cliEnvCodexHome': 'Codex könyvtár',
  'settings.cliEnvCodexBin': 'Codex futtatható fájl elérési útja',
  'settings.cliEnvCodexBaseUrl': 'Codex/OpenAI proxy Base URL',
  'settings.cliEnvCodexApiKey': 'Codex/OpenAI CLI API-kulcs',
  'settings.modelCustom': 'Egyedi (gépeld be alább)…',
  'settings.modelCustomLabel': 'Egyedi modell-id',
  'settings.modelCustomPlaceholder': 'pl. anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': 'Média-szolgáltatók',
  'settings.mediaProvidersHint': 'API-kulcsok kép-, videó- és hanggeneráláshoz. Helyben tárolva, és a helyi daemonnal szinkronizálva.',
  'settings.mcpServerTitle': 'MCP-szerver',
  'settings.mcpServerHint': 'Tedd elérhetővé az Open Designt MCP-szerverként a kódügynököd számára.',
  'settings.externalMcpTitle': 'Külső MCP',
  'settings.externalMcpHint': 'Adj hozzá MCP-eszközöket külső szolgáltatásokból (Higgsfield, GitHub, …).',
  'settings.mediaProviderApiKey': 'API-kulcs',
  'settings.mediaProviderBaseUrl': 'Bázis URL',
  'settings.mediaProviderConfigured': 'Beállítva',
  'settings.mediaProviderUnset': 'Nincs beállítva',
  'settings.mediaProviderClear': 'Törlés',
  'settings.mediaProviderClearConfirm': 'Törölni szeretnéd a mentett {name} beállításokat? A {name} használatához újra meg kell adnod azokat.',
  'settings.mediaProviderPlaceholder': 'API-kulcs beillesztése',
  'settings.mediaProviderBaseUrlPlaceholder': 'Alapértelmezett bázis URL felülírása',
  'settings.mediaProviderReload': 'Újratöltés a helyi démonból',
  'settings.mediaProviderReloadError': 'Nem sikerült újratölteni a médiaszolgáltatók beállításait a helyi démonból.',
  'settings.mediaProviderReloadSuccess': 'A médiaszolgáltatók beállításai újra lettek töltve a helyi démonból.',
  'settings.mediaProviderLoadError': 'Nem sikerült betölteni a médiaszolgáltatók beállításait a helyi démonból. Egyelőre a böngészőben mentett beállításokat használjuk.',
  'settings.mediaProviderComingSoonHint': 'Ezeket nyomon követjük az ütemtervben; a daemon még nem szállít klienst, így nincs mit konfigurálni.',
  'settings.privacy': 'Adatvédelem',
  'settings.privacyHint': 'Milyen adatokat osztunk meg az Open Design csapatával',
  'settings.privacyConsentKicker': 'Segíts jobbá tenni az Open Design alkalmazást',
  'settings.privacyConsentLead': 'Az Open Design megoszthat használati adatokat a csapatunkkal, hogy segítsen a fejlesztésben. Ez magában foglalja:',
  'settings.privacyConsentFooter': 'Ezeket bármikor módosíthatod a Beállítások → Adatvédelem menüben.',
  'settings.privacyConsentShare': 'Használati adatok megosztása',
  'settings.privacyConsentDecline': 'Ne ossza meg',
  'settings.privacyConsentAccept': 'Értem',
  'settings.privacyConsentBannerFooter': 'Az adatmegosztás alapértelmezetten be van kapcsolva. Bármikor kikapcsolhatod a Beállítások → Adatvédelem menüben.',
  'settings.privacyConsentPolicyLink': 'Adatvédelmi szabályzat elolvasása',
  'settings.privacyMetrics': 'Névtelen metrikák',
  'settings.privacyMetricsHint': 'Futtatások száma, Token-használat, hibaarány, időtartam. Nincsenek promptok, nincsenek projektadatok.',
  'settings.privacyContent': 'Conversation content',
  'settings.privacyContentHint': 'Promptok, asszisztensi válaszok, eszközbemenetek/-kimenetek és a minőség-ellenőrzéshez szükséges teljes kontextusfájlok. A titkokat küldés előtt eltávolítjuk.',
  'settings.privacyInstallationId': 'Névtelen azonosító',
  'settings.privacyOptedOut': 'kikapcsolva',
  'settings.privacyDataDeletion': 'Adataim törlése',
  'settings.privacyDataDeletionHint': 'Lecseréli a névtelen azonosítódat, és leállítja a küldést. A meglévő nyomok a megőrzési szabályzatunk szerint évülnek el.',
  'settings.about': 'Névjegy',
  'settings.aboutHint': 'Verzió- és futtatókörnyezeti adatok',
  'settings.appVersion': 'Verzió',
  'settings.appChannel': 'Csatorna',
  'settings.appRuntime': 'Futtatókörnyezet',
  'settings.appPlatform': 'Platform',
  'settings.appArchitecture': 'Architektúra',
  'settings.runtimePackaged': 'Csomagolt alkalmazás',
  'settings.runtimeDevelopment': 'Fejlesztői',
  'settings.versionUnavailable': 'A verzió adatai nem érhetők el, amíg a daemon offline.',
  'settings.installLatest': 'Legújabb verzió telepítése',
  'settings.alreadyLatest': 'Ön már a legújabb verziót használja',
  'settings.mcpTitle': 'MCP szerver',
  'settings.mcpHint': 'Engedd, hogy a kódoló agentek (Cursor, Claude Code, VS Code…) közvetlenül olvassák az Open Design projektjeidet.',
  'settings.mcpDaemonError': 'Nem sikerült elérni a helyi daemont a telepítési útvonalak feloldásához ({error}). Győződj meg róla, hogy az Open Design fut, majd nyisd meg újra ezt a panelt.',
  'settings.mcpBuildDaemon': 'Először építsd fel a daemont.',
  'settings.mcpNodeMissing': 'A Node bináris fájl hiányzik.',
  'settings.mcpBuildHint': 'Az apps/daemon/dist/cli.js hiányzik. Futtasd a `pnpm --filter @open-design/daemon build` parancsot, majd frissíts.',
  'settings.mcpMethodCli': 'CLI parancs',
  'settings.mcpInstructionCli': 'Futtasd ezt a terminálodban.',
  'settings.mcpMethodToml': 'TOML konfiguráció',
  'settings.mcpInstructionCodex': 'Fűzd hozzá ezt a táblát a következőhöz: {path}. Ugyanazt a konfigurációt használja a Codex CLI és a Codex IDE-kiegészítő.',
  'settings.mcpMethodOneClick': 'Egykattintásos telepítés',
  'settings.mcpInstructionCursor': 'Kattints az „Install in Cursor” gombra a jóváhagyási párbeszédpanellel történő telepítéshez, vagy egyesítsd ezt a JSON-t a következővel: {path}.',
  'settings.mcpDeeplinkInstallCursor': 'Telepítés a Cursorba',
  'settings.mcpMethodJson': 'JSON konfiguráció',
  'settings.mcpInstructionCopilot': 'Nyisd meg a Command Palette-et ({shortcut}), futtasd az „MCP: Open User Configuration” parancsot, és egyesítsd ezt a JSON-t. A Copilot Chatnek Agent módban kell lennie, hogy az eszközök megjelenjenek.',
  'settings.mcpInstructionAntigravity': 'Az Antigravityben: Agent panel "..." menü → MCP Servers → Manage MCP Servers → View raw config. Egyesítsd ezt a JSON-t.',
  'settings.mcpInstructionZed': 'Nyisd meg a Zed beállításait ({shortcut}), és egyesítsd ezt a legfelső szintű objektummal. A Zed a „context_servers” kulcsot használja, nem a „mcpServers” kulcsot.',
  'settings.mcpInstructionWindsurf': 'Nyisd meg ezt: {path} (vagy használd az MCPs ikont a Cascade-ben → Configure), majd egyesítsd:',
  'settings.mcpCopyAria': 'MCP konfigurációs részlet másolása',
  'settings.mcpResolvingFailed': '# az útvonalak feloldása sikertelen, lásd a fenti hibát',
  'settings.mcpLoadingPaths': '# telepítési útvonalak betöltése a helyi daemonból…',
  'settings.mcpCopied': 'Másolva',
  'settings.mcpCopy': 'Másolás',
  'settings.mcpCursorApproval': 'A Cursor megjelenít egy jóváhagyási párbeszédpanelt a konfiguráció írása előtt.',
  'settings.mcpCodexOneClickInstall': 'Telepítés a Codexbe',
  'settings.mcpCodexOneClickUninstall': 'Eltávolítás a Codexből',
  'settings.mcpCodexOneClickUnavailable': 'A Codex CLI nem található a PATH-on — telepítsd a Codexet, vagy illeszd be a kódrészletet manuálisan.',
  'settings.mcpCodexInstallSuccess': 'Telepítve. Indítsd újra a Codexet az új szerver betöltéséhez.',
  'settings.mcpCodexUninstallSuccess': 'Eltávolítva a Codexből.',
  'settings.mcpCodexBusy': 'Dolgozom…',
  'settings.mcpCodexInstallError': 'A művelet sikertelen: {error}',
  'settings.mcpRestartNote': 'Indítsd újra a klienst az új szerver betöltéséhez.',
  'settings.mcpRestartDetail': 'A legtöbb szerkesztő csak indításkor tölti be az MCP szervereket. A Cursor / VS Code / Antigravity / Windsurf esetén a teljes újraindítás helyett futtathatod a `Developer: Reload Window` parancsot a parancspalettáról. A Zed és a Claude Code esetén ki kell lépni és újra meg kell nyitni.',
  'settings.mcpCapabilitiesTitle': 'Mit tehet az Agented',
  'settings.mcpCapabilityRead': 'Bármilyen fájl olvasása vagy keresése egy projektben (HTML, JSX, CSS, JSON, SVG, Markdown).',
  'settings.mcpCapabilityPull': 'Egy designcsomag lekérése egyetlen hívással: a belépési fájl, valamint minden CSS-változó, komponens és betűtípus, amelyre hivatkozik.',
  'settings.mcpCapabilityDefault': 'Alapértelmezésként az Open Designban éppen megnyitott projektet és fájlt használja, így mondhatod, hogy „építsd ezt meg az alkalmazásomban” anélkül, hogy újra meg kellene adnod, melyik designról van szó.',
  'settings.mcpRunningNote': 'Az Open Designnak futnia kell az MCP eszközhívások sikeréhez. Ha azelőtt indítottad el a kódoló Agentet, hogy megnyitottad volna az Open Designt, indítsd újra az Agentet, hogy elérje az élő daemont.',
  'entry.tabDesigns': 'Tervek',
  'entry.tabTemplates': 'Sablonok',
  'entry.tabDesignSystems': 'Designrendszerek',
  'entry.tabConnectors': 'Kapcsolók',
  'entry.openSettingsTitle': 'Beállítások',
  'entry.openSettingsAria': 'Beállítások megnyitása',
  'entry.discordLabel': 'Csatlakozás a Discordhoz',
  'entry.discordAria': 'Csatlakozás az Open Design Discordhoz',
  'entry.discordAriaWithOnline': 'Csatlakozás az Open Design Discordhoz - {online}',
  'entry.discordOnlineLabel': '{count} online',
  'entry.followXLabel': 'Kövesd a @OpenDesignHQ fiókot az X-en',
  'entry.followThreadsLabel': 'Follow Open Design on Threads',
  'entry.youtubeLabel': 'Open Design on YouTube',
  'entry.resizeAria': 'Oldalsáv átméretezése',
  'entry.loadingWorkspace': 'Munkaterület betöltése…',
  'entry.useEverywhereTitle': 'Használat bárhol',
  'entry.useEverywhereAria': '„Használat bárhol” útmutató megnyitása (CLI, MCP, HTTP, Skills)',
  'entry.navExpand': 'Oldalsáv kibontása',
  'entry.navCollapse': 'Oldalsáv összecsukása',
  'entry.navNewProject': 'Új projekt',
  'entry.navHome': 'Kezdőlap',
  'entry.navProjects': 'Projektek',
  'entry.navTasks': 'Automatizálások',
  'entry.navPlugins': 'Pluginok',
  'entry.navDesignSystems': 'Tervezőrendszerek',
  'entry.navBrands': 'Márkacsomag',
  'entry.navIntegrations': 'Integrációk',
  'workspaceTabs.project': 'Projekt',
  'workspaceTabs.pluginDetails': 'Plugin részletei',
  'workspaceTabs.marketplace': 'Marketplace',
  'homeHero.title': 'Mit tervezel ma?',
  'homeHero.startWithTemplate': 'Kezdés sablonnal…',
  'homeHero.startBlankProject': '…vagy kezdj egy üres projektet',
  'homeHero.templatePicker.label': 'Sablon',
  'homeHero.templatePicker.searchPlaceholder': 'Sablonok keresése',
  'homeHero.templatePicker.projectTypes': 'Projekttípusok',
  'homeHero.templatesScrollHint': 'Görgess felfelé további sablonokért',
  'homeHero.templatesCollapse': 'Sablonok összecsukása',
  'homeHero.subtitlePrefix': 'A nyílt forráskódú Claude Design alternatíva.',
  'homeHero.placeholder': 'Írd le, mit szeretnél generálni…',
  'homeHero.placeholderActive': 'Szerkeszd a példalekérdezést, vagy írj sajátot…',
  'homeHero.carousel.hint': 'Csatolj egy fájlt, kapcsold össze a dizájnrendszered, vagy írd le, mit szeretnél készíteni',
  'homeHero.carousel.onePageBrief': 'Egyoldalas projektösszefoglaló írása',
  'homeHero.carousel.notesToDeck': 'Jegyzeteim átalakítása prezentációvá',
  'homeHero.carousel.signupFlow': 'Regisztrációs folyamat megtervezése',
  'homeHero.carousel.improveBrief': 'Meglévő projektösszefoglaló javítása',
  'homeHero.carousel.loadingAnimation': 'Betöltési animáció készítése',
  'homeHero.carousel.teamUpdateSlides': 'Diák tervezése csapatfrissítéshez',
  'homeHero.carousel.ordersDashboard': 'Rendeléskövető irányítópult prototípusa',
  'homeHero.carousel.productDetail': 'Termékadatlap elrendezése',
  'homeHero.carousel.caseStudy': 'Esettanulmány vázlata',
  'homeHero.carousel.landingIntro': 'Rövid bevezető tervezése egy landing oldalhoz',
  'homeHero.carousel.pitchDeck': 'Pitch deck készítése új termékhez',
  'homeHero.carousel.appIdea': 'Egy alkalmazásötlet leírása',
  'homeHero.carousel.landingLayout': 'Landing oldal elrendezésének felvázolása',
  'homeHero.skills': 'Skillek',
  'homeHero.addMenu': 'Kontextus hozzáadása',
  'homeHero.addPlugin': 'Bővítmény hozzáadása',
  'homeHero.addConnectors': 'Csatlakozók hozzáadása',
  'homeHero.addMcp': 'MCP-kiszolgáló hozzáadása',
  'homeHero.noPlugins': 'Nincs telepített bővítmény',
  'homeHero.noMcp': 'Nincs MCP-kiszolgáló',
  'homeHero.noConnectors': 'Nincs csatlakoztatott csatlakozó',
  'homeHero.applying': 'Alkalmazás…',
  'homeHero.pluginTitle': 'Plugin: {title}',
  'homeHero.pluginPrefix': 'Plugin: {title}',
  'homeHero.skillPrefix': 'Skill: {title}',
  'homeHero.removePlugin': 'Plugin eltávolítása',
  'homeHero.removePluginAria': '{title} plugin eltávolítása',
  'homeHero.clearActivePlugin': 'Aktív plugin törlése',
  'homeHero.clearActiveSkill': 'Aktív skill törlése',
  'homeHero.contextItemsResolved': '{n} kontextuselem feloldva',
  'homeHero.removeFile': 'Fájl eltávolítása',
  'homeHero.contextSearchResults': 'Kontextuskeresés eredményei',
  'homeHero.contextSurfaces': 'Kontextusfelületek',
  'homeHero.loadingContext': 'Kontextus betöltése…',
  'homeHero.noResults': 'Nincs találat erre: "{query}".',
  'homeHero.searchPrompt': 'Fájlok, pluginok, skillek, MCP-szerverek és összekötők keresése.',
  'homeHero.parameters': '{n} paraméter',
  'homeHero.details': 'Részletek',
  'homeHero.toRun': 'a futtatáshoz',
  'homeHero.forNewLine': 'új sorhoz',
  'homeHero.run': 'Futtatás',
  'homeHero.typeSomethingToRun': 'Írj be valamit a futtatáshoz',
  'homeHero.promptExamples': 'Példák',
  'homeHero.footer.designSystem': 'Stílus',
  'homeHero.footer.autoDesignSystem': 'Automatikus',
  'homeHero.footer.autoDesignSystemSummary': 'Automatikusan kiválasztja az aktuális prompthoz illő designrendszert és vizuális stílust.',
  'homeHero.footer.ratio': 'Arány',
  'homeHero.footer.duration': 'Időtartam',
  'homeHero.footer.resolution': 'Felbontás',
  'homeHero.footer.speakerNotes': 'Jegyzetek',
  'homeHero.footer.noSpeakerNotes': 'Nincs jegyzet',
  'homeHero.footer.availableCount': '{n} elérhető',
  'homeHero.footer.noMatches': 'Nincs találat',
  'homeHero.moreShortcuts': 'Továbbiak',
  'homeHero.railAria': 'Válassz projektkategóriát vagy kezdő gyorsindítót',
  'homeHero.subTypeAria': 'Válassz altípust',
  'homeHero.confirmReplaceTitle': 'Lecseréled a jelenlegi promptot?',
  'homeHero.confirmReplaceBody': 'A(z) {title} használata lecseréli a beviteli mezőben jelenleg lévő szöveget.',
  'homeHero.confirmReplace': 'Csere',
  'homeHero.chip.prototype': 'Prototípus',
  'homeHero.chip.liveArtifact': 'Élő artifact',
  'homeHero.chip.deck': 'Diasor',
  'homeHero.chip.image': 'Kép',
  'homeHero.chip.video': 'Videó',
  'homeHero.chip.hyperframes': 'HyperFrames',
  'homeHero.chip.audio': 'Hang',
  'homeHero.chip.createBrandKit': 'Márkacsomag létrehozása',
  'homeHero.chip.createPlugin': 'Plugin létrehozása',
  'homeHero.chip.figma': 'Figmából',
  'homeHero.chip.folder': 'Mappából',
  'homeHero.chip.template': 'Sablonból',
  'homeHero.chip.liveArtifactHint': 'Készíts interaktív HTML/CSS/JS artifactot, amelyet élőben előnézhetsz.',
  'homeHero.chip.hyperframesHint': 'Hozz létre HTML-alapú animációt: feliratok, hangra reagáló vizuálok, jelenetátmenetek.',
  'homeHero.chip.createBrandKitHint': 'Készíts márkacsomagot egy webhelyből, majd alkalmazd bármelyik csevegésben.',
  'homeHero.chip.createPluginHint': 'Hozz létre újrafelhasználható Open Design plugint, és add hozzá a Saját pluginjaimhoz.',
  'homeHero.chip.figmaHint': 'Migrálj egy Figma frame-et az aktív tervezőrendszerbe.',
  'homeHero.chip.folderHint': 'Importálj egy meglévő helyi mappát, és folytasd a szerkesztést.',
  'homeHero.chip.templateHint': 'Indulj egy beépített sablonból.',
  'homeHero.chip.wireframe': 'Wireframe',
  'homeHero.chip.mobile': 'Mobile app',
  'homeHero.chip.document': 'Document',
  'homeHero.chip.prototypeDesc': 'Interactive app mockups',
  'homeHero.chip.wireframeDesc': 'Lo-fi screens & flows',
  'homeHero.chip.mobileDesc': 'iOS & Android screens',
  'homeHero.chip.deckDesc': 'Presentations & pitch decks',
  'homeHero.chip.documentDesc': 'Resumes, reports & PDFs',
  'homeHero.chip.imageDesc': 'Posters, graphics & art',
  'homeHero.chip.videoDesc': 'Clips, reels & promos',
  'homeHero.chip.audioDesc': 'Voiceovers, music & SFX',
  'homeHero.chip.hyperframesDesc': 'Motion graphics & loops',
  'homeHero.chip.liveArtifactDesc': 'Data-backed live dashboards',
  'homeHero.chip.createBrandKitDesc': 'Extract a brand design system',
  'homeHero.chip.prototypeNext': 'Open a chat that builds a high-fidelity, clickable web prototype you refine turn by turn.',
  'homeHero.chip.wireframeNext': 'Open a chat that sketches lo-fi screens and flows to validate structure first.',
  'homeHero.chip.mobileNext': 'Open a chat that lays out mobile screens for iOS and Android.',
  'homeHero.chip.deckNext': 'Open a chat that builds a slide deck you can present and export.',
  'homeHero.chip.documentNext': 'Open a chat that drafts a polished document — resume, report, or PDF.',
  'homeHero.chip.imageNext': 'Open a chat that generates on-brand images you can iterate on.',
  'homeHero.chip.videoNext': 'Open a chat that produces a short video you can refine.',
  'homeHero.chip.audioNext': 'Open a chat that creates voiceover, music, or sound effects.',
  'homeWorkingDir.trigger': 'Select working directory',
  'homeWorkingDir.pick': 'Choose folder',
  'homeWorkingDir.replace': 'Change working directory',
  'homeWorkingDir.recent': 'Recent folders',
  'homeWorkingDir.recentEmpty': 'No recent folders',
  'homeWorkingDir.clear': 'Remove working directory',
  'homeWorkingDir.hint': 'Let the agent read this local folder (not imported into Design Files)',
  'homeWorkingDir.missing': 'This working folder no longer exists — pick another',
  'homeWorkingDir.applyFailed': 'Couldn\'t set the working directory — the folder may no longer exist',
  'workingDirPicker.title': 'Mappa',
  'workingDirPicker.homeTitle': 'Helyi tárhelyen mentve – kattints mappa választásához',
  'workingDirPicker.processing': 'Feldolgozás…',
  'workingDirPicker.select': 'Helyi tárhely',
  'workingDirPicker.clearAria': 'Munkakönyvtár törlése',
  'workingDirPicker.replaceFailed': 'A munkakönyvtár cseréje nem sikerült',
  'workingDirPicker.unavailable': 'A mappaválasztó nem érhető el ebben a buildben. Mappa kiválasztásához futtasd az asztali alkalmazást.',
  'workingDirPicker.openUnavailable': 'Nyisd meg ezt a projektet az asztali alkalmazásban a mappa megjelenítéséhez.',
  'workingDirPicker.openFailed': 'A mappa nem jeleníthető meg',
  'workingDirPicker.showInFileManager': 'Megjelenítés a fájlkezelőben',
  'workingDirPicker.replace': 'Mappa választása…',
  'workingDirPicker.recent': 'Legutóbbi könyvtárak',
  'workingDirPicker.defaultLabel': 'Helyi tárhely',
  'handoff.toTarget': 'Átadás ide: {target}',
  'handoff.openInTarget': 'Megnyitás itt: {target}',
  'handoff.openAction': 'Megnyitás',
  'handoff.menuTitle': 'Melyik szerkesztőben nyissuk meg?',
  'handoff.action': 'Átadás',
  'handoff.fallbackTitle': 'Nem található szerkesztő a $PATH útvonalon – megnyitás itt: {target}',
  'handoff.chooseTargetAria': 'Válassz átadási célt',
  'handoff.optionsAria': 'Átadási beállítások',
  'handoff.editorSection': 'Megnyitás szerkesztővel',
  'handoff.cliSection': 'Másolás CLI-hez',
  'handoff.clickOpen': 'Kattints a megnyitáshoz',
  'handoff.framework': 'Kódkeretrendszer',
  'handoff.framework.react': 'React',
  'handoff.framework.vue': 'Vue.js',
  'handoff.framework.svelte': 'Svelte',
  'handoff.framework.solid': 'SolidJS',
  'handoff.framework.next': 'Next.js',
  'handoff.framework.vanilla': 'JS',
  'handoff.frameworkPrompt.react': 'React',
  'handoff.frameworkPrompt.vue': 'Vue.js',
  'handoff.frameworkPrompt.svelte': 'Svelte',
  'handoff.frameworkPrompt.solid': 'SolidJS',
  'handoff.frameworkPrompt.next': 'Next.js / React',
  'handoff.frameworkPrompt.vanilla': 'vanilla JavaScript, HTML és CSS',
  'handoff.amrWebsite': 'AMR webhely megnyitása',
  'handoff.copyPrompt': 'Prompt másolása',
  'handoff.copyPromptForTarget': 'Prompt másolása ehhez: {target}',
  'handoff.copied': 'Másolva',
  'handoff.projectPathUnavailable': 'A projekt útvonala még betöltődik. Próbáld újra egy pillanat múlva.',
  'handoff.copyFailed': 'A vágólapra írás le lett tiltva. Próbáld újra egy pillanat múlva.',
  'handoff.promptIntro': 'Folytatás ebből a helyi Open Design projektmappából:',
  'handoff.promptTarget': 'Cél',
  'handoff.promptCli': 'CLI',
  'handoff.promptStepsLead': 'Te veszed át a munkát itt: {cli}. Kérlek:',
  'handoff.promptReadFiles': 'Először lépj be ebbe a könyvtárba, vagy olvasd be. Részesítsd előnyben a DESIGN.md, README, meglévő HTML/CSS/JS, eszközök és a package.json fájlokat, ha vannak.',
  'handoff.promptKeepDesign': 'Őrizd meg a jelenlegi vizuális megjelenést, elrendezést, interakciókat és eszközöket. Ne állj meg egy tervnél.',
  'handoff.promptProduceCode': 'Generálj vagy módosíts valódi, futtatható {framework} kódot. Ha a projektnek már van egyértelműbb technológiai készlete, jelezd az ütközést, és tartsd futtathatóan az eredményt.',
  'handoff.promptVerify': 'Végezetül add meg a futtatáshoz, az előnézethez és az ellenőrzéshez szükséges parancsokat.',
  'handoff.promptCommandHint': 'A projektkönyvtárból való indításhoz használd ezt:',
  'handoff.promptProject': 'Projekt',
  'handoff.promptProjectId': 'Projektazonosító',
  'handoff.notInstalled': 'Nincs telepítve',
  'handoff.notDetectedTitle': '{target} – nem észlelhető a $PATH útvonalon',
  'designSystemPicker.select': 'Válassz tervezési rendszert',
  'designSystemPicker.loading': 'Design rendszerek betöltése…',
  'designSystemPicker.searchPlaceholder': 'Tervezési rendszerek keresése (cím / kategória / összegzés)',
  'designSystemPicker.searchCompactPlaceholder': 'Tervezési rendszerek keresése',
  'designSystemPicker.noneTitle': 'Nincs tervezési rendszer',
  'designSystemPicker.noneSummary': 'Hagyd, hogy a modell szabadon válasszon',
  'designSystemPicker.empty': 'Nincs egyező tervezési rendszer',
  'designSystemPicker.openPreview': 'Előnézet megnyitása',
  'designSystemPicker.loadingPreview': 'Előnézet betöltése…',
  'designSystemPicker.noPreview': 'Nincs előnézeti oldal. Nyisd meg a Tervezési rendszereket a teljes előnézet megtekintéséhez.',
  'designSystemPicker.previewHint': 'Vigyél az egeret egy tervezési rendszer fölé az előnézethez',
  'designSystemPicker.fullscreenAria': '{title} teljes képernyős előnézet',
  'designSystemPicker.closeFullscreen': 'Teljes képernyős előnézet bezárása',
  'designSystemPicker.closeEsc': 'Bezárás (Esc)',
  'designSystemPicker.previewFrameTitle': '{title} előnézet',
  'designSystemPicker.fullscreenFrameTitle': '{title} teljes képernyős előnézet',
  'recentProjects.title': 'Legutóbbi projektek',
  'recentProjects.viewAll': 'Összes megtekintése',
  'recentProjects.empty': 'Még nincsenek projektek — írj egy promptot az elsőhöz.',
  'pluginsHome.title': 'Közösség',
  'pluginsHome.subtitle': 'Ehhez a futtatókörnyezethez csomagolt, használatra kész Open Design munkafolyamatok. Válasszon egyet egy kezdő prompt betöltéséhez, vagy böngésszen a registry-ben továbbiakért.',
  'pluginsHome.browseRegistry': 'Registry böngészése',
  'pluginsHome.count': '{filtered} / {total}',
  'pluginsHome.loadingCatalog': 'Katalógus betöltése…',
  'pluginsHome.emptyCatalog': 'A katalógus üres. A beépített pluginok az Open Design részeként érkeznek, és automatikusan meg kell jelenniük itt — próbáld újraindítani a daemont, ha ez továbbra is fennáll.',
  'pluginsHome.emptyFiltered': 'Egyetlen plugin sem felel meg a jelenlegi szűrőknek.',
  'pluginsHome.clearFilters': 'Szűrők törlése',
  'pluginsHome.modeAria': 'Plugin mód',
  'pluginsHome.featured': 'Mentve',
  'pluginsHome.totalInCatalog': '{n} a katalógusban',
  'pluginsHome.categoryFilterAria': 'Kategóriaszűrő',
  'pluginsHome.subcategoryFilterAria': '{label} alkategória-szűrő',
  'pluginsHome.allCategory': 'Összes: {label}',
  'pluginsHome.searchPlaceholder': 'Pluginok keresése…',
  'pluginsHome.searchAria': 'Pluginek keresése',
  'pluginsHome.clearSearch': 'Keresés törlése',
  'pluginsHome.facet.import': 'Importálás',
  'pluginsHome.facet.create': 'Létrehozás',
  'pluginsHome.facet.export': 'Exportálás',
  'pluginsHome.facet.share': 'Megosztás',
  'pluginsHome.facet.deploy': 'Üzembe helyezés',
  'pluginsHome.facet.refine': 'Finomítás',
  'pluginsHome.facet.extend': 'Bővítés',
  'pluginsHome.facet.figma': 'Figma',
  'pluginsHome.facet.github': 'GitHub',
  'pluginsHome.facet.codeFolder': 'Kód / mappa',
  'pluginsHome.facet.url': 'URL',
  'pluginsHome.facet.screenshot': 'Képernyőkép',
  'pluginsHome.facet.pdf': 'PDF',
  'pluginsHome.facet.pptx': 'PPTX',
  'pluginsHome.facet.framer': 'Framer',
  'pluginsHome.facet.webflow': 'Webflow',
  'pluginsHome.facet.slides': 'Diák',
  'pluginsHome.facet.publicLink': 'Nyilvános link',
  'pluginsHome.facet.githubPr': 'GitHub PR',
  'pluginsHome.facet.githubGist': 'GitHub Gist',
  'pluginsHome.subfacet.business-dashboards': 'Dashboardok',
  'pluginsHome.subfacet.app-prototypes': 'Appok',
  'pluginsHome.subfacet.landing-marketing': 'Landing / marketing',
  'pluginsHome.subfacet.developer-tools': 'Fejlesztői eszközök',
  'pluginsHome.subfacet.docs-reports': 'Dokumentumok / riportok',
  'pluginsHome.subfacet.brand-design': 'Márka / design',
  'pluginsHome.subfacet.pitch-business': 'Pitch / üzlet',
  'pluginsHome.subfacet.course-training': 'Kurzus / képzés',
  'pluginsHome.subfacet.reports-briefings': 'Riportok / összefoglalók',
  'pluginsHome.subfacet.product-sales': 'Termék / értékesítés',
  'pluginsHome.subfacet.engineering-talks': 'Tech előadások',
  'pluginsHome.subfacet.creative-decks': 'Kreatív prezentációk',
  'pluginsHome.subfacet.ui-product-mockups': 'UI / mockupok',
  'pluginsHome.subfacet.brand-visuals': 'Márka / logó',
  'pluginsHome.subfacet.storyboards-motion-refs': 'Storyboardok',
  'pluginsHome.subfacet.social-content': 'Közösségi / tartalom',
  'pluginsHome.subfacet.avatar-portrait': 'Avatar / portré',
  'pluginsHome.subfacet.illustration-style': 'Illusztráció / stílus',
  'pluginsHome.subfacet.motion-effects': 'Motion / effektek',
  'pluginsHome.subfacet.social-short-form': 'Közösségi / rövid videók',
  'pluginsHome.subfacet.marketing-product': 'Marketing / termék',
  'pluginsHome.subfacet.data-explainers': 'Adatok / magyarázatok',
  'pluginsHome.subfacet.cinematic-story': 'Filmszerű / történet',
  'pluginsView.lede': 'Böngéssze a telepített munkafolyamatokat, fedezzen fel registry-bejegyzéseket, kezelje a forrásokat, és készítse elő a plugineket a csapaton belüli terjesztéshez.',
  'pluginsView.importPlugin': 'Plugin importálása',
  'pluginsView.agentContext': 'Agent kontextus',
  'pluginsView.summaryAria': 'Plugin összefoglaló',
  'pluginsView.areasAria': 'Plugin területek',
  'pluginsView.loading': 'Pluginok betöltése…',
  'pluginsView.tab.installed': 'Telepítve',
  'pluginsView.tab.available': 'Elérhető',
  'pluginsView.tab.sources': 'Források',
  'pluginsView.tab.team': 'Csapat',
  'pluginsView.tabHint.installed': 'Az Ön pluginjei',
  'pluginsView.tabHint.available': 'Forrásokból',
  'pluginsView.tabHint.sources': 'Katalógusok',
  'pluginsView.tabHint.team': 'Vállalati',
  'pluginsView.installedTitle': 'Telepített pluginek',
  'pluginsView.installedSubtitle': 'Marketplace-forrásokból importált vagy telepített pluginek.',
  'pluginsView.installedEmpty': 'Még nincsenek telepített felhasználói pluginek. Használja a Létrehozás / Importálás lehetőséget, vagy telepítsen egy Elérhető bejegyzést.',
  'pluginsView.availableTitle': 'Forrásokból elérhető',
  'pluginsView.availableSubtitle': 'A konfigurált marketplace-ekből felfedezett katalógusbejegyzések.',
  'pluginsView.availableFiltersAria': 'Elérhető plugin szűrők',
  'pluginsView.searchAvailableAria': 'Elérhető pluginek keresése',
  'pluginsView.searchAvailablePlaceholder': 'Elérhető pluginek keresése',
  'pluginsView.clearAvailableSearch': 'Elérhető plugin keresés törlése',
  'pluginsView.source': 'Forrás',
  'pluginsView.availableEmptyInstalled': 'Még nincsenek elérhető bejegyzések. A telepített katalógusbejegyzések eltűnnek az Elérhető listából; távolíts el egyet, hogy újra elérhetővé váljon.',
  'pluginsView.availableEmptyFiltered': 'Egyetlen elérhető bejegyzés sem felel meg a szűrőknek.',
  'pluginsView.availableEmptyNoSources': 'Még nincsenek elérhető bejegyzések. Adj hozzá egy forrást a Források lapon.',
  'pluginsView.installing': 'Telepítés…',
  'pluginsView.install': 'Telepítés',
  'pluginsView.sourcesTitle': 'Registry-források',
  'pluginsView.sourcesSubtitle': 'Marketplace-katalógusok, amelyek feltöltik az Elérhető plugin-bejegyzéseket.',
  'pluginsView.sourceUrl': 'Forrás URL',
  'pluginsView.defaultTrust': 'Alapértelmezett megbízhatóság',
  'pluginsView.trust.restricted': 'Korlátozott',
  'pluginsView.trust.trusted': 'Megbízható',
  'pluginsView.trust.official': 'Hivatalos',
  'pluginsView.adding': 'Hozzáadás…',
  'pluginsView.addSource': 'Forrás hozzáadása',
  'pluginsView.sourcesEmpty': 'Még nincsenek registry-források konfigurálva.',
  'pluginsView.pluginsCount': '{n} plugin',
  'pluginsView.catalogVersion': 'katalógus v{version}',
  'pluginsView.trustFor': 'Megbízhatóság: {name}',
  'pluginsView.refreshing': 'Frissítés…',
  'pluginsView.removing': 'Eltávolítás…',
  'pluginsView.teamTitle': 'Privát csapat-marketplace-ek',
  'pluginsView.teamBody': 'Ez a terület a vállalati és csapatkatalógusok, a privát megbízhatósági szabályok és a megosztott plugin-életciklus vezérlők számára van fenntartva.',
  'pluginCard.details': 'Részletek',
  'pluginCard.use': 'Használat',
  'pluginCard.useWithQuery': 'Használat lekérdezéssel',
  'pluginCard.applying': 'Alkalmazás…',
  'pluginCard.publish': 'Közzététel',
  'pluginCard.contribute': 'Hozzájárulás',
  'pluginCard.starting': 'Indítás…',
  'pluginCard.detailsAria': '{title} részleteinek megtekintése',
  'pluginCard.chooseUseAria': 'Válaszd ki, hogyan használod ezt: {title}',
  'pluginCard.useOptionsAria': 'Használati lehetőségek ehhez: {title}',
  'pluginCard.shareAria': '{title} megosztása',
  'pluginCard.publishAria': '{title} közzététele GitHub-tárolóként',
  'pluginCard.publishTitle': 'Plugin közzététele GitHub-tárolóként',
  'pluginCard.contributeAria': '{title} hozzájárulása az Open Designhoz',
  'pluginCard.contributeTitle': 'Plugin hozzájárulása az Open Designhoz pull requesttel',
  'skillPluginCandidate.createForMe': 'Plugin/sablon létrehozása',
  'skillPluginCandidate.contributeToMain': 'Hozzájárulás az open-designhoz',
  'skillPluginCandidate.repoDescription': 'Úgy tűnik, ez a tároló pluginként működhetne.',
  'integrations.kicker': 'Integráció',
  'integrations.lede': 'Csatlakoztass külső rendszereket, hozd be az MCP-eszközöket az agent-folyamatodba, és használd az Open Designt más IDE-kből, szkriptekből és automatizációkból.',
  'integrations.agentReady': 'Agentre kész',
  'integrations.areasAria': 'Integrációs területek',
  'integrations.tabLabel.mcp': 'MCP',
  'integrations.tabLabel.skills': 'Skillek',
  'integrations.tabHint.mcp': 'Külső eszközök',
  'integrations.tabHint.connectors': 'Fiókok és API-k',
  'integrations.tabHint.useEverywhere': 'CLI, HTTP, MCP',
  'integrations.skillsTitle': 'Skill-integrációk',
  'integrations.skillsBody': 'A skill-szintű integrációkezelés egy másik ágról kerül át. Ez a lap azért van fenntartva, hogy az MCP, a Connectorok és a jövőbeli Skill-beállítások ugyanazon az Integráció útvonalon legyenek.',
  'mcpClient.title': 'Külső MCP-szerverek',
  'mcpClient.subtitle': 'Külső felek eszközei a kódoló agentedhez.',
  'mcpClient.addServer': 'Szerver hozzáadása',
  'mcpClient.emptyTitle': 'Nincs MCP-szerver konfigurálva.',
  'mcpClient.emptyBody': 'Kattints a „Szerver hozzáadása” gombra a kezdéshez — válassz egy sablont (Higgsfield OpenClaw, Pollinations, Allyson, Imagician, EdgeOne Pages, GitHub, Filesystem…), vagy állíts be egyéni stdio / HTTP szervert.',
  'mcpClient.saveChanges': 'Módosítások mentése',
  'mcpClient.storedAt': 'Tárolva itt:',
  'mcpClient.daemonError': 'Nem sikerült elérni a helyi daemont. Győződj meg róla, hogy az Open Design fut, majd nyisd meg újra ezt a panelt.',
  'mcpClient.saveFailed': 'A mentés sikertelen. Ellenőrizd, hogy a daemon fut-e, majd próbáld újra.',
  'useEverywhere.modalAria': 'Használd az Open Designt mindenhol',
  'useEverywhere.modalTitle': 'Használd az Open Designt mindenhol',
  'useEverywhere.modalSubtitle': 'Illeszd be az Open Designt bármely IDE-be, agentbe vagy szkriptbe — CLI, HTTP, MCP és Skills. Használd a „Útmutató másolása agenthez” lehetőséget, és illeszd be a Claude Code, Codex, Cursor, openclaw vagy hermes felületre a teljes beállításhoz.',
  'useEverywhere.closeAria': '„Használat mindenhol” bezárása',
  'useEverywhere.closeTitle': 'Bezárás (Esc)',
  'useEverywhere.tabsAria': 'Integrációs felületek',
  'useEverywhere.footStrong': 'Átadás egy kattintással.',
  'useEverywhere.footBody': 'Strukturált markdown útmutatót másol, amelyre az agented azonnal cselekvéssel reagálhat — telepítés, ellenőrzés és használat.',
  'useEverywhere.configureMcp': 'MCP-szerver konfigurálása',
  'useEverywhere.copyGuide': 'Útmutató másolása egy agentnek',
  'useEverywhere.copy': 'Másolás',
  'useEverywhere.copied': 'Másolva',
  'useEverywhere.copyFailed': 'A másolás sikertelen',
  'useEverywhere.copySnippetAria': 'Kódrészlet másolása: {label}',
  'useEverywhere.section.overview.tab': 'Áttekintés',
  'useEverywhere.section.overview.heading': 'Az Open Design ott működik, ahol az agented dolgozik',
  'useEverywhere.section.overview.intro': 'Az Open Design több mint egy ablak — egy helyi, privilegizált daemon (`od`) és egy Skills + Design-Systems + Atoms registry. Amint fut a gépeden, bármely kód-agent (Claude Code, Codex, Cursor, OpenCode/openclaw, Hermes, a saját szkripted) vezérelhet generálásokat, vizsgálhat projekteket, és állíthat elő design artefaktumokat négy felcserélhető felületen keresztül.',
  'useEverywhere.section.overview.bullet1': 'CLI — `od <command>` headless szkriptekhez, CI-hez és shell-automatizáláshoz.',
  'useEverywhere.section.overview.bullet2': 'MCP szerver — az Open Designt Model Context Protocol szerverként köti be, így bármely MCP-képes agent listázhatja a skilleket, futtathat szcenáriókat és olvashat artefaktumokat.',
  'useEverywhere.section.overview.bullet3': 'HTTP API — `http://127.0.0.1:7456/api/*` REST + SSE végpontok; ugyanaz a felület, amelyet a webes felhasználói felület használ.',
  'useEverywhere.section.overview.bullet4': 'Skills — beilleszthető `SKILL.md` csomagok (Claude-kompatibilis), amelyeket bármely, a PATH-odon már meglévő agent meghívhat egyáltalán Open Design nélkül.',
  'useEverywhere.section.overview.bullet5': 'Standard artefaktumok — valódi HTML projektek létrehozása Skillsből, beépített alapértelmezett pluginokból és közösségi plugin példákból, mielőtt a daemon elindul.',
  'useEverywhere.section.overview.snippet1': 'Indítsd el a daemont (és a webes felületet) helyben',
  'useEverywhere.section.overview.snippet2': 'Erősítsd meg, hogy elérhető',
  'useEverywhere.section.overview.snippet3': 'Szabványos artefaktumok beolvasása indítás előtt',
  'useEverywhere.section.overview.footer': 'A daemon alapértelmezetten a `./.od/` mappába (projektszintű) ír. Állítsd be az `OD_DATA_DIR=~/.open-design` értéket, hogy az adatokat megoszd a projektek között.',
  'useEverywhere.section.cli.tab': 'CLI · od',
  'useEverywhere.section.cli.heading': 'Vezéreld az Open Designt bármelyik shellből',
  'useEverywhere.section.cli.intro': 'Az `od` bináris a daemonnal együtt érkezik, és ugyanaz a bináris, amelyet a Claude Code / Codex használ generáláskor. A legtöbb alparancs vékony kliens, amely a helyi daemonnak POST-ol, így ugyanúgy működnek, akár a `pnpm tools-dev` paranccsal, akár csomagolt alkalmazásként indítottad őket.',
  'useEverywhere.section.cli.bullet1': '`od` (argumentumok nélkül) — elindítja a daemont és megnyitja a webes felhasználói felületet.',
  'useEverywhere.section.cli.bullet2': '`od media generate ...` — kép / videó / audio bájtok előállítása az egységes médiaprotokollon keresztül.',
  'useEverywhere.section.cli.bullet3': '`od run ...` — projektfuttatás indítása prompt + skill alapján.',
  'useEverywhere.section.cli.bullet4': '`od plugin install <source>` / `od plugin apply <id>` — közösségi pluginok telepítése és alkalmazása.',
  'useEverywhere.section.cli.bullet5': '`od skills list` / `od design-systems list` — annak vizsgálata, hogy mi érhető el helyben.',
  'useEverywhere.section.cli.bullet6': '`od status` / `od doctor` — a daemon állapotának ellenőrzése és az agent CLI-k felismerése a PATH-odon.',
  'useEverywhere.section.cli.snippet1': 'Kép generálása (a beállított médiaszolgáltatóra delegálja)',
  'useEverywhere.section.cli.snippet2': 'Forgatókönyv-plugin futtatása fej nélkül, és események streamelése JSON-sorokként',
  'useEverywhere.section.cli.snippet3': 'Helyben elérhető skillek és tervezőrendszerek leltározása',
  'useEverywhere.section.cli.snippet4': 'Beültetett artefaktumok ellenőrzése a CLI-n keresztül',
  'useEverywhere.section.cli.snippet5': 'Környezet + felismert agentek ellenőrzése (Claude, Codex, Cursor, …)',
  'useEverywhere.section.cli.footer': 'Minden alparancs elfogadja a `--daemon-url http://127.0.0.1:<port>` opciót egy konkrét futó daemon megcélzásához — hasznos, ha tesztekhez sandbox-olt második példányt futtatsz.',
  'useEverywhere.section.mcp.tab': 'MCP-szerver',
  'useEverywhere.section.mcp.heading': 'Tedd elérhetővé az Open Designt MCP-szerverként bármely kódoló agent számára',
  'useEverywhere.section.mcp.intro': 'Az Open Design egy Model Context Protocol szerverrel (`od mcp`) érkezik, amely lehetővé teszi bármely MCP-képes kliens — Cursor, Claude Code, Antigravity, VS Code Copilot Chat, openclaw, hermes — számára, hogy felfedezze az Open Design eszközeit (skillek listázása, előnézetek renderelése, média generálása, pluginok futtatása) manuális shell-hívás nélkül. A daemon minden főbb klienshez közzétesz egy beillesztésre kész telepítési kódrészletet a `GET /api/mcp/install-info` végponton keresztül.',
  'useEverywhere.section.mcp.bullet1': 'Stdio transport — nincs extra port, a kliens közvetlenül indítja az `od mcp` parancsot.',
  'useEverywhere.section.mcp.bullet2': 'Automatikusan felismeri az élő daemon URL-jét a helyi IPC-állapotsocketen keresztül, amikor sidecar-ként indul.',
  'useEverywhere.section.mcp.bullet3': 'Egyszerű telepítések esetén a `--daemon-url http://127.0.0.1:<port>` értékre tér vissza, így az MCP-folyamat mindig megtalálja a futó daemont.',
  'useEverywhere.section.mcp.bullet4': 'Rögzíti az `OD_DATA_DIR` értéket, hogy a létrehozott MCP-folyamat ugyanoda írjon, ahová a daemon már ír (elkerüli az EPERM hibát a csomagolt macOS-alkalmazáscsomagokban).',
  'useEverywhere.section.mcp.snippet1': 'Általános MCP kliens-konfiguráció (működik Cursorban, Claude Code-ban, Codexben, …)',
  'useEverywhere.section.mcp.snippet2': 'Vagy: kérd el a daemontól a telepítésedhez igazított kódrészletet',
  'useEverywhere.section.mcp.snippet3': 'Élő artefaktumokat kezelő MCP-változat (irányítópultok olvasása és frissítése)',
  'useEverywhere.section.mcp.footer': 'Az Open Design alkalmazásban nyisd meg a Beállítások → Integrációk menüt, hogy kliens-specifikus telepítési parancsot másolj (Cursor, Claude Code, Antigravity, VS Code), ahelyett hogy kézzel szerkesztenéd a JSON-t.',
  'useEverywhere.section.http.tab': 'HTTP API',
  'useEverywhere.section.http.heading': 'Ugyanaz a REST + SSE felület, amelyet a webes felület használ',
  'useEverywhere.section.http.intro': 'A helyi daemon egy HTTP API-t szolgál ki a `http://127.0.0.1:7456` címen (a port konfigurálható). Minden végpont, amelyet a webes felület hív, a szkriptjeid számára is elérhető. A streamelő végpontok (chatfordulók, projektfuttatások) Server-Sent Events eseményeket bocsátanak ki a `@open-design/contracts` szerződéstípusaival.',
  'useEverywhere.section.http.bullet1': '`GET /api/health` — a daemon életjele.',
  'useEverywhere.section.http.bullet2': '`GET /api/skills` és `GET /api/design-systems` — elérhető registry-k.',
  'useEverywhere.section.http.bullet3': '`GET /api/projects` és `POST /api/projects` — projektek listázása és létrehozása (a POST a projektet + az első beszélgetést adja vissza).',
  'useEverywhere.section.http.bullet4': '`GET /api/projects/:id/chat` — egy beszélgetés agent-eseményeinek SSE adatfolyama.',
  'useEverywhere.section.http.bullet5': '`POST /api/plugins/:id/apply` — egy telepített plugin összekötése, és a renderelt példa-lekérdezésének + bemeneteinek lekérése.',
  'useEverywhere.section.http.bullet6': '`GET /api/agents` — a PATH-odon felismert kód-agent CLI-k.',
  'useEverywhere.section.http.snippet1': 'Telepített skillek listázása (az agent ezeket sablonként használja)',
  'useEverywhere.section.http.snippet2': 'Projekt létrehozása promptból (teljes szerveroldali folyamat)',
  'useEverywhere.section.http.snippet3': 'Egy chat-forduló streamelése (SSE — minden sor JSON-Lines kompatibilis)',
  'useEverywhere.section.http.footer': 'Minden kéréshez/válaszhoz tartozó tiszta TypeScript típusok a `@open-design/contracts` csomagban élnek — importáld őket a szkriptedbe a teljes automatikus kiegészítéshez, generátor bekötése nélkül.',
  'useEverywhere.section.skills.tab': 'Skillek és fej nélküli mód',
  'useEverywhere.section.skills.heading': 'Beilleszthető Skills bármely agenthez — még futó Open Design nélkül is',
  'useEverywhere.section.skills.intro': 'A Skill egy könyvtár, amely Claude-kompatibilis `SKILL.md` fájlt tartalmaz (YAML front-matter + törzs). Az Open Design kibővíti a formátumot az `od:` névtérrel (`mode`, `preview`, `design_system`, `inputs`, …), így ugyanaz az artefaktum használható mind az Open Designon belül, mind egy egyszerű agenttel, mint a Claude Code, Codex, openclaw vagy hermes. A felfedezés precedencia-láncot követ, így a projektek felülbírálhatják a saját skilljeiket.',
  'useEverywhere.section.skills.bullet1': 'Felfedezés: `./.claude/skills/` → `./skills/` → `~/.claude/skills/` (a projekt nyer).',
  'useEverywhere.section.skills.bullet2': 'Hozz létre szimbolikus linket egy skillre több projektben, hogy megoszd másolás nélkül.',
  'useEverywhere.section.skills.bullet3': 'Minden skill deklarálhat konnektorokat, atomokat, tervezőrendszer-követelményeket és egy `preview` példakimenetet a galériához.',
  'useEverywhere.section.skills.bullet4': 'Fej nélkül: egy agent, amelynek `od` szerepel a PATH-jában, meghívhatja az `od skills list` parancsot, majd futtathat bármely skillt; a daemon a csak olvasható folyamatokhoz nem kötelező.',
  'useEverywhere.section.skills.bullet5': 'A `pnpm seed:test-projects` ugyanazt az artefaktumformát gyakoroltatja az alapértelmezett plugin-példákkal és a közösségi plugin-példákkal, majd a kapott `index.html` projekteket újrafelhasználható tesztadatként tárolja.',
  'useEverywhere.section.skills.snippet1': 'Minimális SKILL.md (Claude-kompatibilis front matter + Open Design extrák)',
  'useEverywhere.section.skills.snippet2': 'Megosztott skill szimbolikus linkelése egy projektbe (cc-switch stílusban)',
  'useEverywhere.section.skills.snippet3': 'Fej nélkül: a daemon által jelenleg látott skillek listázása',
  'useEverywhere.section.skills.snippet4': 'Fej nélküli artefaktum-fixtúracsomag',
  'useEverywhere.section.skills.footer': 'Specifikáció: a `docs/skills-protocol.md` és a `docs/agent-adapters.md` lefedi a teljes adapterfelületet (Claude Code, Codex, Cursor, MCP-képes agentek, BYOK API fallback) és az adapterenkénti skill-injektálási stratégiákat.',
  'tasks.kicker': 'Automatizálási munkaterület',
  'tasks.comingSoon': 'Hamarosan',
  'tasks.lede': 'Az automatizálások a promptokból tartós munkát hoznak létre: az Orbit futtatja őket, a rutinok fenntartják őket, az ütemezések eldöntik, mikor induljanak, az élő artefaktumok pedig megmutatják, mi változott.',
  'tasks.newAutomation': 'Új automatizálás',
  'tasks.previewNote': 'Csak előnézeti felület. Az Orbit beállításai ma már elérhetők; a rutinok, az ütemezések és az élő artefaktumok bekötése a backend-ágak összeolvadásával érkezik.',
  'tasks.primitivesAria': 'Automatizálási alapelemek',
  'tasks.primitive.orbit.title': 'Orbit',
  'tasks.primitive.orbit.body': 'Tartós futtatókörnyezet hosszan futó vagy ismétlődő agentmunkához.',
  'tasks.primitive.orbit.enabled': 'Napi összefoglaló engedélyezve',
  'tasks.primitive.orbit.manualOnly': 'Csak manuálisan',
  'tasks.primitive.routines.title': 'Rutinok',
  'tasks.primitive.routines.body': 'Tartós feladatdefiníciók, amelyek egyetlen chat befejezése után is megmaradnak.',
  'tasks.primitive.routines.meta': 'A termékváz kész',
  'tasks.primitive.schedules.title': 'Ütemezések',
  'tasks.primitive.schedules.body': 'Idő- vagy eseményalapú triggerek, amelyek eldöntik, mikor fusson egy rutin.',
  'tasks.primitive.schedules.meta': 'Ág függőben',
  'tasks.primitive.liveArtifacts.title': 'Élő artefaktumok',
  'tasks.primitive.liveArtifacts.body': 'Jelentések és jegyzetek, amelyek folyamatosan frissülnek, amíg egy agent dolgozik.',
  'tasks.primitive.liveArtifacts.meta': 'Előnézeti modell',
  'tasks.listAria': 'Automatizálások listája',
  'tasks.routinesAndRuns': '{n} rutin és futtatás',
  'tasks.filtersAria': 'Automatizálási szűrők',
  'tasks.filter.scheduled': 'Ütemezett',
  'tasks.filter.running': 'Fut',
  'tasks.filter.done': 'Kész',
  'tasks.configurationAria': 'Automatizálás beállításai',
  'tasks.slot.trigger': 'Trigger',
  'tasks.slot.pattern': 'Minta',
  'tasks.slot.runtime': 'Futásidő',
  'tasks.slot.output': 'Kimenet',
  'tasks.liveArtifact': 'Élő artefaktum',
  'tasks.viewProgress': 'Folyamat megtekintése',
  'tasks.pause': 'Szüneteltetés',
  'tasks.runNow': 'Futtatás most',
  'tasks.openArtifact': 'Artefaktum megnyitása',
  'tasks.status.dailyAt': 'Naponta · {time}',
  'tasks.status.pausedManual': 'Szüneteltetve · csak manuálisan',
  'tasks.sample.orbit.title': 'Orbit Daily connector összefoglaló',
  'tasks.sample.orbit.metaEnabled': 'A connector-összefoglaló ütemezve van',
  'tasks.sample.orbit.metaDisabled': 'Nyisd meg az Orbit beállításait az engedélyezéshez',
  'tasks.sample.orbit.previewEnabled': 'orbit_daily.html · élő artefaktum',
  'tasks.sample.orbit.previewDisabled': 'Nincs ütemezett futtatás',
  'tasks.sample.orbit.triggerEnabled': 'Ütemezés · naponta ekkor: {time}',
  'tasks.sample.orbit.triggerDisabled': 'Manuális · igény szerint futtatva',
  'tasks.sample.orbit.pattern': 'Rutin · connector-összefoglaló',
  'tasks.sample.orbit.runtime': 'Orbit · daemon által ütemezve',
  'tasks.sample.orbit.output': 'Élő tartalom · frissíthető jelentés',
  'tasks.sample.orbit.artifactMetaEnabled': 'Minden futtatás után frissül',
  'tasks.sample.orbit.artifactMetaDisabled': 'Várakozás az ütemezésre',
  'tasks.sample.orbit.body1': '# Orbit Daily tevékenység-összefoglaló',
  'tasks.sample.orbit.body2': 'Connectorok ellenőrizve · sikerek, kihagyások és hibák',
  'tasks.sample.orbit.body3': 'A kiemelésekből frissíthető élő artefaktum lesz.',
  'tasks.sample.mcp.title': 'MCP alternatívák kutatása',
  'tasks.sample.mcp.status': 'Fut az Orbit-ban · 2 ó 14 p',
  'tasks.sample.mcp.meta': '14 / 30 forrás feldolgozva',
  'tasks.sample.mcp.preview': 'research_notes.md · élő',
  'tasks.sample.mcp.trigger': 'Kézi · egyszeri',
  'tasks.sample.mcp.pattern': 'Mélykutatási prompt',
  'tasks.sample.mcp.runtime': 'Távoli · tartós',
  'tasks.sample.mcp.output': 'Élő jelentés · automatikus frissítés',
  'tasks.sample.mcp.artifactMeta': 'Frissítve 12 mp-e',
  'tasks.sample.mcp.body1': '# MCP alternatívák – ideiglenes eredmények',
  'tasks.sample.mcp.body2': '14 forrás áttekintve · 3 esélyes kiválasztva',
  'tasks.sample.mcp.body3': '## Szűkített lista',
  'tasks.sample.mcp.body4': '- Eszközhívási sémák JSON-RPC-n keresztül...',
  'tasks.sample.mcp.body5': '- gRPC-alapú agent protokollok...',
  'tasks.sample.weekly.title': 'Heti csapatösszefoglaló',
  'tasks.sample.weekly.status': 'Következő: hétfő 9:00',
  'tasks.sample.weekly.meta': 'Frissíti a heti csapatdokumentumot',
  'tasks.sample.weekly.preview': 'team_weekly.md · következő tartalom',
  'tasks.sample.weekly.trigger': 'Ütemezés · heti',
  'tasks.sample.weekly.pattern': 'Rutin · csapatösszefoglaló',
  'tasks.sample.weekly.runtime': 'Távoli · ismétlődő',
  'tasks.sample.weekly.output': 'Élő tartalom · markdown',
  'tasks.sample.weekly.artifactMeta': 'Utoljára frissítve 4 napja',
  'tasks.sample.weekly.body1': '# Heti csapat',
  'tasks.sample.weekly.body2': '## Folyamatban',
  'tasks.sample.weekly.body3': '- Designrendszer-integrációs kör',
  'tasks.sample.weekly.body4': '- Connectorok minőségi átvizsgálása',
  'tasks.sample.weekly.body5': '## Kockázatok',
  'tasks.sample.pr.title': 'PR-felülvizsgálati emlékeztető',
  'tasks.sample.pr.status': 'Új PR esetén · 23 perce indult',
  'tasks.sample.pr.meta': 'Slack DM-et küld',
  'tasks.sample.pr.preview': 'Az utolsó kézbesítés sikeres volt',
  'tasks.sample.pr.trigger': 'Esemény · új PR',
  'tasks.sample.pr.pattern': 'Rutin · értesítés',
  'tasks.sample.pr.runtime': 'Helyi · gyors futtatás',
  'tasks.sample.pr.output': 'Üzenet · Slack DM',
  'tasks.sample.pr.artifactMeta': 'Utoljára aktiválva 23 perce',
  'tasks.sample.pr.body1': 'PR #184 megnyitva felülvizsgálatra',
  'tasks.sample.pr.body2': 'Egyező felülvizsgálók: design-platform, web-runtime',
  'tasks.sample.pr.body3': 'Kézbesítés: Slack DM elküldve',
  'tasks.sample.meeting.title': 'Megbeszélés előtti előkészület',
  'tasks.sample.meeting.status': 'Holnap · 10:00',
  'tasks.sample.meeting.meta': 'Egyszeri · összefoglalót küld',
  'tasks.sample.meeting.preview': 'meeting_brief.md · sorban áll',
  'tasks.sample.meeting.trigger': 'Ütemezés · egyszeri',
  'tasks.sample.meeting.pattern': 'Tájékoztató prompt',
  'tasks.sample.meeting.runtime': 'Távoli · korlátozott',
  'tasks.sample.meeting.output': 'Artefaktum + üzenet',
  'tasks.sample.meeting.artifactMeta': 'Generálásra sorba állítva',
  'tasks.sample.meeting.body1': '# Megbeszélés-tájékoztató',
  'tasks.sample.meeting.body2': 'Napirend forrása: naptáresemény + hivatkozott dokumentumok',
  'tasks.sample.meeting.body3': 'A kimenet tartalmazni fogja a döntéseket, akadályokat és kérdéseket.',
  'tasks.sample.candidate.title': 'Jelöltek követése',
  'tasks.sample.candidate.status': 'Sikertelen · beavatkozás szükséges',
  'tasks.sample.candidate.meta': 'A hitelesítés lejárt',
  'tasks.sample.candidate.preview': 'Csatlakoztasd újra a Greenhouse-t a folytatáshoz',
  'tasks.sample.candidate.trigger': 'Ütemezés · napi',
  'tasks.sample.candidate.pattern': 'Rutin · jelentkezők szinkronizálása',
  'tasks.sample.candidate.runtime': 'Távoli · ismétlődő',
  'tasks.sample.candidate.output': 'Élő tartalom · táblázat',
  'tasks.sample.candidate.artifactMeta': 'Szüneteltetve, amíg a hitelesítés helyre nem áll',
  'tasks.sample.candidate.body1': '# Jelöltfolyamat',
  'tasks.sample.candidate.body2': 'Utolsó sikeres szinkronizálás: 2 napja',
  'tasks.sample.candidate.body3': 'Beavatkozás szükséges: csatlakoztassa újra a forrásfiókot.',
  'routines.title': 'Automatizálások',
  'routines.subtitle': 'Ütemezett automatizálások, amelyek felügyelet nélkül futnak.',
  'routines.newAutomation': 'Új automatizálás',
  'routines.loading': 'Betöltés…',
  'routines.empty': 'Még nincsenek automatizálások.',
  'routines.emptyHint': 'Kattintson az Új automatizálás gombra felügyelet nélküli agentfuttatás ütemezéséhez.',
  'routines.runHistoryLoading': 'Futások betöltése…',
  'routines.runHistoryEmpty': 'Még nincsenek futtatások.',
  'routines.fieldName': 'Név',
  'routines.fieldNamePlaceholder': 'Reggeli összefoglaló',
  'routines.fieldPrompt': 'Prompt',
  'routines.fieldPromptPlaceholder': 'Töltsd le a tegnapi GitHub + Linear tevékenységet, és foglald össze, mi változott.',
  'routines.fieldSchedule': 'Ütemezés',
  'routines.fieldMinute': 'Minden óra perce',
  'routines.fieldTime': 'Időpont',
  'routines.fieldTimezone': 'Időzóna',
  'routines.fieldsetProject': 'Projekt',
  'routines.kind.hourly': 'Óránként',
  'routines.kind.daily': 'Naponta',
  'routines.kind.weekdays': 'Hétköznapokon',
  'routines.kind.weekly': 'Hetente',
  'routines.weekday.short.0': 'V',
  'routines.weekday.short.1': 'H',
  'routines.weekday.short.2': 'K',
  'routines.weekday.short.3': 'Sze',
  'routines.weekday.short.4': 'Cs',
  'routines.weekday.short.5': 'P',
  'routines.weekday.short.6': 'Szo',
  'routines.weekday.long.0': 'Vasárnap',
  'routines.weekday.long.1': 'Hétfő',
  'routines.weekday.long.2': 'Kedd',
  'routines.weekday.long.3': 'Szerda',
  'routines.weekday.long.4': 'Csütörtök',
  'routines.weekday.long.5': 'Péntek',
  'routines.weekday.long.6': 'Szombat',
  'routines.timeAm': 'AM',
  'routines.timePm': 'PM',
  'routines.describe.hourly': 'Minden órában :{minute} perckor fut',
  'routines.describe.daily': 'Naponta {time} {tz} időpontban fut',
  'routines.describe.weekdays': 'Fut hétfőtől péntekig {time} {tz} időpontban',
  'routines.describe.weekly': 'Minden {day} {time} {tz} időpontban fut',
  'routines.modeCreate': 'Új projekt létrehozása minden futtatáskor',
  'routines.modeCreateHint': 'Friss, elkülönített munkaterület minden indításkor.',
  'routines.modeReuse': 'Meglévő projekt újrafelhasználása',
  'routines.modeReuseHint': 'Minden futtatás új beszélgetésként él a projekten belül.',
  'routines.pickProject': '— Válassz projektet —',
  'routines.targetReuse': '→ {project}',
  'routines.targetCreate': '→ minden futáskor új projekt',
  'routines.tagPaused': 'szüneteltetve',
  'routines.metaNext': 'következő: {when}',
  'routines.metaLast': 'utolsó:',
  'routines.triggerManual': 'kézi',
  'routines.triggerScheduled': 'ütemezett',
  'routines.openProject': 'Projekt megnyitása',
  'routines.openProjectTitle': 'A projekt megnyitása, amelybe ez a futtatás írt',
  'routines.runNow': 'Futtatás most',
  'routines.edit': 'Szerkesztés',
  'routines.pause': 'Szüneteltetés',
  'routines.resume': 'Folytatás',
  'routines.history': 'Előzmények',
  'routines.hideHistory': 'Előzmények elrejtése',
  'routines.delete': 'Törlés',
  'routines.deleteTitle': 'Automatizálás törlése',
  'routines.cancel': 'Mégse',
  'routines.save': 'Mentés',
  'routines.saving': 'Mentés…',
  'routines.create': 'Létrehozás',
  'routines.creating': 'Létrehozás…',
  'routines.status.queued': 'várakozási sorban',
  'routines.status.running': 'fut',
  'routines.status.succeeded': 'sikeres',
  'routines.status.failed': 'sikertelen',
  'routines.status.canceled': 'megszakítva',
  'routines.confirmDelete': 'Törli ezt az automatizálást? A korábbi futtatások és projektjeik megmaradnak.',
  'routines.errorPickProject': 'Válassz egy projektet az újrafelhasználáshoz, vagy válts a „Minden futáskor új létrehozása” lehetőségre',
  'routines.errorAgentEmptyOutput': 'Az Agent kimenet nélkül fejeződött be. Lehet, hogy a modell vagy a szolgáltató üres választ adott vissza — ellenőrizd az Agent naplóit a felsőbb szintű hibákért.',
  'entry.helpAria': 'Súgó',
  'entry.helpMenuAria': 'Súgó menü',
  'entry.helpGetHelp': 'Kérj segítséget a GitHubon',
  'entry.helpSubmitFeature': 'Funkció javaslása',
  'entry.helpWhatsNew': 'Újdonságok',
  'entry.helpDownloadDesktop': 'Asztali alkalmazás letöltése',
  'entry.githubStarLabel': 'Csillagozás',
  'entry.githubStarTitle': 'Csillagozz meg minket a GitHubon',
  'entry.githubStarAria': 'Csillagozd meg az Open Design projektet a GitHubon',
  'entry.tabImageTemplates': 'Képsablonok',
  'entry.tabVideoTemplates': 'Videósablonok',
  'promptTemplates.searchPlaceholder': 'Sablonok keresése…',
  'promptTemplates.countLabel': '{n} találat',
  'promptTemplates.emptyImage': 'Még nincs telepített képsablon.',
  'promptTemplates.emptyVideo': 'Még nincs telepített videósablon.',
  'promptTemplates.emptyNoMatch': 'Egy sablon sem felel meg a keresésnek.',
  'promptTemplates.attributionFooter': 'Nyilvános prompt-tárakból átvéve. Minden kártya az eredeti szerzőre mutat.',
  'promptTemplates.openPreviewTitle': 'Prompt és előnézet megnyitása',
  'promptTemplates.sourcePrefix': 'Forrás:',
  'promptTemplates.fetchError': 'A sablon törzse nem tölthető be.',
  'promptTemplates.promptLabel': 'Prompt törzse',
  'promptTemplates.copyPrompt': 'Prompt másolása',
  'promptTemplates.copyDone': 'Másolva!',
  'promptTemplates.modelHint': 'Ajánlott modell: {model}',
  'promptTemplates.openSource': 'Eredeti megnyitása',
  'promptTemplates.openFullscreen': 'Teljes képernyős előnézet',
  'promptTemplates.closeFullscreen': 'Teljes képernyős előnézet bezárása',
  'promptTemplates.allSources': 'Minden forrás',
  'promptTemplates.sourceFilterAria': 'Szűrés forrás szerint',
  'promptTemplates.retry': 'Újra',
  'connectors.title': 'Kapcsolók',
  'connectors.subtitle': 'Helyi és jövőbeli adatforrások, amelyek élő artefaktokat táplálhatnak.',
  'connectors.account': 'Fiók',
  'connectors.noAccount': 'Nincs csatlakoztatva',
  'connectors.tools': 'Eszközök',
  'connectors.connect': 'Csatlakozás',
  'connectors.disconnect': 'Leválasztás',
  'connectors.authorizationPending': 'Várakozás az engedélyezésre...',
  'connectors.authorizationPendingHint': 'Fejezd be az engedélyezést a megnyitott ablakban.',
  'connectors.cancelAuthorization': 'Mégse',
  'connectors.configure': 'Beállítás',
  'connectors.unavailable': 'Nem érhető el',
  'connectors.phaseStubTitle': 'A kapcsoló API-k a 3. fázisban érkeznek; ez csak előnézet.',
  'connectors.statusAvailable': 'Elérhető',
  'connectors.statusConnected': 'Csatlakoztatva',
  'connectors.statusError': 'Hiba',
  'connectors.statusDisabled': 'Letiltva',
  'connectors.gateTitle': 'Add meg a Composio API-kulcsot a folytatáshoz',
  'connectors.gateBody': 'Illeszd be fent a kulcsot, majd kattints a Kulcs mentése gombra az elérhető integrációk betöltéséhez.',
  'connectors.aboutLabel': 'Névjegy',
  'connectors.detailsLabel': 'Részletek',
  'connectors.statusLabel': 'Állapot',
  'connectors.category.aiAgents': 'AI-ügynökök',
  'connectors.category.aiInfrastructure': 'AI-infrastruktúra',
  'connectors.category.accounting': 'Könyvelés',
  'connectors.category.admin': 'Adminisztráció',
  'connectors.category.advertising': 'Hirdetés',
  'connectors.category.analytics': 'Analitika',
  'connectors.category.automation': 'Automatizálás',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'Naptár',
  'connectors.category.commerce': 'Kereskedelem',
  'connectors.category.communication': 'Kommunikáció',
  'connectors.category.contacts': 'Kapcsolatok',
  'connectors.category.dataPlatform': 'Adatplatform',
  'connectors.category.database': 'Adatbázis',
  'connectors.category.design': 'Tervezés',
  'connectors.category.developer': 'Fejlesztői eszközök',
  'connectors.category.documentation': 'Dokumentáció',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': 'Oktatás',
  'connectors.category.email': 'E-mail',
  'connectors.category.events': 'Események',
  'connectors.category.fieldService': 'Terepszolgálat',
  'connectors.category.finance': 'Pénzügy',
  'connectors.category.fitness': 'Fitnesz',
  'connectors.category.forms': 'Űrlapok',
  'connectors.category.gaming': 'Játék',
  'connectors.category.hr': 'HR',
  'connectors.category.hospitality': 'Vendéglátás',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': 'Integráció',
  'connectors.category.localization': 'Lokalizáció',
  'connectors.category.logistics': 'Logisztika',
  'connectors.category.maps': 'Térképek',
  'connectors.category.marketing': 'Marketing',
  'connectors.category.media': 'Média',
  'connectors.category.meetings': 'Megbeszélések',
  'connectors.category.nonprofit': 'Nonprofit',
  'connectors.category.observability': 'Megfigyelhetőség',
  'connectors.category.payments': 'Fizetések',
  'connectors.category.personal': 'Személyes',
  'connectors.category.presentations': 'Prezentációk',
  'connectors.category.procurement': 'Beszerzés',
  'connectors.category.product': 'Termék',
  'connectors.category.productivity': 'Produktivitás',
  'connectors.category.projectManagement': 'Projektmenedzsment',
  'connectors.category.recruiting': 'Toborzás',
  'connectors.category.research': 'Kutatás',
  'connectors.category.salesIntelligence': 'Értékesítési intelligencia',
  'connectors.category.scheduling': 'Ütemezés',
  'connectors.category.search': 'Keresés',
  'connectors.category.security': 'Biztonság',
  'connectors.category.signing': 'Aláírás',
  'connectors.category.social': 'Közösségi',
  'connectors.category.spreadsheets': 'Táblázatok',
  'connectors.category.storage': 'Tárhely',
  'connectors.category.support': 'Támogatás',
  'connectors.category.surveys': 'Kérdőívek',
  'connectors.category.tasks': 'Feladatok',
  'connectors.category.timeTracking': 'Időkövetés',
  'connectors.category.video': 'Videó',
  'connectors.category.whiteboard': 'Tábla',
  'connectors.categoryLabel': 'Kategória',
  'connectors.providerLabel': 'Szolgáltató',
  'connectors.toolsSection': 'Eszközök',
  'connectors.toolsLoading': 'Eszközök betöltése…',
  'connectors.noToolsAvailable': 'Még nincs elérhető eszköz. Csatlakozás után megjelennek ennek az integrációnak a képességei.',
  'connectors.toolDetailsUnavailable': 'Az eszközök részletei nem érhetők el, de ez a csatlakozó {n} eszközt jelez.',
  'connectors.loadMoreTools': 'További eszközök betöltése',
  'connectors.openDetailsAria': '{name} részleteinek megnyitása',
  'connectors.toolsBadgeNone': 'Nincs eszköz',
  'connectors.toolsBadgeOne': '{n} eszköz',
  'connectors.toolsBadgeMany': '{n} eszköz',
  'connectors.searchPlaceholder': 'Kapcsolók keresése…',
  'connectors.searchAriaLabel': 'Kapcsolók keresése név, szolgáltató vagy eszköz alapján',
  'connectors.searchClear': 'Keresés törlése',
  'connectors.emptyNoMatchTitle': 'Nincs „{query}” kifejezésre illeszkedő kapcsoló',
  'connectors.emptyNoMatchBody': 'Próbálj más kulcsszót, vagy töröld a keresést a teljes katalógushoz.',
  'connectors.emptyNoMatchAction': 'Keresés törlése',
  'newproj.tabPrototype': 'Prototípus',
  'newproj.tabLiveArtifact': 'Élő artifact',
  'newproj.tabDeck': 'Diavetítés',
  'newproj.tabTemplate': 'Sablonból',
  'newproj.tabMedia': 'Média',
  'newproj.tabOther': 'Egyéb',
  'newproj.titlePrototype': 'Új prototípus',
  'newproj.titleLiveArtifact': 'Új élő artifact',
  'newproj.titleDeck': 'Új diavetítés',
  'newproj.titleTemplate': 'Indulás sablonból',
  'newproj.titleImage': 'Új kép',
  'newproj.titleVideo': 'Új videó',
  'newproj.titleAudio': 'Új hang',
  'newproj.titleMedia': 'Új média',
  'newproj.titleOther': 'Új projekt',
  'newproj.namePlaceholder': 'Projekt neve',
  'newproj.fidelityLabel': 'Részletesség',
  'newproj.fidelityWireframe': 'Drótváz',
  'newproj.fidelityHigh': 'Részletes',
  'newproj.toggleSpeakerNotes': 'Előadói jegyzetek használata',
  'newproj.toggleSpeakerNotesHint': 'Kevesebb szöveg a diákon — a beszédpontok a jegyzetekbe kerülnek.',
  'newproj.toggleAnimations': 'Animációk hozzáadása',
  'newproj.toggleAnimationsHint': 'Mozgás (belépés, hover, átmenetek) hozzáadása a sablonra.',
  'newproj.targetPlatformsLabel': 'Célplatformok',
  'newproj.targetPlatformsHint': 'Válasszon egyet vagy többet. A reszponzív web csak a böngésző töréspontjait fedi le; natív, többplatformos változatokhoz adjon hozzá iOS, Android, táblagépes vagy asztali alkalmazást.',
  'newproj.platform.responsive.label': 'Reszponzív web',
  'newproj.platform.responsive.hint': 'Egyetlen webes élmény, asztali, táblagépes és mobil böngészőkre optimalizálva',
  'newproj.platform.webDesktop.label': 'Asztali web',
  'newproj.platform.webDesktop.hint': 'Böngészőközpontú termék vagy nyitóoldal',
  'newproj.platform.mobileIos.label': 'iOS alkalmazás',
  'newproj.platform.mobileIos.hint': 'iPhone-keretek és iOS-interakciós szabályok',
  'newproj.platform.mobileAndroid.label': 'Android alkalmazás',
  'newproj.platform.mobileAndroid.hint': 'Pixel-keretek és Material-interakciós szabályok',
  'newproj.platform.tablet.label': 'Táblagépes alkalmazás',
  'newproj.platform.tablet.hint': 'Natív stílusú táblagépes élmény osztott nézetekkel',
  'newproj.platform.desktopApp.label': 'Asztali alkalmazás',
  'newproj.platform.desktopApp.hint': 'macOS/Windows alkalmazáskeret',
  'newproj.surfaceOptionsLabel': 'Kiegészítő felületek',
  'newproj.includeLandingPage': 'Nyitóoldal hozzáadása',
  'newproj.includeLandingPageHint': 'Adjon hozzá egy reszponzív marketingoldalt hirdetésekhez, várólistákhoz, indítási kampányokhoz, alkalmazásletöltésekhez vagy a termék bemutatásához.',
  'newproj.includeOsWidgets': 'OS-widgetek hozzáadása',
  'newproj.includeOsWidgetsHint': 'Adjon hozzá platformnatív kezdőképernyő-, zárolási képernyő- vagy gyorselérési widgeteket mobil/táblagépes alkalmazásokhoz.',
  'newproj.includeOsWidgetsDisabledHint': 'Akkor érhető el, ha célplatformként iOS, Android vagy táblagépes alkalmazás van kiválasztva.',
  'newproj.templateLabel': 'Sablon',
  'newproj.noTemplatesTitle': 'Még nincs sablon',
  'newproj.noTemplatesBody': 'Nyiss meg egy projektet, majd a fájlnézőben a Megosztás menüvel alakítsd sablonná. A sablonok itt jelennek meg.',
  'newproj.savedTemplate': 'Mentett sablon',
  'newproj.fileSingular': 'fájl',
  'newproj.filePlural': 'fájl',
  'newproj.create': 'Létrehozás',
  'newproj.locationLabel': 'Mentés ide',
  'newproj.locationDefault': 'Open Design projektek',
  'newproj.locationExternalBase': 'Külső bázis',
  'newproj.createLiveArtifact': 'Élő artifact létrehozása',
  'newproj.createFromTemplate': 'Létrehozás sablonból',
  'newproj.createDisabledTitle': 'Először ments el egy projektet sablonként (bármely projekt Megosztás menüjéből).',
  'newproj.importClaudeZip': 'Claude Design ZIP importálása',
  'newproj.importClaudeZipTitle': 'Claude Design .zip export importálása',
  'newproj.importingClaudeZip': 'Importálás…',
  'newproj.privacyFooter': 'Alapértelmezetten csak te láthatod a projekted.',
  'newproj.designSystem': 'Designrendszer',
  'newproj.dsNoneFreeform': 'Nincs — szabad formátum',
  'newproj.dsNoneSubtitleEmpty': 'Nincsenek rendszertokenek, válassz saját palettát',
  'newproj.dsNoneSubtitleSelected': 'Hagyd ki a rendszertokeneket. Az ügynök maga választ palettát.',
  'newproj.dsCategoryFallback': 'Designrendszer',
  'newproj.dsSearch': 'Designrendszerek keresése…',
  'newproj.dsModeAria': 'Kijelölési mód',
  'newproj.dsModeSingle': 'Egy',
  'newproj.dsModeMulti': 'Több',
  'newproj.dsNoneTitle': 'Nincs — szabad formátum',
  'newproj.dsNoneSub': 'Hagyd ki a rendszertokeneket. Az ügynök maga választ palettát.',
  'newproj.dsEmpty': 'Egy designrendszer sem felel meg a „{query}" keresésnek.',
  'newproj.dsFootSingular': 'csak inspiráció.',
  'newproj.dsFootPlural': 'csak inspiráció.',
  'newproj.dsFootClear': 'Törlés',
  'newproj.dsBadgeDefault': 'ALAPÉRT.',
  'newproj.dsPrimaryFallback': 'Elsődleges',
  'newproj.surfaceImage': 'Kép',
  'newproj.surfaceVideo': 'Videó',
  'newproj.surfaceAudio': 'Hang',
  'newproj.modelLabel': 'Modell',
  'newproj.modelSearch': 'Modellek keresése…',
  'newproj.modelEmpty': 'Nincs találat a modellekre.',
  'newproj.modelRecommended': 'Ajánlott',
  'newproj.modelMissingTitle': 'Modell kiválasztása',
  'newproj.modelMissingSub': 'Válassz modellt ehhez a felülethez.',
  'newproj.aspectLabel': 'Képarány',
  'newproj.videoLengthLabel': 'Hossz',
  'newproj.videoLengthSeconds': '{n} mp',
  'newproj.audioKindLabel': 'Hangtípus',
  'newproj.audioKindMusic': 'Zene',
  'newproj.audioKindSpeech': 'Beszéd / TTS',
  'newproj.audioKindSfx': 'Hangeffekt',
  'newproj.audioDurationLabel': 'Időtartam',
  'newproj.audioDurationSeconds': '{n} mp',
  'newproj.voiceLabel': 'Hang',
  'newproj.voicePlaceholder': 'Szolgáltatói hang-id, opcionális',
  'newproj.connectorsLabel': 'Kapcsolók',
  'newproj.connectorsHint': 'Adatforrások, amelyeket ez az artefaktum használhat.',
  'newproj.connectorsEmptyTitle': 'Nincs beállított kapcsoló',
  'newproj.connectorsEmptyBody': 'Csatlakoztass egy adatforrást, hogy az élő artefaktum valódi adatokat használjon helykitöltők helyett.',
  'newproj.connectorsEmptyCta': 'Kapcsolók beállítása →',
  'newproj.connectorsLoading': 'Kapcsolók betöltése…',
  'newproj.connectorsCountOne': '{n} csatlakoztatva',
  'newproj.connectorsCountMany': '{n} csatlakoztatva',
  'newproj.connectorsManage': 'Kezelés',
  'newproj.promptTemplateLabel': 'Hivatkozási sablon',
  'newproj.promptTemplateNoneTitle': 'Nincs — saját megfogalmazás',
  'newproj.promptTemplateNoneSub': 'Hagyd ki a galériát, írd le a saját brieffed',
  'newproj.promptTemplateRefSub': 'Hivatkozási sablon',
  'newproj.promptTemplateSearch': 'Sablonok keresése…',
  'newproj.promptTemplateEmpty': 'Még nincs telepített sablon ehhez a felülethez.',
  'newproj.promptTemplateBodyLabel': 'Prompt (módosítható)',
  'newproj.promptTemplateOptimizeHint': 'Bármit módosíthatsz — a változtatásaid beépülnek az ügynök briefjébe.',
  'newproj.promptTemplateBodyEmpty': 'Üres törzs — az ügynök nem kap sablonhivatkozást.',
  'newproj.deleteTemplateTitle': 'Sablon törlése',
  'newproj.deleteTemplateConfirm': 'Törlöd a(z) „{name}" sablont? Ez nem vonható vissza.',
  'newproj.deleteTemplateConfirmCta': 'Sablon törlése',
  'newproj.deleteTemplateError': 'A sablon törlése nem sikerült. Próbáld újra.',
  'designs.subRecent': 'Legutóbbi',
  'designs.subYours': 'A te terveid',
  'designs.filterAria': 'Projektek szűrése',
  'designs.searchPlaceholder': 'Keresés…',
  'designs.emptyNoProjects': 'Még nincs projekt.',
  'designs.emptyNoMatch': 'Egy projekt sem felel meg a keresésnek.',
  'designs.deleteTitle': 'Projekt törlése',
  'designs.deleteConfirm': 'Törlöd a(z) „{name}" projektet?',
  'designs.cardFreeform': 'szabad formátum',
  'designs.badgeLive': 'Élő',
  'designs.liveArtifactBadgesAria': 'Élő artifact jelvények',
  'designs.liveCount': '{n} élő',
  'designs.statusLive': 'Élő artifact',
  'designs.statusArchived': 'Archivált',
  'designs.statusError': 'Hiba',
  'designs.statusRefreshing': 'Frissítés…',
  'designs.statusRefreshFailed': 'A frissítés sikertelen',
  'designs.statusRefreshed': 'Frissítve',
  'designs.status.notStarted': 'Nem kezdődött el',
  'designs.status.queued': 'Sorban',
  'designs.status.running': 'Fut',
  'designs.status.awaitingInput': 'Bevitelre vár',
  'designs.status.succeeded': 'Befejezve',
  'designs.status.published': 'Közzétéve',
  'designs.status.failed': 'Sikertelen',
  'designs.status.canceled': 'Megszakítva',
  'designs.viewToggleAria': 'Nézet módja',
  'designs.viewGrid': 'Rácsnézet',
  'designs.viewKanban': 'Tábla nézet',
  'designs.kanbanEmptyColumn': 'Nincs terv',
  'designs.deleteAria': '{name} projekt törlése',
  'designs.menuMore': 'További műveletek',
  'designs.menuRename': 'Átnevezés',
  'designs.menuDelete': 'Törlés',
  'designs.renamePrompt': 'Új név ehhez: „{name}”',
  'designs.selectMode': 'Kijelölés',
  'designs.cancelSelect': 'Mégse',
  'designs.deleteSelected': 'Kijelöltek törlése',
  'designs.selectedCount': '{n} kijelölve',
  'designs.deleteSelectedConfirm': 'Töröl {n} projektet?',
  'designs.deleteSelectedSuccess': '{n} projekt sikeresen törölve.',
  'designs.deleteSelectedPartial': '{deleted} projekt törölve; {failed} sikertelen.',
  'designs.tagPrototype': 'Prototípus',
  'designs.tagLiveArtifact': 'Élő elem',
  'designs.tagSlide': 'Dia',
  'designs.tagMedia': 'Média',
  'designs.renameTitle': 'Projekt átnevezése',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'Mégse',
  'examples.typeLabel': 'Típus',
  'examples.surfaceLabel': 'Felület',
  'examples.surfaceWeb': 'Web',
  'examples.surfaceImage': 'Kép',
  'examples.surfaceVideo': 'Videó',
  'examples.surfaceAudio': 'Hang',
  'examples.scenarioLabel': 'Forgatókönyv',
  'examples.modeAll': 'Mind',
  'examples.modePrototypeDesktop': 'Prototípusok · Asztali',
  'examples.modePrototypeMobile': 'Prototípusok · Mobil',
  'examples.modeDeck': 'Diák',
  'examples.modeDocument': 'Dokumentumok és sablonok',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'Élő',
  'examples.scenarioGeneral': 'Általános',
  'examples.scenarioEngineering': 'Mérnöki',
  'examples.scenarioProduct': 'Termék',
  'examples.scenarioDesign': 'Dizájn',
  'examples.scenarioMarketing': 'Marketing',
  'examples.scenarioSales': 'Értékesítés',
  'examples.scenarioFinance': 'Pénzügy',
  'examples.scenarioHr': 'HR',
  'examples.scenarioOperations': 'Operáció',
  'examples.scenarioSupport': 'Ügyfélszolgálat',
  'examples.scenarioLegal': 'Jogi',
  'examples.scenarioEducation': 'Oktatás',
  'examples.scenarioPersonal': 'Személyes',
  'examples.searchPlaceholder': 'Példák keresése…',
  'examples.searchAria': 'Példák keresése név alapján',
  'examples.emptyNoSkills': 'Nincs elérhető skill. Fut a daemon?',
  'examples.emptyNoMatch': 'Egy példa sem felel meg ezeknek a szűrőknek.',
  'examples.openPreview': '⤢ Előnézet megnyitása',
  'examples.loadingPreview': 'Előnézet betöltése…',
  'examples.hoverPreview': 'Vidd fölé az egeret az előnézethez',
  'examples.usePrompt': 'Használd ezt a promptot',
  'examples.previewModalTitle': 'Teljes előnézet (modális)',
  'examples.shareTitle': 'Példa megosztása',
  'examples.shareLoadFirst': 'Vidd fölé az egeret az előnézet betöltéséhez',
  'examples.unavailablePlaceholder': 'Nincs mellékelt {kind} előnézet — nyisd meg a részletekért',
  'examples.shareUnavailable': 'Nincs megosztható {kind} előnézet mellékelve',
  'examples.shareMenu': 'Megosztás ▾',
  'examples.exportPdfAllSlides': 'Exportálás PDF-ként (minden dia)',
  'examples.exportPptxLocked': 'Exportálás PPTX-ként… (előbb sablont nyiss)',
  'examples.tagSlideDeck': 'Diavetítés',
  'examples.tagTemplate': 'Sablon',
  'examples.tagDesignSystem': 'Designrendszer',
  'examples.tagMobilePrototype': 'Mobil prototípus',
  'examples.tagDesktopPrototype': 'Asztali prototípus',
  'examples.tagImage': 'Kép',
  'examples.tagVideo': 'Videó',
  'examples.tagAudio': 'Hang',
  'examples.previewLabel': 'Előnézet',
  'ds.surfaceLabel': 'Felület',
  'ds.surfaceWeb': 'Web',
  'ds.surfaceImage': 'Kép',
  'ds.surfaceVideo': 'Videó',
  'ds.surfaceAudio': 'Hang',
  'ds.searchPlaceholder': 'Designrendszerek keresése…',
  'ds.emptyNoMatch': 'Egy designrendszer sem felel meg a keresésnek.',
  'ds.badgeDefault': 'ALAPÉRT.',
  'ds.preview': 'Előnézet',
  'ds.previewTitle': 'Designrendszer előnézete',
  'ds.categoryAll': 'Mind',
  'ds.categoryUncategorized': 'Kategorizálatlan',
  'ds.showcase': 'Bemutató',
  'ds.tokens': 'Tokenek',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'DESIGN.md betöltése…',
  'avatar.title': 'Fiók és beállítások',
  'avatar.localCli': 'Helyi CLI',
  'avatar.anthropicApi': 'Anthropic API',
  'avatar.useLocal': 'Helyi CLI használata',
  'avatar.useApi': 'API · BYOK használata',
  'avatar.codeAgent': 'Kód-ügynök',
  'avatar.rescan': 'PATH újraellenőrzése',
  'avatar.amrConsole': 'AMR-fiók',
  'avatar.amrConsoleMeta': 'Egyenleg és feltöltés',
  'avatar.settings': 'Beállítások',
  'avatar.backToProjects': 'Vissza a projektekhez',
  'avatar.metaActive': 'aktív',
  'avatar.metaOffline': 'offline',
  'avatar.metaSelected': 'kiválasztva',
  'avatar.noAgentSelected': 'nincs kiválasztott ügynök',
  'avatar.modelSection': 'Modell',
  'avatar.modelLabel': 'Modell',
  'avatar.reasoningLabel': 'Gondolkodás',
  'avatar.customSuffix': '(egyedi)',
  'socialShare.openDesignSection': 'Open Design megosztása',
  'socialShare.openDesignTitle': 'Open Design a GitHubon',
  'socialShare.openDesignText': 'Az Open Design egy nyílt forráskódú munkaterület tervezési elemek létrehozásához, szerkesztéséhez, telepítéséhez és átadásához.',
  'socialShare.openDesignCopyText': '{text}\n{url}',
  'socialShare.projectSection': 'MEGOSZTÁS KÖZÖSSÉGI MÉDIÁN',
  'socialShare.publishPageTitle': 'Megosztási oldal közzététele',
  'socialShare.publishPageSubtitle': 'Tedd közzé ezt az előnézetet, hogy megosztható legyen közösségi platformokon.',
  'socialShare.projectTitle': '{title} · Open Design',
  'socialShare.projectText': 'Open Design segítségével készült: {title}. Tekintsd meg a telepített elemet, és csillagozd a repót: {repo}',
  'socialShare.projectCopyText': 'Open Design segítségével készült: {title}\n{url}\nOpen Design repó: {repo}',
  'socialShare.deployFirst': 'Telepítés, majd megosztás…',
  'socialShare.copied': 'Másolva',
  'socialShare.platform.x': 'X',
  'socialShare.platform.linkedin': 'LinkedIn',
  'socialShare.platform.facebook': 'Facebook',
  'socialShare.platform.reddit': 'Reddit',
  'socialShare.platform.telegram': 'Telegram',
  'socialShare.platform.whatsapp': 'WhatsApp',
  'socialShare.platform.weibo': 'Weibo',
  'socialShare.platform.line': 'LINE',
  'socialShare.platform.instagram': 'Instagram',
  'socialShare.platform.xiaohongshu': 'Xiaohongshu',
  'inlineSwitcher.chipTitle': 'CLI / modell váltása',
  'inlineSwitcher.chipCli': 'Helyi CLI',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'alapértelmezett',
  'inlineSwitcher.noAgent': 'nincs ügynök',
  'inlineSwitcher.modeLabel': 'Mód',
  'inlineSwitcher.agentLabel': 'Ügynök',
  'inlineSwitcher.providerLabel': 'Szolgáltató',
  'inlineSwitcher.modelLabel': 'Modell',
  'inlineSwitcher.useCli': 'Helyi CLI használata',
  'inlineSwitcher.useByok': 'Saját API-kulcs használata',
  'inlineSwitcher.daemonOffline': 'A démon offline — nyisd meg a beállításokat',
  'inlineSwitcher.noAgentsDetected': 'Nincs CLI a PATH-ban',
  'inlineSwitcher.openSettingsForModel': 'Állítsd be a szolgáltatót a Beállításokban',
  'inlineSwitcher.missingApiKey': 'Hiányzó API-kulcs — add hozzá a Beállításokban.',
  'inlineSwitcher.openFullSettings': 'Végrehajtási beállítások megnyitása',
  'inlineSwitcher.customSuffix': '(egyedi)',
  'project.backToProjects': 'Vissza a projektekhez',
  'project.brandReadyTitle': 'A(z) {name} dizájnrendszer kész',
  'project.brandReadyTitleGeneric': 'A dizájnrendszered kész',
  'project.brandReadyCta': 'Megtekintés a Tervezőrendszerekben',
  'project.brandReadyDismiss': 'Elvetés',
  'project.brandReadyRefineHint': 'Automatic extraction can miss details. Refine it before using this system broadly.',
  'project.brandReadyAiOptimize': 'AI Optimize',
  'project.brandReadyEditManually': 'Edit manually',
  'project.brandReadyPreviewOpened': 'Designrendszer előnézete megnyitva.',
  'project.metaFreeform': 'szabad formátum',
  'project.customInstructions': 'Projektutasítások',
  'project.customInstructionsPlaceholder': 'Utasítások ehhez a projekthez (minden üzenetbe beillesztve)…',
  'project.resizeChatPanel': 'Csevegőpanel átméretezése',
  'project.instructionsActive': 'Aktív – minden üzenethez hozzáadva',
  'project.missing': 'This project has been deleted or no longer exists.',
  'chat.tabChat': 'Csevegés',
  'chat.tabComments': 'Megjegyzések',
  'chat.commentsSoon': 'Megjegyzések — hamarosan',
  'chat.comments.attached': 'Csevegéshez csatolva',
  'chat.comments.emptyAttached': 'Nincs csatolt megjegyzés.',
  'chat.comments.saved': 'Mentett megjegyzések',
  'chat.comments.emptySaved': 'Nincsenek mentett megjegyzések.',
  'chat.comments.add': 'Hozzáadás',
  'chat.comments.addAll': 'Összes hozzáadása',
  'chat.comments.remove': 'Eltávolítás',
  'chat.comments.placeholder': 'Megjegyzés ehhez az elemhez…',
  'chat.comments.addSend': 'Hozzáadás és küldés',
  'chat.comments.updateSend': 'Frissítés és küldés',
  'chat.comments.removeAttachment': 'Megjegyzéscsatolmány eltávolítása',
  'chat.comments.removeAttachmentAria': 'Megjegyzéscsatolmány eltávolítása ehhez: {name}',
  'chat.comments.comment': 'Megjegyzés',
  'chat.comments.sendToChat': 'Küldés a csevegésbe',
  'chat.comments.sending': 'Küldés…',
  'chat.comments.edit': 'Szerkesztés',
  'chat.comments.select': 'Kijelölés',
  'chat.comments.selectAll': 'Összes kijelölése',
  'chat.comments.deselect': 'Kijelölés megszüntetése',
  'chat.comments.nSelected': '{n} kijelölve',
  'chat.comments.pin': 'Rögzítés',
  'chat.comments.addNote': 'Jegyzet hozzáadása',
  'chat.comments.savedToast': 'Megjegyzés elmentve',
  'chat.comments.pinSavedToast': 'Rögzítés elmentve',
  'chat.comments.pinAtCoords': 'at {x}, {y}',
  'chat.comments.capturedItems': '{n} rögzített elem',
  'chat.comments.clear': 'Törlés',
  'chat.comments.targetImage': 'Kép',
  'chat.comments.targetControl': 'Vezérlés',
  'chat.comments.targetLink': 'Hivatkozás',
  'chat.comments.targetText': 'Szöveg',
  'chat.comments.targetSection': 'Szakasz',
  'chat.comments.targetPage': 'Oldal',
  'chat.comments.targetArea': 'Terület',
  'chat.annotationNotePlaceholder': 'Jegyzet hozzáadása ehhez a jelöléshez',
  'chat.annotationAttachImage': 'Kép csatolása',
  'chat.annotationAttachedImages': 'Csatolt képek',
  'chat.annotationAttachedRemove': 'Utolsó kép eltávolítása',
  'chat.annotationAddToInput': 'Hozzáadás a bemenethez',
  'chat.annotationAddingToInput': 'Hozzáadás...',
  'chat.annotationQueue': 'Sorba állítás',
  'chat.annotationQueueing': 'Sorba állítás...',
  'chat.annotationSending': 'Küldés...',
  'chat.annotationSendDisabledReason': 'Jelenleg fut egy feladat',
  'chat.annotationPreviewMissing': 'Nem sikerült rögzíteni az előnézetet. Kérjük, próbálja újra.',
  'chat.annotationPreviewMissingInk': 'Nem sikerült rögzíteni az előnézetet. Próbálja újra, hogy ne csak a tinta legyen elküldve.',
  'chat.annotationSentWithoutScreenshot': 'Nem sikerült rögzíteni az előnézetet. A jegyzet képernyőkép nélkül lett elküldve.',
  'chat.annotationTimeout': 'Az annotáció küldése időtúllépés miatt megszakadt. Kérjük, próbálja újra.',
  'chat.annotationFailed': 'Az annotáció küldése nem sikerült. Kérjük, próbálja újra.',
  'chat.annotationProjectCreateFailed': 'Nem sikerült projektet létrehozni, ezért az annotáció nem lett elküldve.',
  'chat.annotationUploadFailed': 'A melléklet feltöltése nem sikerült. Kérjük, próbálja újra.',
  'chat.conversationsTitle': 'Beszélgetések',
  'chat.conversationsAria': 'Beszélgetések előzménye',
  'chat.newConversation': 'Új beszélgetés',
  'chat.newConversationsTitle': 'Új beszélgetés',
  'chat.conversationsHeading': 'Beszélgetések',
  'chat.new': 'Új',
  'chat.emptyConversations': 'Még nincs beszélgetés.',
  'chat.deleteConversation': 'Beszélgetés törlése',
  'chat.renameConversationLabel': '„{title}” átnevezése',
  'chat.deleteConversationConfirm': 'Törlöd a(z) „{title}" beszélgetést? Ez eltávolítja az üzeneteit.',
  'chat.untitledConversation': 'Cím nélküli beszélgetés',
  'chat.forkedConversationTitle': '{title} elágazás',
  'chat.forkConversationFailed': 'Nem sikerült forkot létrehozni ebből a beszélgetésből.',
  'chat.startTitle': 'Indíts beszélgetést',
  'chat.startHint': 'Írd le, mit szeretnél létrehozni, vagy indulj ki az egyik példából:',
  'chat.brandBrowserAssistDesktopOnly': 'Browser assist needs the desktop app so Open Design can read the live browser page.',
  'chat.brandBrowserAssistReadFailed': 'Could not read the browser page. Make sure the brand site is open and fully loaded.',
  'chat.brandBrowserAssistMessage': 'Open Design needs browser assist to finish this brand extraction. Clear the page in the Browser tab, then confirm below.',
  'brandEnrichment.title': "AI-optimalizálás",
  'brandEnrichment.body': "Az Open Design mélyebb kinyerést futtat a háttérben, automatikusan alkalmazza a megfelelő design system skilleket, és helyben frissíti ezt a rendszert. Ez 10-20 percig tarthat; közben dolgozhatsz tovább.",
  'brandEnrichment.cta': "AI-optimalizálás",
  'brandEnrichment.busy': "AI-optimalizálás indítása...",
  'brandExtractionTranscript.sourceDesignMd': 'beillesztett DESIGN.md',
  'brandExtractionTranscript.user': 'Designrendszer kinyerése innen: {source}.',
  'brandExtractionTranscript.doneTitle': 'A(z) {name} programozott kinyerése befejeződött.',
  'brandExtractionTranscript.doneBody': 'Létrehoztam és regisztráltam a(z) {designSystemId} designrendszert innen: {source}. Már előnézetben megnyitható és új designokban használható.',
  'brandExtractionTranscript.next': 'Ezután futtathatod az AI Optimize műveletet egy mélyebb kinyeréshez, vagy létrehozhatsz egy új designt ezzel a rendszerrel.',
  'chat.fillInputTitle': 'Kattints a beviteli mező kitöltéséhez',
  'chat.jumpToLatest': 'Ugrás a legutóbbira',
  'chat.scrollToLatest': 'Görgetés a legutóbbira',
  'chat.you': 'Te',
  'chat.openFile': '{name} megnyitása',
  'chat.copyPrompt': 'Prompt másolása',
  'chat.copyErrorDiagnostic': 'Hibadiagnosztika másolása',
  'chat.copyDone': 'Másolva!',
  'chat.inspect.noEditableTargets': 'This page has no editable elements yet.',
  'chat.inspect.noCommentTargets': 'This page has no commentable elements yet.',
  'chat.inspect.editHint': 'Click an element in the canvas to edit its styles.',
  'chat.inspect.commentHint': 'Click an element in the canvas to add a comment.',
  'chat.composerPlaceholder': 'Írd le, mit szeretnél létrehozni…',
  'chat.activeFileEditingLabel': 'Szerkesztés',
  'chat.activeFilePlaceholder': 'Kérd meg az Open Designt, hogy módosítsa: {file}...',
  'chat.designArtifactsShowMore': 'További {count} tervfájl megjelenítése',
  'chat.mode.chat.label': 'Kérdezés',
  'chat.mode.chat.title': 'Kérdezés mód',
  'chat.mode.chat.summary': 'Gyors válaszokhoz, javításokhoz, tervezéshez és beszélgetéshez, anélkül hogy kötelezően design kimenetet készítene.',
  'chat.mode.chat.solves': 'Használd ötletek tisztázására, promptok finomítására, opciók összevetésére vagy meglévő munka megbeszélésére.',
  'chat.mode.chat.query1': 'Foglalod össze ezt a vázlatot, és mutasd meg a hiányosságokat.',
  'chat.mode.chat.query2': 'Segíts eldönteni a legjobb struktúrát ehhez a landing page-hez.',
  'chat.mode.chat.query3': 'Nézd át ezt a designt, és adj konkrét javítási javaslatokat.',
  'chat.mode.design.label': 'Tervezés',
  'chat.mode.design.title': 'Tervezés mód',
  'chat.mode.design.summary': 'Konkrét kimenetek létrehozásához vagy módosításához: oldalak, prototípusok, live artifactek, diák, képek, videók, HyperFrames, audió, dashboardok és projektfájlok.',
  'chat.mode.design.solves': 'Akkor használd, ha az Open Designnak fájlokat kell generálnia, frissítenie kell a workspace-t, vagy briefből multimodális eredményt kell készítenie.',
  'chat.mode.design.query1': 'Készíts termékbevezető landing page-et és HyperFrames prototípust ebből a briefből.',
  'chat.mode.design.query2': 'Készíts 10 diás befektetői decket előadói jegyzetekkel.',
  'chat.mode.design.query3': 'Készíts kép-, videó- és audióötleteket ehhez a kampányhoz.',
  'chat.mode.cardBestFor': 'Erre jó',
  'chat.mode.cardTry': 'Példakérések',
  'chat.composerHint': '⌘/Ctrl + Enter küldéshez · add meg a célt, tartalmat, stílust és formátumot',
  'chat.cliSettingsTitle': 'CLI- és modellbeállítások',
  'chat.cliSettingsAria': 'CLI- és modellbeállítások megnyitása',
  'chat.attachTitle': 'Fájlok csatolása (vagy beillesztés / húzás)',
  'chat.addContextTitle': 'Add context',
  'chat.attachAria': 'Fájlok csatolása',
  'chat.importTitle': 'Források importálása (hamarosan)',
  'chat.importLabel': 'Importálás',
  'chat.importComingSoon': 'Hamarosan',
  'chat.importSoon': 'Hamarosan',
  'chat.importFig': '.fig fájl feltöltése',
  'chat.importGitHub': 'GitHub csatlakoztatása',
  'chat.importWeb': 'Webelem mentése',
  'chat.importFolder': 'Kódmappa hozzákapcsolása',
  'chat.importSkills': 'Skillek és designrendszerek',
  'chat.importProject': 'Hivatkozás egy másik projektre',
  'chat.importDesignSystemHeader': 'Válassz designrendszert',
  'chat.importDesignSystemBack': 'Vissza',
  'chat.importDesignSystemSearch': 'Designrendszerek keresése…',
  'chat.importDesignSystemEmpty': 'Nincs a(z) "{query}"-hoz illeszkedő designrendszer',
  'chat.importDesignSystemNone': 'Nincs — szabad',
  'chat.importDesignSystemNoneSub': 'Most ne kötődj egyik rendszerhez sem',
  'chat.importDesignSystemActive': 'Aktív',
  'chat.importDesignSystemSwitched': 'Designrendszer átállítva: {title}',
  'chat.importDesignSystemFailed': 'Nem sikerült váltani a designrendszert. Próbáld újra.',
  'chat.importDesignSystemLoadFailed': 'Nem sikerült betölteni a designrendszereket.',
  'browserUse.title': 'Inspiráció',
  'browserUse.summary': '{count} webes művelet, előtérbe helyezve az eszközök kinyerését, a designnyelvet, a mozgást, a vizuális ellenőrzéseket és a komponensszerkezetet.',
  'browserUse.searchAria': 'Inspiráció keresése',
  'browserUse.searchPlaceholder': 'Képernyőképek, betűtípusok, színek, a11y keresése...',
  'browserUse.empty': 'Nincs egyező inspiráció',
  'browserUse.unavailable': 'Az inspiráció itt nem érhető el',
  'browserUse.added': 'Hozzáadva a szerkesztőhöz',
  'browserUse.category.assets': 'Eszközök kinyerése',
  'browserUse.category.tokens': 'Designnyelv',
  'browserUse.category.motion': 'Mozgás',
  'browserUse.category.visual': 'Vizuális ellenőrzések',
  'browserUse.category.structure': 'Komponensek',
  'browserUse.category.project': 'Projektfuttatás',
  'browserUse.category.general': 'Általános',
  'browserUse.input.none': 'Nincs bemenet',
  'browserUse.input.assetKind': 'kind: images | svgs | media | fonts, limit=200',
  'browserUse.input.optionalSelector': 'Opcionális szelektor',
  'browserUse.input.requirementSelector': 'Követelmény, opcionális szelektor',
  'browserUse.input.selectorOptional': 'Opcionális szelektor',
  'browserUse.input.scaleOne': 'scale=1',
  'browserUse.input.selectorScaleTwo': 'Szelektor, scale=2',
  'browserUse.input.gridOverlay': '12 oszlop, max. 1200, térköz 24',
  'browserUse.input.bodySelector': 'selector=\'body\'',
  'browserUse.input.navigate': 'URL, domain vagy keresési kifejezések',
  'browserUse.input.selector': 'Szelektor',
  'browserUse.input.selectorText': 'Szelektor és szöveg',
  'browserUse.input.scroll': 'Pixel, felül, alul vagy oldal',
  'browserUse.input.terminalRun': 'Parancs, időtúllépés 120 mp',
  'browserUse.input.command': 'Parancs',
  'browserUse.input.maxChars': 'maxChars=8000',
  'browserUse.input.custom': '{input}',
  'browserUse.action.extract_logo.output': 'A legjobb logójelöltek a fejlécből, navigációból, osztálynevekből, pozícióból, OG-képből, valamint favicon tartalékként.',
  'browserUse.action.list_images.output': 'Minden img, srcset, source és CSS háttérkép méretekkel és alt szöveggel.',
  'browserUse.action.download_assets.output': 'Letöltött eszközmappa, valamint _manifest.json referer és cookie támogatással.',
  'browserUse.action.extract_svgs.output': 'Beágyazott SVG-k és hivatkozott .svg fájlok külön SVG fájlokként mentve.',
  'browserUse.action.optimize_svgs.output': 'Optimalizált SVG fájlok, valamint tömörítési arány.',
  'browserUse.action.extract_colors.output': 'Súlyozott paletta, valamint :root CSS színváltozók palette.json és palette.html formátumban.',
  'browserUse.action.extract_fonts.output': 'A leggyakoribb betűtípuscsaládok, méretek, vastagságok és @font-face szabályok typography.json formátumban.',
  'browserUse.action.extract_design_tokens.output': 'Sugár, árnyék, térköz és CSS-változók tokens.json fájlként.',
  'browserUse.action.extract_type_scale.output': 'Címsor-, törzsszöveg- és gombtípus-skála mérettel, vastagsággal, sormagassággal és arányokkal.',
  'browserUse.action.extract_buttons.output': 'Duplikátumoktól megtisztított gombstílus-könyvtár buttons.html és buttons.json fájlként.',
  'browserUse.action.extract_grid_system.output': 'Grid- és flex-konténerek, irány, közök, oszlopok és maximális szélességek layout.json fájlként.',
  'browserUse.action.extract_breakpoints.output': 'Reszponzív media query töréspontok breakpoints.json fájlként.',
  'browserUse.action.extract_gradients.output': 'CSS-színátmenetek gradients.css, gradients.json és előnézeti HTML formátumban.',
  'browserUse.action.extract_shadows.output': 'Dobozárnyékok, szövegárnyékok és vetett árnyékok shadows.json fájlként, előnézettel együtt.',
  'browserUse.action.extract_easings.output': 'Átmenet- és animáció-időzítő (easing) függvények easings.json fájlként.',
  'browserUse.action.export_tokens.output': 'tokens.css, tokens.scss, tailwind.theme.js és style-dictionary.tokens.json.',
  'browserUse.action.extract_animations.output': '@keyframes, átmenet- és transzformációs szabályok, észlelt mozgáskönyvtárak, motion.css és motion.json.',
  'browserUse.action.validate_view.output': 'Képernyőkép-útvonalak, valamint strukturált vizuális és elrendezési problémák.',
  'browserUse.action.audit_layout.output': 'Elrendezési hibák, beleértve a túlcsordulást, a határátlépést, az átfedést és a levágott szöveget audit.json fájlként.',
  'browserUse.action.audit_accessibility.output': 'Akadálymentesítési problémák szelektorokkal, címkékkel, szerepekkel, fókusszal, kontraszttal és ahol hasznos, képernyőképekkel.',
  'browserUse.action.responsive_screenshots.output': 'Mobil 390, tablet 834 és asztali 1440 képernyőképek.',
  'browserUse.action.screenshot_full.output': 'Teljes oldalas képernyőkép a látómezőn túl.',
  'browserUse.action.screenshot_element.output': 'Egyetlen elem képernyőképe alapértelmezetten 2x méretben.',
  'browserUse.action.screenshot_with_grid.output': 'Képernyőkép elrendezési rács átfedéssel.',
  'browserUse.action.screenshot_dark_mode.output': 'Képernyőkép prefers-color-scheme: dark beállítással.',
  'browserUse.action.generate_styleguide.output': 'Egyoldalas stílusútmutató színekkel, típusskálával, sugárral és árnyékokkal.',
  'browserUse.action.extract_html.output': 'Tiszta, önálló HTML script, noscript és beágyazott eseménykezelő attribútumok nélkül.',
  'browserUse.action.extract_component_inventory.output': 'Ismétlődő komponensmintázatok, szelektorok, darabszámok és képernyőképek.',
  'browserUse.action.extract_copy.output': 'Címsorok, CTA-k, törzsszöveg és leírások copy.md és copy.json fájlként.',
  'browserUse.action.extract_nav.output': 'Elsődleges navigációs és lábléc-hivatkozások sitemap.md és nav.json fájlként.',
  'browserUse.action.extract_forms.output': 'Űrlapmezők, címkék, validációs súgók és beküldési műveletek forms.json fájlként.',
  'browserUse.action.run_project.output': 'Az észlelt fejlesztői szerver URL-je a Browser fülön megnyitva.',
  'browserUse.action.detect_project.output': 'Keretrendszer, csomagkezelő, telepítési parancs, fejlesztői parancs és port.',
  'browserUse.action.page_info.output': 'URL, cím, leírás, OG-kép, témaszín, favicon és viewport.',
  'browserUse.action.snapshot.output': 'Legfeljebb 120 látható interaktív és szöveges elem tag-gel, címkével, href-fel és koordinátákkal.',
  'browserUse.action.navigate.output': 'Nyisd meg az oldalt, és add vissza a page_info adatokat.',
  'browserUse.action.click.output': 'Kattints az első egyező elemre, miután a látómezőbe görgetted.',
  'browserUse.action.type_text.output': 'Tölts ki egy beviteli mezőt, és váltsd ki az input és change eseményeket.',
  'browserUse.action.scroll.output': 'Aktuális és maximális görgetési pozíció.',
  'browserUse.action.extract_og_metadata.output': 'Meta cím, leírás, kanonikus URL, OG/Twitter kártyák, közösségi kép és témaszín.',
  'browserUse.action.terminal_run.output': 'stdout, stderr és kilépési kód.',
  'browserUse.action.terminal_run_background.output': 'Háttérfeladat azonosítója és legutóbbi kimenete.',
  'browserUse.action.terminal_read.output': 'Legutóbbi megosztott terminálkimenet.',
  'chat.designToolbox.title': 'Tervezői eszköztár',
  'chat.designToolbox.tooltip': 'Tervezői eszköztár',
  'chat.designToolbox.aria': 'Tervezői eszköztár megnyitása',
  'chat.designToolbox.searchPlaceholder': 'Készségek / MCP / bővítmények / csatlakozók / tervfájlok keresése...',
  'chat.designToolbox.searchAria': 'Tervezői eszköztár erőforrásainak keresése',
  'chat.designToolbox.followupSection': 'Folytatás',
  'chat.designToolbox.resourcesSection': 'Globális erőforrások',
  'chat.designToolbox.selected': 'Kiválasztva',
  'chat.designToolbox.noResources': 'Nincs erőforrás a következőhöz: "{query}".',
  'chat.designToolbox.badge.video': 'Videó',
  'chat.designToolbox.badge.image': 'Kép',
  'chat.designToolbox.badge.motion': 'Mozgás',
  'chat.designToolbox.badge.polish': 'Finomítás',
  'chat.designToolbox.action.auto-match.title': 'Következő lépés egyeztetése',
  'chat.designToolbox.action.auto-match.badge': 'Egyeztetés',
  'chat.designToolbox.action.auto-match.description': 'Előbb határozd meg az ízlésszintet, majd egyeztesd a készségeket, az MCP-t, a bővítményeket, a csatlakozókat és a fájlokat.',
  'chat.designToolbox.action.motion.title': 'Animáció / mozgás hozzáadása',
  'chat.designToolbox.action.motion.badge': 'Mozgás',
  'chat.designToolbox.action.motion.description': 'Adj belépési, görgetési, állapotátmeneti és mikrointerakciós mozgást az aktuális HTML-hez vagy oldalelemhez.',
  'chat.designToolbox.action.motion-polish.title': 'Mozgás finomítása',
  'chat.designToolbox.action.motion-polish.badge': 'Időzítés',
  'chat.designToolbox.action.motion-polish.description': 'Tekintsd át a meglévő mozgás időzítését, easing függvényeit, teljesítményét és a csökkentett mozgáshoz tartozó tartalék megoldásait.',
  'chat.designToolbox.action.anti-ai-polish.title': 'AI-érzet eltávolítása',
  'chat.designToolbox.action.anti-ai-polish.badge': 'Ízlés',
  'chat.designToolbox.action.anti-ai-polish.description': 'Távolítsd el a sablonos érzetet, az AI-gradienseket, az olcsó kártyahalmokat és a homályos szövegeket.',
  'chat.designToolbox.action.visual-polish.title': 'Dizájn finomítása / kiadásra kész',
  'chat.designToolbox.action.visual-polish.badge': 'Finomítás',
  'chat.designToolbox.action.visual-polish.description': 'Ellenőrizd a vizuális hierarchiát, a tipográfiát, a térközöket, a reszponzív viselkedést, az akadálymentességet és a kiszállítás minőségét.',
  'chat.designToolbox.action.image-gen.title': 'Képek / vizuális referenciák generálása',
  'chat.designToolbox.action.image-gen.badge': 'Kép',
  'chat.designToolbox.action.image-gen.description': 'Szakaszreferenciák, eszközök, ikonok, közösségi képek vagy moodboard generálása az aktuális oldalhoz.',
  'chat.designToolbox.action.video-gen.title': 'Videó / mozgásszkript generálása',
  'chat.designToolbox.action.video-gen.badge': 'Videó',
  'chat.designToolbox.action.video-gen.description': 'Alakítsd a dizájnt rövid videóvá, Remotion / Hyperframes storyboarddá vagy generálásra kész prompttá.',
  'chat.designToolbox.kind.skill': 'Skill',
  'chat.designToolbox.kind.plugin': 'Plugin',
  'chat.designToolbox.kind.mcp': 'MCP',
  'chat.designToolbox.kind.mcpTemplate': 'MCP-sablon',
  'chat.designToolbox.kind.connector': 'Csatlakozó',
  'chat.designToolbox.kind.designFile': 'Dizájnfájl',
  'chat.designToolbox.context.browser': 'Böngésző',
  'chat.designToolbox.context.designFiles': 'Dizájnfájlok',
  'chat.designToolbox.context.designSystem': 'Dizájnrendszer',
  'chat.designToolbox.context.folder': 'Mappa',
  'chat.designToolbox.context.terminal': 'Terminál',
  'chat.designToolbox.context.sideChat': 'Oldalsó csevegés',
  'chat.designToolbox.context.liveArtifact': 'Élő artifact',
  'chat.designToolbox.context.file': 'Fájl',
  'chat.designToolbox.prompt.contextGeneric': 'Aktuális célpont: a jelenleg megnyitott HTML / dizájnfájl / webelem.',
  'chat.designToolbox.prompt.contextSpecific': 'Aktuális cél: {kind} · {label}.',
  'chat.designToolbox.prompt.preserveDraft': 'Őrizd meg a szerkesztőben már meglévő szándékot: {draft}',
  'chat.designToolbox.prompt.selectedSkill': 'Kiválasztott skill: {skill}. Használd ezt elsődleges munkafolyamatként ebben a körben.',
  'chat.designToolbox.prompt.noSkill': 'Ha nincs konkrét egyező skill, először válaszd ki a legjobb kombinációt az elérhető skillek, MCP-k, pluginok, csatlakozók és dizájnfájlok közül.',
  'chat.designToolbox.prompt.autoMatchIntro': 'Lépj fel kreatívigazgató-orchestratorként, és fejezz be egy dizájn-munkafolyamatot:',
  'chat.designToolbox.prompt.autoMatchStep1': '1. Először határozd meg, mit jelent a „jól kinéző dizájn”: célközönség, üzleti cél, márkaérzet, stílusreferenciák, információsűrűség, szín-/tipográfia-/mozgás-/asset-szabványok, valamint a kerülendő AI-/sablonmintázatok.',
  'chat.designToolbox.prompt.autoMatchStep2': '2. Keresd át és illeszd hozzá a fenti teljes erőforrásindexet. Ne csak a dizájn-eszköztár ajánlásait használd; ahol hasznos, kombináld a skilleket, MCP-ket, pluginokat, csatlakozókat és dizájnfájlokat.',
  'chat.designToolbox.prompt.autoMatchStep3': '3. Ha a célpont vagy az esztétikai mérce még mindig nem világos, irányíts véges választási lehetőségekkel vagy űrlap jellegű felülettel, és adj meg egy ajánlott alapértelmezést. Ha eléggé világos, hajtsd végre közvetlenül a következő lépést.',
  'chat.designToolbox.prompt.autoMatchStep4': '4. Fejezd be a folyamatot ebben a sorrendben: diagnózis -> stílusirány -> erőforrásválasztás -> konkrét szerkesztés/generálás -> ellenőrzés. Minden lépésnél magyarázd el, miért ezeket az erőforrásokat választottad, és mit kell legközelebb megerősíteni.',
  'chat.designToolbox.prompt.motion': 'Adj kiváló minőségű mozgást az aktuális HTML / oldalelemhez: válaszd ki a leghasznosabb 1-2 belépő, görgetési, állapotátmeneti vagy mikrointerakciós pillanatot. Tartsd visszafogottan, részesítsd előnyben a transform / opacity megoldásokat, és építs be prefers-reduced-motion tartalék megoldásokat.',
  'chat.designToolbox.prompt.motionPolish': 'Vizsgáld felül és finomítsd a meglévő mozgás időzítését, gyorsulását, teljesítményét és akadálymentességét. Távolítsd el a hirtelen, olcsó vagy az olvashatóságot rontó animációkat; szükség esetén használj kifinomultabb idővonalat.',
  'chat.designToolbox.prompt.antiAiPolish': 'Végezz egy AI-érzet elleni finomítási kört: távolítsd el a sablonos elrendezéseket, az olcsó gradienseket/ragyogásokat, az értelmetlen kártyahalmokat és a homályos szövegeket. Őrizd meg az információt, és tedd olyanná, mintha egy valódi dizájner adta volna át.',
  'chat.designToolbox.prompt.visualPolish': 'Finomítsd ezt a dizájnt, amíg kiadásra kész nem lesz: ellenőrizd a hierarchiát, a tipográfiát, a térközöket, a reszponzív viselkedést, a gombállapotokat, az üres/betöltési/hibaállapotokat és az akadálymentességet; közvetlenül javítsd ki a legfontosabb problémákat.',
  'chat.designToolbox.prompt.imageGen': 'Készítsd el a következő vizuáliseszköz-tervet ehhez a dizájnhoz: szakaszreferenciák, hero-eszközök, illusztrációk, ikonok, közösségi képek vagy moodboard. Először döntsd el, milyen típusú kép hiányzik, majd adj végrehajtható generálási prompteket / fájltervet.',
  'chat.designToolbox.prompt.videoGen': 'Fordítsd ezt a dizájnt a videó felé: készíts rövidvideó-storyboardot, Hyperframes / Remotion képkockastruktúrát vagy Sora/fal-ra kész promptot. Részesítsd előnyben, hogy a meglévő HTML / oldaltartalom természetesen váljon felvételekké.',
  'chat.designToolbox.prompt.useSkill': 'Használd a(z) {skill} skillt az aktuális dizájnon.',
  'chat.designToolbox.prompt.skillInstruction': 'Először döntsd el a legjobb következő célt, majd fejezz be egy konkrét kört. Ha külső eszközöktől vagy API-któl függ, adj egy futtatható tartalék megoldást, vagy mondd meg, mit kell biztosítanom.',
  'chat.designToolbox.prompt.selectedResource': 'Kiválasztott erőforrás: {kind} · {title} ({id}).',
  'chat.designToolbox.prompt.resourceDescription': 'Erőforrás leírása: {description}',
  'chat.designToolbox.prompt.pluginResource': 'Használd ezt a plugint az aktuális dizájnfolyamat fő kontextusaként. Ha bemeneteket vagy GenUI-t tesz elérhetővé, szükség esetén irányíts a választásban; ha nem illik a célponthoz, válassz egy jobb globális erőforrást, és magyarázd el, miért.',
  'chat.designToolbox.prompt.mcpResource': 'Részesítsd előnyben ezt az MCP-képességet a következő dizájnlépéshez. Amikor külső eszközökre, webes rögzítésre, kép-/videógenerálásra vagy adatokra van szükség, először döntsd el, hogy elvégzi-e a feladatot, majd adj végrehajtható tervet.',
  'chat.designToolbox.prompt.mcpTemplateResource': 'Ez az MCP egy konfigurálható sablon. Ha ez a leghasznosabb eszköz ehhez a dizájnlépéshez, először irányíts a beállításon; ha létezik konfigurált alternatíva, folytasd azzal az alternatívával.',
  'chat.designToolbox.prompt.connectorResource': 'Használd ezt a csatlakozót, amikor valós adatokra, eszközökre, fióktartalomra vagy külső munkafolyamathoz való hozzáférésre van szükség. Használat előtt magyarázd el, mit fognak olvasni vagy írni, és kérj megerősítést, amikor az helyénvaló.',
  'chat.designToolbox.prompt.fileResource': 'Használd ezt a dizájnfájlt aktuális dizájncélpontként vagy referenciaeszközként, és ebből fejezd be a következő lépést. Ha más fájlokat is össze kell hasonlítani, folytasd a keresést az összes dizájnfájl között.',
  'chat.designToolbox.prompt.resourceIndex': 'Globális erőforrásindex: skillek({skills}), pluginok({plugins}), MCP({mcpEnabled} engedélyezve / {mcpTemplates} sablon), csatlakozók({connectors} csatlakoztatva), dizájnfájlok({files}).',
  'chat.designToolbox.prompt.searchableSkills': 'Kereshető skillek',
  'chat.designToolbox.prompt.searchablePlugins': 'Kereshető pluginok',
  'chat.designToolbox.prompt.availableMcp': 'Elérhető MCP',
  'chat.designToolbox.prompt.connectedConnectors': 'Csatlakoztatott csatlakozók',
  'chat.designToolbox.prompt.referenceDesignFiles': 'Referencia dizájnfájlok',
  'chat.designToolbox.prompt.mcpTemplateName': '{name} sablon',
  'chat.designToolbox.prompt.processRule': 'Munkafolyamat-szabály: először határozd meg az esztétikai célt és a megkötéseket, majd keresd és illeszd hozzá az erőforrásokat; amikor felhasználói választásra van szükség, generálj véges választási lehetőséget kínáló felületet, és megerősítés után folytasd.',
  'chat.designToolbox.prompt.moreSuffix': ', +{count} további',
  'chat.designToolbox.prompt.compactLine': '{label}: {values}{suffix}.',
  'chat.mentionTabsAria': 'Említési felületek',
  'chat.mentionTabAll': 'Mind',
  'chat.mentionTabTabs': 'Lapok',
  'chat.mentionTabPlugins': 'Bővítmények',
  'chat.mentionTabSkills': 'Készségek',
  'chat.mentionTabMcp': 'MCP',
  'chat.mentionTabConnectors': 'Csatlakozók',
  'chat.mentionTabFiles': 'Tervezőfájlok',
  'chat.mentionNoResults': 'Nincs találat erre: „{query}”.',
  'chat.mentionSearchPrompt': 'Tervezőfájlok, lapok, bővítmények, készségek, MCP-kiszolgálók és csatlakozók keresése.',
  'chat.mentionSectionTabs': 'Lapok',
  'chat.mentionSectionPlugins': 'Bővítmények',
  'chat.mentionSectionSkills': 'Készségek',
  'chat.mentionSectionMcp': 'MCP',
  'chat.mentionSectionConnectors': 'Csatlakozók',
  'chat.mentionSectionFiles': 'Tervezőfájlok',
  'chat.mentionActiveSkill': 'Aktív',
  'chat.mentionUseMcpTitle': '{name} használata',
  'chat.mentionUseConnectorTitle': '{name} használata',
  'chat.mentionPluginOfficial': 'Hivatalos',
  'chat.mentionPluginMine': 'Saját bővítmény',
  'chat.linkedFolderRemoveAria': 'Hozzákapcsolt mappa eltávolítása {path}',
  'chat.linkedFolderNotFound': 'A mappa nem létezik',
  'chat.linkedFolderAlready': 'Ez a mappa már hozzá van kapcsolva',
  'chat.linkedFolderPickError': 'Nem sikerült megnyitni a mappaválasztót',
  'chat.queuedHeader': 'Sorban áll',
  'chat.queuedToSend': 'a küldéshez',
  'chat.queuedEditQueuedTaskAria': 'Sorban álló feladat szerkesztése',
  'chat.queuedSave': 'Mentés',
  'chat.queuedCancel': 'Mégse',
  'chat.queuedReorder': 'Húzza az átrendezéshez',
  'chat.queuedEdit': 'Szerkesztés',
  'chat.queuedMore': 'további sorban áll',
  'chat.queuedFollowUpFallback': 'Sorban álló utókövetés',
  'chat.send': 'Küldés',
  'chat.stop': 'Leállítás',
  'chat.removeAria': '{name} eltávolítása',
  'chat.example1Title': 'Magazinszerű pitch deck',
  'chat.example1Tag': 'Magazin',
  'chat.example1Prompt': 'Egy 10 diás magazinszerű pitch deck egy designstúdió seed köréhez — svájci rácselrendezés, túlméretezett serif címsorok félkövér drop capekkel, monospace szakaszszámok, bőséges üres tér, és teljes kihasználású fotódiák szövegközpontú diákkal váltakozva. Borító, vízió, piac, termék, eredmények, csapat, kérés, kapcsolat.',
  'chat.example2Title': 'SaaS analitikai dashboard',
  'chat.example2Tag': 'Adat',
  'chat.example2Prompt': 'Sűrű analitikai dashboard fejlesztői SaaS-hez — KPI-csík hét/hét deltákkal, két egymásra rakott vonaldiagram (MRR és aktív munkaterületek), világtérképes hőtérkép a használatról, kohorsz-megtartási rács, top-ügyfelek ranglista, és valós idejű eseménystream. Sötét téma, táblázatos monospace számok, sparkline akcentusok.',
  'chat.example3Title': 'Éves jelentés long-scroll',
  'chat.example3Tag': 'Magazinszerű',
  'chat.example3Prompt': 'Interaktív éves jelentés egy klíma-non-profitnak — long-scroll magazinszerű elrendezés, nagy kiemelt-idézet blokkokkal, adatvizualizációkkal (egymásra rakott oszlopok, animált számlálók, projekthelyek choropleth térképe), fotó-megszakítókkal, donor fallal, és záró cselekvésre hívással. Modern serif törzs, sans-serif diagramcímkék, földes papírpaletta.',
  'preview.usePlugin': 'Bővítmény használata',
  'preview.usePluginOnly': 'Csak a bővítmény',
  'preview.usePluginOnlyDesc': 'Használd a bővítmény szerkezetét, a tartalmat magad írd meg',
  'preview.replicateContent': 'Tartalom másolása',
  'preview.replicateContentDesc': 'Használd a példapromptot az előnézet újraalkotásához',
  'preview.shareMenu': 'Megosztás',
  'preview.exportMenu': 'Exportálás',
  'preview.shareTemplateBadge': 'Sablon',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': 'Sablonhivatkozás másolása',
  'preview.copyShareText': 'Megosztási szöveg másolása',
  'preview.shareSocialGroup': 'Megosztás közösségi médiában',
  'preview.shareCopyGroup': 'Másolás',
  'preview.shareExportGroup': 'Fájlok exportálása',
  'preview.shareCopied': 'Másolva',
  'preview.shareCopyFailed': 'A másolás sikertelen',
  'preview.shareTextDefault': 'Open Design sablon: {title}',
  'preview.openInNewTab': 'Megnyitás új lapon',
  'preview.exit': '⤓ Kilépés',
  'preview.fullscreen': '⤢ Teljes képernyő',
  'preview.closeTitle': 'Bezárás (Esc)',
  'preview.loading': '{label} betöltése…',
  'preview.errorTitle': 'A példa betöltése nem sikerült.',
  'preview.errorBody': 'A példa HTML-jének letöltése meghiúsult. Győződj meg róla, hogy az Open Design fut, majd próbáld újra.',
  'preview.retry': 'Újra',
  'preview.unavailableTitle': 'Nincs mellékelt előnézet: {noun}.',
  'preview.unavailableBody': 'Futtasd a promptot a csevegésben, hogy {kind} kimenetet készíts.',
  'preview.nounSkill': 'ez a skill',
  'preview.nounPlugin': 'ez a plugin',
  'preview.nounTemplate': 'ez a sablon',
  'preview.showSidebar': '{label} megjelenítése',
  'preview.hideSidebar': '{label} elrejtése',
  'misc.savedTemplate': 'Mentett sablon',
  'misc.primary': 'Elsődleges',
  'misc.designSystem': 'Designrendszer',
  'workspace.designFiles': 'Designfájlok',
  'workspace.focusMode': 'Munkaterület fókuszálása',
  'workspace.showChat': 'Csevegés megjelenítése',
  'workspace.closeTab': 'Lap bezárása',
  'workspace.deleteFileConfirm': 'Törlöd a(z) „{name}" fájlt a projektmappából?',
  'workspace.deleteSelectedFilesConfirm': 'Törlöd a(z) {n} kijelölt fájlt a projektmappából?',
  'workspace.deleteSelectedFilesPartial': '{n} fájl törlése sikertelen.',
  'workspace.openFromDesignFiles': 'Nyiss meg egy fájlt innen:',
  'workspace.designFilesLink': 'Designfájlok',
  'workspace.loadingSketch': 'Vázlat betöltése…',
  'workspace.newTab': 'Új lap',
  'workspace.searchFilesPlaceholder': 'Search files…',
  'workspace.openTabs': 'Megnyitott lapok',
  'workspace.openFile': 'Open a file',
  'workspace.noFilesMatch': 'No files match',
  'workspace.allFiles': 'All',
  'workspace.createNew': 'Create new',
  'workspace.tabOpen': 'Open',
  'workspace.sideChatContextBanner': 'Integrated context from the current conversation',
  'workspace.sideChatDefaultTitle': 'Side chat',
  'workspace.newTerminal': 'New Terminal',
  'workspace.newTerminalDescription': 'Open a shell in the project directory in a new tab',
  'workspace.newBrowser': 'New Browser',
  'workspace.newBrowserDescription': 'Open a built-in browser tab for reference sites and design research',
  'workspace.terminalStarting': 'Terminál indítása…',
  'workspace.terminalStartingDescription': 'A projekt shell előkészítése. Ez általában csak néhány másodperc.',
  'workspace.terminalSessionEnded': 'A munkamenet véget ért',
  'workspace.terminalReconnecting': 'Újracsatlakozás…',
  'workspace.terminalStartFailed': 'Nem sikerült elindítani a terminálmunkamenetet',
  'workspace.terminalRestart': 'Újraindítás',
  'designFiles.title': 'Designfájlok',
  'designFiles.upload': 'Fájlok feltöltése',
  'designFiles.pasteText': 'Beillesztés szövegfájlként',
  'designFiles.newSketch': 'Új vázlat',
  'designFiles.empty': 'A kreációk itt jelennek meg',
  'designFiles.refresh': 'Frissítés',
  'designFiles.delete': 'Törlés',
  'designFiles.searchPlaceholder': 'Fájlok keresése…',
  'designFiles.up': 'Fel',
  'designFiles.back': 'Vissza',
  'designFiles.crumbs': 'projekt',
  'designFiles.rowMenu': 'Sor menü',
  'designFiles.openInTab': 'Megnyitás lapon',
  'designFiles.download': 'Letöltés',
  'designFiles.downloadSelected': '{n} fájl letöltése ZIP-ként',
  'designFiles.deleteSelected': '{n} törlése',
  'designFiles.clearSelection': 'Kijelölés törlése',
  'designFiles.selectPage': 'Összes kijelölése az oldalon',
  'designFiles.selectAll': 'Összes kijelölése',
  'designFiles.dropTitle': '⤓ Húzd ide a fájlokat',
  'designFiles.dropDesc': 'Képek, dokumentumok, hivatkozások vagy mappák — az ügynök kontextusként használja őket.',
  'designFiles.dropLabel': 'Húzd ide a fájlokat',
  'designFiles.upload.title': 'Fájlok feltöltése',
  'designFiles.paste.title': 'Szöveg beillesztése fájlként',
  'designFiles.upload.label': 'Feltöltés',
  'designFiles.paste.label': 'Beillesztés',
  'designFiles.previewOpen': 'Megnyitás',
  'designFiles.previewClose': 'Előnézet bezárása',
  'designFiles.modified': 'Módosítva: {time} · {size}',
  'designFiles.weeksAgo': '{n} hete',
  'designFiles.groupBy': 'Csoportosítás',
  'designFiles.groupByKind': 'Típus',
  'designFiles.groupByModified': 'Módosítás',
  'designFiles.filterBy': 'Szűrés típus szerint',
  'designFiles.filterClear': 'Törlés',
  'designFiles.filterCount': '{n} típus',
  'designFiles.expandGroup': 'Kibontás',
  'designFiles.collapseGroup': 'Összecsukás',
  'designFiles.sectionPages': 'Oldalak',
  'designFiles.sectionScripts': 'Szkriptek',
  'designFiles.sectionImages': 'Képek',
  'designFiles.sectionSketches': 'Vázlatok',
  'designFiles.sectionLiveArtifacts': 'Élő elemek',
  'designFiles.sectionOther': 'Egyéb',
  'designFiles.modifiedToday': 'Ma',
  'designFiles.modifiedYesterday': 'Tegnap',
  'designFiles.modifiedPrevious7Days': 'Előző 7 nap',
  'designFiles.modifiedPrevious30Days': 'Előző 30 nap',
  'designFiles.modifiedOlder': 'Régebbi',
  'designFiles.showMore': '+{n} további megjelenítése',
  'designFiles.kindHtml': 'HTML oldal',
  'designFiles.kindImage': 'Kép',
  'designFiles.kindSketch': 'Vázlat',
  'designFiles.kindText': 'Szöveg',
  'designFiles.kindCode': 'Szkript',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': 'Dokumentum',
  'designFiles.kindPresentation': 'Prezentáció',
  'designFiles.kindSpreadsheet': 'Táblázat',
  'designFiles.kindLiveArtifact': 'Élő elem',
  'designFiles.kindBinary': 'Bináris',
  'designFiles.kindFolder': 'Mappa',
  'designFiles.folderCount': '{n} fájl',
  'designFiles.newFolderTitle': 'Új mappa',
  'designFiles.newFolderLabel': 'Mappa neve',
  'designFiles.moveTitle': 'Áthelyezés mappába',
  'designFiles.moveLabel': 'Cél mappa',
  'designFiles.moveRoot': 'Projekt gyökere',
  'designFiles.moveNewFolder': 'Új mappa…',
  'designFiles.move': 'Áthelyezés',
  'designFiles.copyPath': 'Útvonal másolása',
  'designFiles.copiedPath': 'Útvonal másolva',
  'designFiles.deleteFolderConfirm': 'Törli a(z) „{name}“ mappát és teljes tartalmát?',
  'designFiles.folderCreated': '„{name}“ mappa létrehozva',
  'designFiles.folderDeleted': '„{name}“ mappa törölve',
  'designFiles.filesMoved': '{n} áthelyezve ide: {dest}',
  'designFiles.colName': 'Név',
  'designFiles.colKind': 'Típus',
  'designFiles.colModified': 'Módosítva',
  'designFiles.perPage': 'Mutat',
  'designFiles.all': 'Összes',
  'designFiles.prev': 'Előző',
  'designFiles.next': 'Következő',
  'designFiles.jumpToPage': 'Ugrás oldalra',
  'designFiles.pageInfo': '{start}–{end} / {total}',
  'designFiles.sectionFolders': 'Mappák',
  'designFiles.sectionStylesheets': 'Stíluslapok',
  'designFiles.sectionDocuments': 'Dokumentumok',
  'designFiles.kindStylesheet': 'Stíluslap',
  'designFiles.modifiedExt': 'Módosítva: {time} · {size} · {ext}',
  'designFiles.usefulInfoLabel': 'Hasznos információk',
  'designFiles.usefulInfoTip': 'Kattints duplán bármelyik fájlra, hogy egy teljes lapon nyisd meg.',
  'designFiles.usefulInfoTip2': 'Írj @ jelet a csevegésben, hogy fájlt használj kontextusként.',
  'designFiles.usefulInfoTip4': 'Válassz design rendszert, és az eredmény a márkádhoz igazodik.',
  'designFiles.usefulInfoTip5': 'Nincs ötleted? Próbálj ki egy plugin sablont a kezdőlap Közösség részében.',
  'designFiles.usefulInfoTip6': 'Kérdésed vagy javaslatod van? Csatlakozz hozzánk Discordon.',
  'designFiles.usefulInfoTip7': 'Tetszik az Open Design? Adj egy csillagot GitHubon.',
  'designFiles.usefulInfoTip8': 'Kövesd a @OpenDesignHQ fiókot X-en a friss hírekért.',
  'designFiles.usefulInfoTip9': 'Húzz képeket, dokumentumokat vagy egész mappákat erre a panelre — az ügynök kontextusként használja őket.',
  'designFiles.usefulInfoTip10': 'Kattints az „Új vázlat” gombra, rajzolj egy elrendezést, és az ügynök elkészíti.',
  'designFiles.usefulInfoTip11': 'Jelölj ki bármilyen elemet az előnézetben és írj megjegyzést — az ügynök célzottan módosít.',
  'designFiles.usefulInfoTip12': 'Nem tetszik az eredmény? Bekarikázni gyorsabb, mint újra leírni.',
  'designFiles.usefulInfoTip13': 'Bármely terv egy kattintással exportálható PDF, kép vagy önálló HTML formátumban.',
  'designFiles.usefulInfoTip14': 'Elégedett vagy egy projekttel? Mentsd el sablonként a Megosztás menüből.',
  'designFiles.usefulInfoTip15': 'Telepítés után azonnal készíthetsz közösségi megosztókártyákat.',
  'quickSwitcher.placeholder': 'Fájl megnyitása…',
  'quickSwitcher.empty': 'Nincsenek fájlok ebben a projektben',
  'quickSwitcher.noMatches': 'Nincs találat',
  'quickSwitcher.navigate': 'navigáció',
  'quickSwitcher.open': 'megnyitás',
  'quickSwitcher.close': 'bezárás',
  'pasteDialog.title': 'Szöveg beillesztése',
  'pasteDialog.hint': 'A projektmappába mentve. Bármilyen név adható.',
  'pasteDialog.fileNameLabel': 'Fájlnév',
  'pasteDialog.namePlaceholder': 'jegyzetek.txt',
  'pasteDialog.contentLabel': 'Tartalom',
  'pasteDialog.contentPlaceholder': 'Illessz be bármit…',
  'pasteDialog.save': 'Mentés',
  'pasteDialog.cancel': 'Mégse',
  'sketch.save': 'Vázlat mentése',
  'sketch.cancel': 'Mégse',
  'sketch.saving': 'Mentés…',
  'sketch.saved': 'Mentve',
  'sketch.tooltipDirty': 'Mentetlen változtatások',
  'sketch.tooltipClean': 'Mentve',
  'fileViewer.empty': 'Válassz fájlt a megtekintéshez.',
  'fileViewer.loading': 'Betöltés…',
  'fileViewer.exportPptx': 'Exportálás PPTX-ként',
  'fileViewer.openInNewTab': 'Megnyitás új lapon',
  'fileViewer.copyPath': 'Útvonal másolása',
  'fileViewer.copied': 'Másolva!',
  'fileViewer.share': 'Megosztás',
  'fileViewer.binaryMeta': 'Bináris · {size}',
  'fileViewer.binaryNote': 'Bináris fájl ({size} bájt). A megtekintéshez töltsd le, vagy nyisd meg lemezről.',
  'fileViewer.pdfMeta': 'PDF · {size}',
  'fileViewer.documentMeta': 'Dokumentum',
  'fileViewer.presentationMeta': 'Prezentáció',
  'fileViewer.spreadsheetMeta': 'Táblázat',
  'fileViewer.previewUnavailable': 'Előnézet nem elérhető. Töltsd le vagy nyisd meg a fájlt a megtekintéshez.',
  'fileViewer.download': 'Letöltés',
  'fileViewer.open': 'Megnyitás',
  'fileViewer.imageMeta': 'Kép · {size}',
  'fileViewer.reactMeta': 'React komponens · {size}',
  'fileViewer.sketchMeta': 'Vázlat · {size}',
  'fileViewer.markdownStreamingMeta': 'Streamelő előnézet…',
  'fileViewer.markdownErrorMeta': 'Az előnézet hiányos lehet (generálási hiba).',
  'fileViewer.markdownStreamingStatus': 'Streamelés… részleges markdownt mutatva.',
  'fileViewer.markdownErrorStatus': 'Generálási hiba. Az utolsó elérhető tartalom látszik.',
  'fileViewer.videoMeta': 'Videó · {size}',
  'fileViewer.audioMeta': 'Hang · {size}',
  'fileViewer.reload': 'Újratöltés',
  'fileViewer.reloadDisk': 'Újratöltés lemezről',
  'fileViewer.copy': 'Másolás',
  'fileViewer.copyTitle': 'Fájltartalom másolása',
  'fileViewer.saveDisabled': 'Mentés (csak olvasható nézet)',
  'fileViewer.save': 'Mentés',
  'fileViewer.preview': 'Előnézet',
  'fileViewer.source': 'Forrás',
  'fileViewer.tweaks': 'Finomhangolás',
  'fileViewer.tweaksUnavailable': 'Nincs finomhangolási panel ebben az artefaktumban',
  'fileViewer.jsxModuleTitle': 'Nincs önálló előnézet',
  'fileViewer.jsxModuleBody': 'Ez a fájl egy komponensmodul, amelyet egy másik oldal tölt be.',
  'fileViewer.jsxModuleCta': 'Nyisd meg az oldalt, amely megjeleníti:',
  'fileViewer.comment': 'Megjegyzés',
  'fileViewer.edit': 'Szerkesztés',
  'fileViewer.draw': 'Rajz',
  'fileViewer.mark': 'Megjelölés',
  'fileViewer.markTool': 'Megjelölő eszköz',
  'fileViewer.boxSelect': 'Keretes kijelölés',
  'fileViewer.screenshot': 'Képernyőkép',
  'manualEdit.layers': 'Rétegek',
  'manualEdit.editableCount': '{count} szerkeszthető',
  'manualEdit.hiddenBadge': 'Rejtett',
  'manualEdit.title': 'Kézi szerkesztő',
  'manualEdit.fallbackTitle': 'Szerkesztés',
  'manualEdit.movePanel': 'Szerkesztőpanel áthelyezése',
  'manualEdit.editParams': 'Paraméterek szerkesztése',
  'manualEdit.closePanel': 'Szerkesztőpanel bezárása',
  'manualEdit.selectLayer': 'Válassz egy réteget',
  'manualEdit.empty': 'Kattints egy elemre az előnézetben, vagy válassz egy réteget.',
  'manualEdit.noEditableLayers': 'Nem található szerkeszthető réteg.',
  'manualEdit.noClass': 'nincs osztály',
  'manualEdit.tabsAria': 'Kézi szerkesztés fülek',
  'manualEdit.tabContent': 'Tartalom',
  'manualEdit.tabStyle': 'Stílus',
  'manualEdit.tabAttributes': 'Attribútumok',
  'manualEdit.tabHtml': 'Html',
  'manualEdit.tabSource': 'Forrás',
  'manualEdit.attributesJson': 'Attribútumok JSON',
  'manualEdit.selectedHtml': 'Kijelölt elem HTML-je',
  'manualEdit.fullSource': 'Teljes elem forráskódja',
  'manualEdit.applyContent': 'Tartalom alkalmazása',
  'manualEdit.applyStyle': 'Stílus alkalmazása',
  'manualEdit.applyAttributes': 'Attribútumok alkalmazása',
  'manualEdit.applyHtml': 'HTML alkalmazása',
  'manualEdit.applySource': 'Forrás alkalmazása',
  'manualEdit.invalidAttributes': 'Érvénytelen attribútumok JSON.',
  'manualEdit.changes': 'Módosítások',
  'manualEdit.undo': 'Visszavonás',
  'manualEdit.redo': 'Mégis',
  'manualEdit.noChanges': 'Még nincsenek kézi szerkesztések.',
  'manualEdit.imageUrl': 'Kép URL',
  'manualEdit.altText': 'Alternatív szöveg',
  'manualEdit.label': 'Címke',
  'manualEdit.text': 'Szöveg',
  'manualEdit.href': 'Href',
  'manualEdit.textColor': 'Szövegszín',
  'manualEdit.background': 'Háttér',
  'manualEdit.fontSize': 'Betűméret',
  'manualEdit.weight': 'Vastagság',
  'manualEdit.align': 'Igazítás',
  'manualEdit.padding': 'Belső margó',
  'manualEdit.margin': 'Külső margó',
  'manualEdit.radius': 'Lekerekítés',
  'manualEdit.border': 'Szegély',
  'manualEdit.width': 'Szélesség',
  'manualEdit.minHeight': 'Minimális magasság',
  'manualEdit.deleteElement': 'Elem törlése',
  'manualEdit.deleteElementConfirm': 'Törli a kijelölt elemet? Ez a Visszavonás paranccsal visszavonható.',
  'manualEdit.uploadImage': 'Kép feltöltése',
  'manualEdit.uploadingImage': 'Kép feltöltése…',
  'manualEdit.uploadImageFailed': 'A kép feltöltése nem sikerült.',
  'manualEdit.focusSlides': 'Diákra fókuszálás',
  'manualEdit.showPanels': 'Panelek megjelenítése',
  'fileViewer.zoomOut': 'Kicsinyítés',
  'fileViewer.zoomIn': 'Nagyítás',
  'fileViewer.resetZoom': 'Nagyítás visszaállítása',
  'fileViewer.viewportAria': 'Előnézeti nézetablak',
  'fileViewer.viewportDesktop': 'Asztali',
  'fileViewer.viewportDesktopTitle': 'Teljes szélességű asztali előnézet',
  'fileViewer.viewportTablet': 'Táblagép',
  'fileViewer.viewportTabletTitle': 'Tablet előnézet 820 × 1180 méretben (modern álló alapérték)',
  'fileViewer.viewportMobile': 'Mobil',
  'fileViewer.viewportMobileTitle': 'Mobil előnézet 390 × 844 méretben',
  'fileViewer.reloadAria': 'Újratöltés',
  'fileViewer.previousSlide': 'Előző dia',
  'fileViewer.nextSlide': 'Következő dia',
  'fileViewer.slideNavAria': 'Dianavigáció',
  'fileViewer.present': 'Bemutatás',
  'fileViewer.presentInTab': 'Ezen a lapon',
  'fileViewer.presentFullscreen': 'Teljes képernyő',
  'fileViewer.presentNewTab': 'Új lap',
  'fileViewer.exitPresentation': 'Bemutató bezárása',
  'fileViewer.shareLabel': 'Megosztás',
  'fileViewer.shareMenuShareLink': 'MEGOSZTÁS',
  'fileViewer.shareMenuPublishOnline': 'ONLINE KÖZZÉTÉTEL',
  'fileViewer.shareMenuDownload': 'LETÖLTÉS',
  'fileViewer.shareMenuPresentation': 'Prezentáció',
  'fileViewer.shareMenuSourceFiles': 'Forrásfájlok',
  'fileViewer.shareMenuSave': 'MENTÉS',
  'fileViewer.copyShareLink': 'Megosztási link másolása',
  'fileViewer.openSharePage': 'Megosztási oldal megnyitása',
  'fileViewer.shareLinkRequiresDeploy': 'Előbb tedd közzé online, hogy linket kapj',
  'fileViewer.shareLinkPublishGuide': 'Tedd közzé online fent a megosztás engedélyezéséhez ↑',
  'fileViewer.shareAfterGenerationComplete': 'A generálás befejezése után megosztható',
  'fileViewer.copyProviderLink': '{provider} hivatkozás másolása',
  'fileViewer.copyCloudflareLink': 'Cloudflare hivatkozás másolása',
  'fileViewer.screenshotCopying': 'Képernyőkép másolása...',
  'fileViewer.screenshotCopied': 'Képernyőkép a vágólapra másolva',
  'fileViewer.screenshotClipboardDenied': 'A böngésző letiltotta a vágólap-hozzáférést',
  'fileViewer.screenshotPreviewLoading': 'Az előnézet még töltődik. Próbálja újra egy pillanat múlva.',
  'fileViewer.screenshotCaptureFailed': 'Az előnézetet nem sikerült rögzíteni. Kérjük, próbálja újra.',
  'fileViewer.exportPdf': 'Exportálás PDF-ként',
  'fileViewer.exportPdfAllSlides': 'Exportálás PDF-ként (minden dia)',
  'fileViewer.exportPptxBusy': 'Várj, amíg az aktuális kör befejeződik.',
  'fileViewer.exportPptxHint': 'Küldj kérést az ügynöknek, hogy alakítsa át ezt a designt PPTX-szé.',
  'fileViewer.exportPptxNa': 'A PPTX export itt nem elérhető.',
  'fileViewer.exportZip': 'Letöltés .zip-ként',
  'fileViewer.exportHtml': 'Exportálás önálló HTML-ként',
  'fileViewer.exportMd': 'Exportálás Markdown-ként',
  'fileViewer.exportImage': 'Exportálás képként',
  'fileViewer.exportPptxImages': 'Exportálás PPTX-ként (képek)',
  'fileViewer.exportPptxEditable': 'Exportálás PPTX-ként (szerkeszthető)',
  'fileViewer.exportingProgress': 'Exportálás…',
  'fileViewer.exportSlideProgress': '{current}/{total}. dia exportálása…',
  'fileViewer.exportingElapsed': 'Exportálás… {seconds}mp',
  'fileViewer.exportSlideEta': '{current}/{total}. dia · ~{seconds}mp van hátra',
  'fileViewer.exportFailed': 'Az exportálás nem sikerült. Próbáld újra.',
  'fileViewer.exportDone': 'Exportálás kész',
  'fileViewer.exportImageFailed': 'A képrögzítés sikertelen. Kérjük, próbálja újra, vagy használja a böngészője képernyőkép eszközét.',
  'fileViewer.exportImageModalSubtitle': 'Válasszon formátumot, majd töltse le az aktuális előnézetet képként.',
  'fileViewer.exportImageFormatLabel': 'Formátum',
  'fileViewer.exportImageSaving': 'Kép mentése…',
  'fileViewer.exportImageSaved': 'Kép mentve',
  'fileViewer.exportImageDownloadStarted': 'Letöltés elindítva',
  'fileViewer.exportImageDownloadDetails': 'Ha nem jelent meg Mentés másként párbeszédablak, a {filename} a böngésző letöltései között található.',
  'fileViewer.exportJsx': 'Exportálás JSX-ként',
  'fileViewer.exportReactHtml': 'Előnézet exportálása HTML-ként',
  'fileViewer.exportStarted': 'Az exportálás elindult',
  'fileViewer.saveAsTemplate': 'Mentés sablonként…',
  'fileViewer.savingTemplate': 'Sablon mentése…',
  'fileViewer.savedTemplate': 'Mentve „{name}" néven',
  'fileViewer.savedTemplateFail': 'A sablon mentése nem sikerült — próbáld újra.',
  'fileViewer.templateNamePrompt': 'Sablon neve',
  'fileViewer.templateNameDefault': 'Cím nélküli sablon',
  'fileViewer.templateDescPrompt': 'Rövid leírás (opcionális — mitől hasznos ez a sablon?)',
  'liveArtifact.refresh.button': 'Frissítés',
  'liveArtifact.refresh.buttonTitle': 'Ennek az élő tartalomnak a frissítése',
  'liveArtifact.refresh.loadingTitle': 'Élő artifact betöltése…',
  'liveArtifact.refresh.noSourceTitle': 'Még nem érhető el frissítési forrás.',
  'liveArtifact.refresh.running': 'Frissítés…',
  'liveArtifact.refresh.runningMessage': 'Adatok és előnézet frissítése. Ez eltarthat egy ideig.',
  'liveArtifact.refresh.runningAction': 'A korábbi előnézet látható marad, amíg a frissítés sikeresen le nem fut.',
  'liveArtifact.refresh.successOne': 'A frissítés befejeződött. Az adatok frissültek.',
  'liveArtifact.refresh.successMany': 'A frissítés befejeződött. Az adatok frissültek.',
  'liveArtifact.refresh.successAction': 'Az előnézet újratöltődött a legutóbb véglegesített adatokkal.',
  'liveArtifact.refresh.previousFailure': 'A korábbi frissítés sikertelen: {message}',
  'liveArtifact.refresh.failureAction': 'Tekintse át a Frissítési előzményeket, javítsa ki a forrás- vagy jogosultsági hibát, majd próbálja újra.',
  'liveArtifact.refresh.networkFailure': 'A frissítési kérés sikertelen. Ellenőrizze a kapcsolatot, és próbálja újra.',
  'liveArtifact.refresh.genericFailure': 'A frissítés sikertelen.',
  'liveArtifact.refresh.statusNever': 'Nem frissíthető',
  'liveArtifact.refresh.statusReady': 'Frissítésre kész',
  'liveArtifact.refresh.statusSucceeded': 'Naprakész',
  'liveArtifact.refresh.statusFailed': 'A frissítés sikertelen',
  'liveArtifact.refresh.statusRunning': 'Frissítés folyamatban',
  'liveArtifact.refresh.statusRunningDescription': 'Jelenleg frissítés van folyamatban.',
  'liveArtifact.refresh.statusSucceededDescription': 'A legutóbbi frissítés sikeresen befejeződött.',
  'liveArtifact.refresh.statusFailedDescription': 'A legutóbbi frissítési kísérlet nem fejeződött be sikeresen.',
  'liveArtifact.refresh.statusReadyDescription': 'Frissíthető források vannak beállítva, de nincs folyamatban futtatás.',
  'liveArtifact.refresh.statusNeverDescription': 'Ennek az élő tartalomnak még nincs frissítési forrása.',
  'liveArtifact.refresh.eventStarted': 'Elindítva',
  'liveArtifact.refresh.eventSucceeded': 'Sikeres',
  'liveArtifact.refresh.eventFailed': 'Sikertelen',
  'liveArtifact.refresh.eventStartedDetail': 'Frissítés elindítva…',
  'liveArtifact.refresh.sourcesUpdatedOne': '{n} forrás frissítve',
  'liveArtifact.refresh.sourcesUpdatedMany': '{n} forrás frissítve',
  'liveArtifact.refresh.timelineEmpty': 'Ebben a munkamenetben még nem volt frissítési tevékenység. Indítson Frissítést az idővonal rögzítéséhez, vagy várja meg az automatikus futtatásokat.',
  'liveArtifact.refresh.heroLastRefreshedLabel': 'Utoljára frissítve',
  'liveArtifact.refresh.heroLastRefreshedNever': 'Soha',
  'liveArtifact.refresh.justNow': 'épp most',
  'liveArtifact.refresh.factCreated': 'Létrehozva',
  'liveArtifact.refresh.factLastUpdated': 'Utoljára frissítve',
  'liveArtifact.refresh.factUnknown': 'Ismeretlen',
  'liveArtifact.refresh.persistedTitle': 'Megőrzött frissítési előzmények',
  'liveArtifact.refresh.persistedHint': 'A refreshes.jsonl fájlból betöltött bejegyzések',
  'liveArtifact.refresh.persistedEmpty': 'Még nincsenek megőrzött frissítési előzmények.',
  'liveArtifact.refresh.persistedStatusSucceeded': 'sikeres',
  'liveArtifact.refresh.persistedStatusRunning': 'fut',
  'liveArtifact.refresh.persistedStatusFailed': 'sikertelen',
  'liveArtifact.refresh.persistedStatusCancelled': 'megszakítva',
  'liveArtifact.refresh.persistedStatusSkipped': 'kihagyva',
  'liveArtifact.refresh.sessionTitle': 'Munkamenet-tevékenység',
  'liveArtifact.refresh.sessionHint': 'A lap megnyitása közben megfigyelt események',
  'liveArtifact.refresh.docSourceTitle': 'Dokumentumforrás',
  'liveArtifact.refresh.docSourceHint': 'Forrás beállítva',
  'liveArtifact.refresh.docSourceType': 'Típus',
  'liveArtifact.refresh.docSourceTool': 'Eszköz',
  'liveArtifact.refresh.docSourceConnector': 'Csatlakozó',
  'liveArtifact.refresh.debugSummary': 'Speciális hibakeresési metaadatok',
  'liveArtifact.refresh.debugNote': 'Tartalmazhat csatlakozó-azonosítókat, fájlneveket, forrás-metaadatokat és belső műtermék-elérési utakat.',
  'liveArtifact.viewer.tabPreview': 'Előnézet',
  'liveArtifact.viewer.tabCode': 'Kód',
  'liveArtifact.viewer.tabData': 'Adatok',
  'liveArtifact.viewer.tabRefreshHistory': 'Frissítési előzmények',
  'liveArtifact.viewer.dataEmpty': 'Nincs elérhető data.json gyorsítótár.',
  'liveArtifact.viewer.code.templateHeading': 'Sablon HTML',
  'liveArtifact.viewer.code.renderedHeading': 'Renderelt HTML',
  'liveArtifact.viewer.code.templateHelp': 'A data.json fájllal az előnézet létrehozásához használt szerkeszthető sablon.',
  'liveArtifact.viewer.code.renderedHelp': 'Az előnézet által jelenleg betöltött generált index.html.',
  'liveArtifact.viewer.code.variantAria': 'Kódváltozat',
  'liveArtifact.viewer.code.variantTemplate': 'Sablon',
  'liveArtifact.viewer.code.variantRendered': 'Renderelt',
  'liveArtifact.viewer.code.loading': 'Kód betöltése…',
  'liveArtifact.viewer.code.unavailable': 'A kód még nem érhető el.',
  'liveArtifact.viewer.code.empty': 'Ez a kódfájl üres.',
  'fileViewer.deployToVercel': 'Telepítés Vercelre',
  'fileViewer.redeployToVercel': 'Újratelepítés',
  'fileViewer.deployingToVercel': 'Telepítés Vercelre…',
  'fileViewer.deployProviderLabel': 'Szolgáltató',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployToProvider': 'Telepítés ide: {provider}',
  'fileViewer.redeployToProvider': 'Újratelepítés ide: {provider}',
  'fileViewer.deployingToProvider': 'Telepítés ide: {provider}…',
  'fileViewer.preparingPublicLink': 'Nyilvános link előkészítése…',
  'fileViewer.copyDeployLink': 'Link másolása',
  'fileViewer.deployModalTitle': 'Telepítés',
  'fileViewer.deployModalSubtitle': 'A kiválasztott szolgáltató fiókjával telepítheted ezt a HTML-előnézetet.',
  'fileViewer.vercelToken': 'Vercel token',
  'fileViewer.vercelTokenGetLink': 'Vercel token kérése',
  'fileViewer.vercelTokenPlaceholder': 'Illeszd be a Vercel tokenedet',
  'fileViewer.vercelTokenReuseHint': 'A mentett tokent használjuk. Adj meg újat a cseréhez.',
  'fileViewer.vercelTokenRequired': 'Előbb adj meg és ments el egy Vercel tokent.',
  'fileViewer.cloudflareApiToken': 'Cloudflare API token',
  'fileViewer.cloudflareApiTokenGetLink': 'API token lekérése',
  'fileViewer.cloudflareApiTokenPlaceholder': 'Illeszd be a Cloudflare API tokenedet',
  'fileViewer.cloudflareApiTokenReuseHint': 'A mentett Cloudflare API tokent használjuk. Adj meg újat a cseréhez.',
  'fileViewer.cloudflareApiTokenRequired': 'Előbb adj meg és ments el egy Cloudflare API tokent.',
  'fileViewer.cloudflareApiTokenScopeHint': 'Az API token létrehozásakor válaszd a Pages Edit jogosultságot; egyedi domainekhez Zone Read / DNS Edit szükséges.',
  'fileViewer.vercelTeamId': 'Csapatazonosító',
  'fileViewer.vercelTeamSlug': 'Csapat slug',
  'fileViewer.cloudflareAccountId': 'Fiók ID',
  'fileViewer.cloudflareAccountIdHint': 'A fiók ID-t a Cloudflare irányítópulton találod.',
  'fileViewer.cloudflareAccountIdRequired': 'Előbb add meg és mentsd el a Cloudflare Account ID-t.',
  'fileViewer.cloudflareZoneLabel': 'Tartomány',
  'fileViewer.cloudflareZonePlaceholder': 'Mentsd a Cloudflare beállításokat a tartományok betöltéséhez',
  'fileViewer.cloudflareZoneRequired': 'Először válassz egy Cloudflare tartományt.',
  'fileViewer.cloudflareZonesLoading': 'Cloudflare domainek betöltése…',
  'fileViewer.cloudflareZonesRefresh': 'Tartományok frissítése',
  'fileViewer.cloudflareZonesLoadFailed': 'Nem sikerült betölteni a Cloudflare tartományokat.',
  'fileViewer.cloudflareZonesEmpty': 'Ehhez a fiókhoz nem található aktív teljes Cloudflare tartomány.',
  'fileViewer.cloudflareDomainPrefixLabel': 'Aldomain előtag',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': 'Csak egy DNS-címkét használj: kisbetűk, számok és kötőjelek.',
  'fileViewer.cloudflareHostnamePreview': 'Egyéni tartomány előnézete: {hostname}',
  'fileViewer.cloudflareCustomDomainHint': 'Opcionális: egyedi domain csatolása. Ha üresen hagyod, akkor is létrejön egy pages.dev link.',
  'fileViewer.cloudflarePagesDevLinkLabel': 'pages.dev URL',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'Egyéni tartomány',
  'fileViewer.optional': 'Opcionális',
  'fileViewer.vercelPreviewOnly': 'A telepítések egyelőre csak Preview-k.',
  'fileViewer.cloudflarePagesPreviewHint': 'A Cloudflare Pages Direct Uploadot használ.',
  'fileViewer.savingConfig': 'Mentés…',
  'fileViewer.deployConfigSaveFailed': 'A Vercel beállítások nem menthetők.',
  'fileViewer.deployFailed': 'A telepítés sikertelen. Ellenőrizd a Vercel beállításokat, és próbáld újra.',
  'fileViewer.deployProviderConfigSaveFailed': 'A {provider} beállításai nem menthetők.',
  'fileViewer.deployProviderFailed': 'A {provider} telepítés sikertelen. Ellenőrizd a beállításokat, és próbáld újra.',
  'fileViewer.deployResultLabel': 'Telepített URL',
  'fileViewer.deployLinkReady': 'Kész',
  'fileViewer.deploySuccessToast': 'A telepítés sikeresen feltöltve',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': 'Nyilvános link várólistán',
  'fileViewer.deployLinkDelayed': 'A webhely telepítve van. A szolgáltató még készíti a nyilvános linket.',
  'fileViewer.deployLinkFailed': 'Az egyéni domain sikertelen',
  'fileViewer.deployLinkProtectedLabel': 'Telepítési védelem bekapcsolva',
  'fileViewer.deployLinkProtected': 'A webhely telepítve van, de ez az előnézeti link hitelesítést kér. Kapcsold ki a Deployment Protectiont, vagy használj saját domaint.',
  'fileViewer.retryLink': 'Újra most',
  'questionForm.submit': 'Beküldés',
  'questionForm.skip': 'Kihagyás',
  'questionForm.locked': 'Megválaszolva',
  'conv.switch': 'Beszélgetés váltása',
  'conv.label': 'Beszélgetés',
  'conv.heading': 'Beszélgetések',
  'conv.new': '+ Új',
  'conv.empty': 'Még nincs beszélgetés.',
  'conv.untitled': 'Cím nélküli beszélgetés',
  'conv.renameTooltip': 'Dupla kattintás az átnevezéshez',
  'conv.delete': 'Beszélgetés törlése',
  'conv.deleteConfirm': 'Törlöd a(z) „{title}" beszélgetést? Ez eltávolítja az üzeneteit.',
  'agentPicker.label': 'Ügynök',
  'agentPicker.modeChoose': 'Válassz végrehajtási módot',
  'agentPicker.localCli': 'Helyi CLI',
  'agentPicker.daemonOff': 'a daemon kikapcsolva',
  'agentPicker.byok': 'API · BYOK',
  'agentPicker.selectAgent': 'Válassz egy észlelt code-agent CLI-t',
  'agentPicker.noAgents': 'nincs ügynök a PATH-on',
  'agentPicker.notInstalled': 'nincs telepítve',
  'agentPicker.rescan': 'Helyi PATH újraellenőrzése ügynökökért',
  'tool.openInTab': '{name} megnyitása lapon',
  'tool.open': 'megnyitás',
  'tool.todos': 'Feladatok',
  'tool.todosExpand': 'Feladatok mutatása',
  'tool.todosCollapse': 'Feladatok elrejtése',
  'tool.todosDone': 'Kész',
  'tool.todosDismiss': 'Feladatlista elvetése',
  'tool.write': 'Írás',
  'tool.edit': 'Szerkesztés',
  'tool.read': 'Olvasás',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': 'Lekérés',
  'tool.search': 'Keresés',
  'tool.lines': '{n} sor',
  'tool.changeSingular': 'változás',
  'tool.changePlural': 'változás',
  'tool.in': 'itt: {path}',
  'tool.hide': 'elrejtés',
  'tool.output': 'kimenet',
  'tool.running': 'fut…',
  'tool.error': 'hiba',
  'tool.done': 'kész',
  'assistant.role': 'Asszisztens',
  'assistant.workingLabel': 'Dolgozik',
  'assistant.doneLabel': 'Kész',
  'assistant.copyMarkdown': 'Válasz Markdown másolása',
  'assistant.forkConversation': 'Fork innen',
  'assistant.forkingConversation': 'Fork létrehozása…',
  'assistant.shareToOpenDesign': 'Megosztás az Open Designnal',
  'assistant.shareToOpenDesignBusy': 'Csomag előkészítése…',
  'assistant.feedbackPrompt': 'Visszajelzés',
  'assistant.feedbackPositive': 'Hasznos',
  'assistant.feedbackNegative': 'Nem hasznos',
  'assistant.feedbackReasonTitle': 'Mondd el, miért',
  'assistant.feedbackReasonPositiveMatched': 'Megértette a kérésemet',
  'assistant.feedbackReasonPositiveVisual': 'Jól néz ki',
  'assistant.feedbackReasonPositiveUseful': 'Hasznos struktúra',
  'assistant.feedbackReasonPositiveEasy': 'Könnyen szerkeszthető tovább',
  'assistant.feedbackReasonPositiveDesignSystem': 'Követte a dizájnrendszert',
  'assistant.feedbackReasonNegativeMissed': 'Figyelmen kívül hagyta a kérésemet',
  'assistant.feedbackReasonNegativeVisual': 'A vizuális minőség javításra szorul',
  'assistant.feedbackReasonNegativeIncomplete': 'Hiányos kimenet',
  'assistant.feedbackReasonNegativeHard': 'Nehéz használni',
  'assistant.feedbackReasonNegativeDesignSystem': 'Nem követte a dizájnrendszert',
  'assistant.feedbackReasonOther': 'Egyéb',
  'assistant.feedbackReasonPlaceholder': 'Adj hozzá egy rövid megjegyzést...',
  'assistant.feedbackReasonSubmit': 'Küldés',
  'assistant.emptyResponseLabel': 'Nincs kimenet',
  'assistant.emptyResponseMessage': 'A szolgáltató szöveg vagy műtermék visszaadása nélkül zárta le a kérést. Próbálj másik modellt vagy szolgáltatót, ellenőrizd a kvótát, vagy próbáld újra.',
  'assistant.unfinishedLabel': 'Befejezetlen munkával állt le',
  'assistant.unfinishedSummary': '{n} feladat hátravan',
  'assistant.unfinishedMore': '+{n} további',
  'assistant.continueRemaining': 'Hátralévő feladatok folytatása',
  'chat.resumeRunCta': 'Futás folytatása',
  'assistant.outTokens': '{n} ki',
  'assistant.producedFiles': 'A körben létrehozott fájlok',
  'assistant.openFile': 'Megnyitás',
  'assistant.downloadFile': 'Letöltés',
  'nextStep.title': 'Következő lépés',
  'nextStep.more': 'Több',
  'nextStep.share': 'Megosztás',
  'nextStep.download': 'Letöltés',
  'nextStep.contribute': 'Hozzájárulás',
  'nextStep.brandAiOptimizeTitle': 'Refine extracted design system',
  'nextStep.brandAiOptimizeBody': 'Starts an agent pass that consumes model tokens, re-extracts the source, and updates this design system in place.',
  'nextStep.brandCreateDesignTitle': 'Create with this design system',
  'nextStep.brandCreateDesignBody': 'Start a new design using the extracted colors, type, assets, and system guidance.',
  'nextStep.createDesignBusy': 'Design létrehozása...',
  'assistant.thinking': 'Gondolkodik',
  'assistant.thought': 'Gondolkodott',
  'assistant.thoughtFor': 'Gondolkodott {s} mp-ig',
  'assistant.systemReminder': 'Rendszer-emlékeztető',
  'assistant.possiblePromptInjection': 'Lehetséges prompt injekció',
  'assistant.waitingFirstOutput': 'Az első kimenetre vár',
  'assistant.statusBootingAgent': 'Ügynök indítása',
  'assistant.statusPreparing': 'Előkészítés...',
  'assistant.statusStarting': 'Indítás',
  'assistant.statusRequesting': 'Kérés küldése',
  'assistant.statusThinking': 'Gondolkodik',
  'assistant.statusStreaming': 'Streamelés',
  'assistant.slowHint': 'Tovább tart a szokásosnál. Az űrlap általában 5–10 mp alatt megjelenik — leállíthatod és újrafogalmazhatod.',
  'assistant.verbEditing': 'Szerkesztés',
  'assistant.verbWriting': 'Írás',
  'assistant.verbReading': 'Olvasás',
  'assistant.verbSearching': 'Keresés',
  'assistant.verbRunning': 'Futtatás',
  'assistant.verbTodos': 'Feladatok',
  'assistant.verbFetching': 'Lekérés',
  'assistant.verbCalling': 'Hívás',
  'qf.answered': 'megválaszolva',
  'qf.choose': 'Válassz…',
  'qf.required': 'kötelező',
  'qf.lockedSubmitted': 'Válaszok elküldve — az ügynök ezeket használja a folyamat további részében.',
  'qf.lockedPrev': 'Ez az űrlap egy korábbi körből származik.',
  'qf.hint': 'Válaszd, ami illik. Hagyd ki az opcionális mezőket, amik nem érdekesek — az ügynök ésszerű alapértékeket használ.',
  'qf.submitDefault': 'Válaszok küldése',
  'qf.submitDisabledTitle': 'Előbb töltsd ki a kötelező mezőket',
  'qf.submitTitle': 'Válaszok küldése',
  'qf.cardSelected': 'kiválasztva',
  'qf.cardRefs': 'Hivatkozások:',
  'qf.cardSampleText': 'Árvíztűrő tükörfúrógép · 0123',
  'questions.tabLabel': 'Kérdések',
  'questions.banner': 'Megengeded, hogy feltegyek néhány gyors kérdést?',
  'questions.bannerAnswered': 'Kérdések megválaszolva',
  'questions.continue': 'Folytatás',
  'questions.generating': 'Kérdések generálása…',
  'questions.skipAll': 'Összes kihagyása',
  'questions.autoSkipHint': 'Automatikusan folytatódik az időzítő lejártakor',
  'sketch.toolSelect': 'Kijelölés (nem aktív)',
  'sketch.toolPen': 'Toll',
  'sketch.toolText': 'Szöveg',
  'sketch.toolRect': 'Téglalap',
  'sketch.toolArrow': 'Nyíl',
  'sketch.toolEraser': 'Radír',
  'sketch.color': 'Szín',
  'sketch.strokeSize': 'Vonalvastagság',
  'sketch.undo': 'Visszavonás',
  'sketch.clear': 'Törlés',
  'sketch.close': 'Bezárás',
  'sketch.closeConfirm': 'Bezárod a vázlatot, és elveted a nem mentett változtatásokat?',
  'sketch.textPrompt': 'Szöveg:',
  'sketch.textModalTitle': 'Szöveg hozzáadása',
  'critiqueTheater.userFacingName': 'Dizájnzsűri',
  'critiqueTheater.roleDesigner': 'Tervező',
  'critiqueTheater.roleCritic': 'Kritikus',
  'critiqueTheater.roleBrand': 'Márka',
  'critiqueTheater.roleA11y': 'Akadálymentesség',
  'critiqueTheater.roleCopy': 'Másolás',
  'critiqueTheater.roundLabel': '{n}. kör / {m}',
  'critiqueTheater.mustFix': '{n} kötelező javítás',
  'critiqueTheater.composite': 'Összesített',
  'critiqueTheater.threshold': 'Küszöbérték',
  'critiqueTheater.consensus': 'Konszenzus',
  'critiqueTheater.interrupt': 'Megszakítás',
  'critiqueTheater.interrupting': 'Megszakítás…',
  'critiqueTheater.interrupted': 'Megszakítva',
  'critiqueTheater.degradedHeading': 'A panel offline ebben a futtatásban',
  'critiqueTheater.degradedReasonMalformed': 'Hibás panelkimenet (az elemző elutasította a blokkot).',
  'critiqueTheater.degradedReasonOversize': 'A panelkimenet túllépte a biztonságos bájtkeretet.',
  'critiqueTheater.degradedReasonAdapter': 'A(z) {adapter} adapter nem támogatta a Critique protokollt.',
  'critiqueTheater.degradedReasonProtocol': 'A(z) {adapter} adapter nem támogatott protokollverziót küldött.',
  'critiqueTheater.degradedReasonMissingArtifact': 'A futtatás végső műtárgy nélkül fejeződött be.',
  'critiqueTheater.replay': 'Visszajátszás',
  'critiqueTheater.replaySpeed': 'Visszajátszás sebessége',
  'critiqueTheater.readOnly': 'Csak olvasható',
  'critiqueTheater.shippedSummary': 'Leszállítva a(z) {round}. körben · összesített {composite}',
  'critiqueTheater.interruptedSummary': 'Megszakítva a(z) {round}. körben · legjobb összesített {composite}',
  'critiqueTheater.shippedBadge': 'Kiszállítva',
  'critiqueTheater.belowThresholdBadge': 'Küszöbérték alatt',
  'critiqueTheater.timedOutBadge': 'Időtúllépés',
  'critiqueTheater.failedHeading': 'A futtatás meghiúsult',
  'critiqueTheater.failedReasonCliExit': 'Az Agent CLI nem nulla kóddal lépett ki, mielőtt a panel befejezhette volna.',
  'critiqueTheater.failedReasonPerRoundTimeout': 'Egy kör túllépte az időkeretét.',
  'critiqueTheater.failedReasonTotalTimeout': 'A teljes futtatás túllépte a teljes időkeretét.',
  'critiqueTheater.failedReasonOrchestrator': 'Belső orkesztrátorhiba.',
  'critiqueTheater.transcriptEmpty': 'Még nincs visszajátszható átirat. Futtass egy kritikát egy rögzítéséhez.',
  'critiqueTheater.transcriptLoading': 'Átirat betöltése…',
  'critiqueTheater.transcriptError': 'Nem sikerült betölteni az átiratot: {error}',
  'critiqueTheater.replaySpeedPaused': 'Szüneteltetve',
  'critiqueTheater.replaySpeedInstant': 'Azonnali',
  'critiqueTheater.replaySpeedLive': 'Élő',
  'critiqueTheater.replaySpeedFast': 'Gyors',
  'critiqueTheater.settingsNav': 'Dizájnzsűri',
  'critiqueTheater.settingsNavHint': 'Ötpaneles tervezési felülvizsgálat a futtatásaidhoz',
  'critiqueTheater.settingsEnabledLabel': 'Design Jury megjelenítése az agent futtatások során',
  'critiqueTheater.settingsEnabledDescription': 'Ha engedélyezve van, egy ötpaneles felülvizsgálat jelenik meg az agent generálások mellett, és a kiszállítás előtt pontozza a kimenetet. Bármikor megszakíthatod.',
  'critiqueTheater.settingsEnabledProjectHint': 'Mentve ehhez a projekthez. Az ebben a projektben futó új futtatások a Design Jury-n keresztül haladnak a szerveroldalon.',
  'critiqueTheater.settingsEnabledNoProjectHint': 'Nyiss meg egy projektet a szerveroldali megőrzéshez. Addig ez csak a böngészőn belüli beállítást módosítja.',
  'pet.title': 'Háziállatok',
  'pet.subtitle': 'Fogadj be egy apró társat, aki a munkaterületed felett lebeg.',
  'pet.navTitle': 'Háziállatok',
  'pet.navHint': 'Befogadás vagy testreszabás',
  'pet.tabBuiltIn': 'Beépített',
  'pet.tabBuiltInHint': 'Az Open Designnal csomagolt társak — válassz egyet és fogadd örökbe.',
  'pet.builtInEmpty': 'A beépített állatok most nem elérhetők. Frissítsd a Közösség fület, amint a daemon újra online.',
  'pet.tabCustom': 'Egyéni',
  'pet.tabCustomHint': 'Készíts sajátot névvel, jellel, színnel vagy sprite-tal.',
  'pet.tabCommunity': 'Közösségi',
  'pet.tabCommunityHint': 'Codex-ben kikelt háziállatok — fogadj be egyet, vagy generálj újat.',
  'pet.tabsAria': 'Háziállat forrása',
  'pet.adopt': 'Befogadás',
  'pet.adoptedBadge': 'Befogadva',
  'pet.adoptCallout': 'Fogadj be egy háziállatot',
  'pet.changePet': 'Háziállat váltása',
  'pet.wake': 'Ébresztés',
  'pet.tuck': 'Elrejtés',
  'pet.wakeTitle': 'Háziállat ébresztése — lebegő réteg megjelenítése.',
  'pet.tuckTitle': 'Háziállat elrejtése — lebegő réteg eltüntetése.',
  'pet.settingsTitle': 'Háziállat beállításainak megnyitása',
  'pet.useCustom': 'Saját háziállat használata',
  'pet.customTitle': 'Készíts egy sajátot',
  'pet.customHint': 'Válassz nevet, jelet és kiemelőszínt — a réteg élőben frissül.',
  'pet.customGreetingPlaceholder': 'Köszönj a háziállatod nevében…',
  'pet.fieldName': 'Név',
  'pet.fieldGlyph': 'Jel',
  'pet.fieldGlyphHint': 'Egyetlen emoji a legjobb (pl. 🐝, 🦄, 🐢).',
  'pet.fieldGreeting': 'Üdvözlés',
  'pet.fieldAccent': 'Kiemelőszín',
  'pet.fieldAccentCustom': 'Egyedi szín',
  'pet.fieldAccentDefault': 'Alapértelmezett kiemelőszín',
  'pet.overlayAria': 'Háziállat társ',
  'pet.spriteAria': '{name} — húzd a mozgatáshoz, kattints a beszélgetéshez',
  'pet.spriteTitle': 'Üdv tőlem, {name}! Kattints a beszélgetéshez.',
  'pet.taskSummarySingle': '{count} agent feladat fut.',
  'pet.taskSummaryMultiple': '{count} agent feladat fut {projects} projektben.',
  'pet.taskSummaryRecentSingle': '{count} agent feladat fejeződött be nemrég.',
  'pet.taskSummaryRecentMultiple': '{count} agent feladat fejeződött be nemrég.',
  'pet.taskListAria': 'Aktív agent feladatok',
  'pet.taskOpenProject': '{project} megnyitása',
  'pet.taskGroup.running': 'Fut',
  'pet.taskGroup.queued': 'Várakozik',
  'pet.taskGroup.recent': 'Nemrég befejezve',
  'pet.idleQuote.leonardo.text': 'A tanulás sohasem meríti ki az elmét.',
  'pet.idleQuote.leonardo.author': 'Leonardo da Vinci',
  'pet.idleQuote.michelangelo.text': 'Megláttam az angyalt a márványban, és addig faragtam, amíg kiszabadítottam.',
  'pet.idleQuote.michelangelo.author': 'Michelangelo',
  'pet.idleQuote.bernini.text': 'Két eszköz segítheti a szobrászt: a fény és az árnyék.',
  'pet.idleQuote.bernini.author': 'Gian Lorenzo Bernini',
  'pet.idleQuote.raphael.text': 'Amikor az ember fest, nem gondolkodik.',
  'pet.idleQuote.raphael.author': 'Raffaello',
  'pet.idleQuote.caravaggio.text': 'Minden mű, bárki bármit fessen is, nem más, mint csekélység és gyermeteg semmiség, hacsak nem életből készül és festik.',
  'pet.idleQuote.caravaggio.author': 'Caravaggio',
  'pet.idleQuote.rodin.text': 'A lényeg az, hogy meghatódjunk, szeressünk, reménykedjünk, remegjünk, éljünk.',
  'pet.idleQuote.rodin.author': 'Auguste Rodin',
  'pet.composerTitle': 'Háziállatok — ébresztés, elrejtés vagy választás',
  'pet.composerMenuTitle': 'Háziállatok',
  'pet.composerMenuHint': 'tipp: írd be /pet a váltáshoz',
  'pet.composerOpenSettings': 'Háziállatok kezelése',
  'pet.welcomeTeaserTitle': 'Fogadj be egy háziállatot',
  'pet.welcomeTeaserBody': 'Egy apró lebegő társ, aki veled van.',
  'pet.welcomeTeaserCta': 'Választok egyet',
  'pet.imageUpload': 'Sprite feltöltése',
  'pet.imageReplace': 'Sprite cseréje',
  'pet.imageRemove': 'Emoji használata',
  'pet.imageHintIdle': 'PNG, JPG, WebP, GIF vagy SVG. Spritesheet? Tölts fel egy vízszintes szalagot, és add meg a képkockaszámot.',
  'pet.imageHintActive': 'A sprite-od látható. Állítsd a képkockaszámot 1 fölé egy vízszintes spritesheet animálásához.',
  'pet.fieldFrames': 'Képkockák',
  'pet.fieldFramesHint': '1 = statikus. > 1 = vízszintes spritesheet.',
  'pet.fieldFps': 'Sebesség (fps)',
  'pet.fieldFpsHint': 'Milyen gyorsan forognak a képkockák.',
  'pet.atlasImport': 'Codex sprite importálása',
  'pet.atlasImportTitle': 'Importálj egy hatch-pet 8x9 / 192x208 atlast (PNG vagy WebP).',
  'pet.atlasPickerTitle': 'Válassz animációs sort',
  'pet.atlasPickerHint': 'A Codex háziállatok 9 animációs sort hoznak. Alapból a teljes atlast használjuk, így a háziállat sort vált hover, húzás és tétlen állapot szerint. Egy sorra is rögzíthető.',
  'pet.atlasCancel': 'Atlas eldobása',
  'pet.atlasAdopt': 'Rögzítés erre a sorra',
  'pet.atlasAdoptFull': 'Teljes atlas használata (animált)',
  'pet.atlasAdoptFullTitle': 'Minden sor megmarad, így a háziállat reagál a hoverre, a húzás irányára és a hosszú tétlenségre.',
  'pet.atlasAdoptRowTitle': 'Csak a kiemelt sort vágjuk ki egy ismétlődő szalaggá.',
  'pet.atlasActiveHint': 'Animált atlas aktív — a háziállat az interakcióid (hover, húzás, tétlen) alapján választ sort.',
  'pet.atlasRow.idle': 'Tétlen',
  'pet.atlasRow.running-right': 'Futás jobbra',
  'pet.atlasRow.running-left': 'Futás balra',
  'pet.atlasRow.waving': 'Integetés',
  'pet.atlasRow.jumping': 'Ugrás',
  'pet.atlasRow.failed': 'Sikertelen',
  'pet.atlasRow.waiting': 'Várakozás',
  'pet.atlasRow.running': 'Futás',
  'pet.atlasRow.review': 'Áttekintés',
  'pet.hatchTitle': 'Új háziállat költése MI-vel',
  'pet.hatchHint': 'Használd a beépített hatch-pet skillt a chatben egy Codex-stílusú spritesheet generálásához, majd importáld ide.',
  'pet.hatchConcept': 'Háziállat-koncepció (opcionális)',
  'pet.hatchConceptPlaceholder': 'pl. egy apró pixel-art shiba kötött pulóverben',
  'pet.hatchCopy': 'Prompt másolása',
  'pet.hatchCopied': 'Kimásolva!',
  'pet.hatchFoot': 'Miután a skill elmentette a háziállatot, gyere vissza és válaszd a „Codex sprite importálása" lehetőséget.',
  'pet.slashPopoverAria': 'Slash parancsok',
  'pet.slashPopoverTitle': 'Parancsok',
  'pet.slashPopoverHint': '↑↓ navigáció · enter választás · esc kilépés',
  'pet.slashPet': 'Háziállat váltása, befogadása vagy a beállítások megnyitása.',
  'pet.slashPetWake': 'Lebegő háziállat-réteg ébresztése.',
  'pet.slashPetTuck': 'Háziállat elrejtése egy időre.',
  'pet.slashHatch': 'Codex háziállat generálása a hatch-pet skill-lel.',
  'pet.slashHatchArg': '<koncepció>',
  'pet.slashSearch': 'Webes keresés az OD research paranccsal.',
  'pet.slashSearchArg': '<keresés>',
  'pet.codexTitle': 'Frissen kikelt',
  'pet.codexSubtitle': 'A hatch-pet skill által csomagolt háziállatok itt jelennek meg, egy kattintással befogadhatók.',
  'pet.codexSubtitleWithDir': '{dir} keresése hatch-pet csomagok után.',
  'pet.codexEmpty': 'Még nincs kikelt háziállat. Írd be /hatch a chatbe egy generálásához.',
  'pet.codexLoading': 'Kikelt háziállatok keresése…',
  'pet.codexRefresh': 'Frissítés',
  'pet.codexAdopt': 'Befogadás',
  'pet.codexAdopting': 'Befogadás folyamatban…',
  'pet.communitySync': 'Közösségi háziállatok letöltése',
  'pet.communitySyncing': 'Letöltés…',
  'pet.communitySyncTitle': 'Frissítsd a Codex Pet Share és j20 Hatchery legutóbbi háziállatait a ~/.codex/pets/ mappába.',
  'pet.communitySyncDone': '{wrote} új háziállat szinkronizálva (összesen {total}).',
  'pet.communitySyncFailed': 'A szinkronizálás sikertelen: {error}',
  'pet.codexBundled': 'Beépített',
  'pet.codexBundledTitle': 'Az Open Designgal érkezik — letöltés nem szükséges.',
  'settings.notifications': 'Értesítések',
  'settings.notificationsHint': 'Hang és asztali értesítés a feladat befejezésekor',
  'settings.notifyCompletionSound': 'Befejezési hang',
  'settings.notifyCompletionSoundHint': 'Megszólal egy kör végén. Alapértelmezetten kikapcsolva.',
  'settings.notifySuccessSound': 'Sikerhang',
  'settings.notifyFailureSound': 'Hibahang',
  'settings.notifyDesktop': 'Asztali értesítés',
  'settings.notifyDesktopHint': 'Akkor érkezik, ha az ablak nem aktív.',
  'settings.notifyDesktopBlocked': 'A böngésző letiltotta. Engedélyezd a webhely beállításaiban.',
  'settings.notifyDesktopUnsupported': 'Az asztali értesítések ebben a környezetben nem elérhetők.',
  'settings.notifyTest': 'Tesztküldés',
  'settings.notifyTestSent': 'Tesztértesítés elküldve. Ha nem jelenik meg banner, ellenőrizd a böngésző és a rendszer értesítési beállításait.',
  'settings.notifyTestFailed': 'Az értesítéshívás sikertelen. Ellenőrizd a böngésző és a rendszer értesítési beállításait.',
  'settings.notifySoundDing': 'Csilingelés',
  'settings.notifySoundChime': 'Csengő',
  'settings.notifySoundTwoToneUp': 'Kétszólamú emelkedő',
  'settings.notifySoundPluck': 'Pengetés',
  'settings.notifySoundBuzz': 'Zümmögés',
  'settings.notifySoundTwoToneDown': 'Kétszólamú ereszkedő',
  'settings.notifySoundThud': 'Tompa puffanás',
  'settings.skills': 'Készségek',
  'settings.skillsHint': 'Funkcionális készségek, amelyeket az ügynök egy feladat közben hívhat',
  'settings.skillsNew': 'Új készség',
  'settings.skillsEmpty': 'Válassz egy készséget balra, vagy hozz létre újat.',
  'settings.skillsEdit': 'Szerkesztés',
  'settings.skillsDelete': 'Törlés',
  'settings.skillsDeleteConfirm': 'Törlés megerősítése',
  'settings.skillsName': 'Név',
  'settings.skillsTriggers': 'Indítók (vesszővel vagy új sorral elválasztva)',
  'settings.skillsDescription': 'Leírás',
  'settings.skillsBody': 'SKILL.md tartalom',
  'settings.skillsCreate': 'Létrehozás',
  'settings.skillsSave': 'Mentés',
  'settings.skillsSaving': 'Mentés…',
  'settings.skillsFiles': 'Fájlok',
  'settings.skillsNoFiles': 'Nincs fájl ebben a készségmappában.',
  'settings.skillsNameRequired': 'A készség neve kötelező.',
  'settings.skillsBodyRequired': 'A készség tartalma kötelező.',
  'settings.designSystems': 'Designrendszerek',
  'settings.designSystemsHint': 'Böngészd és kapcsold be az elérhető designrendszereket',
  'settings.designSystemsInstalled': 'Telepítve',
  'settings.designSystemsAdd': 'Designrendszer hozzáadása',
  'settings.designSystemsHiddenCount': '{count} elrejtve a kezdő galériából',
  'settings.designSystemsShowAll': 'Összes megjelenítése',
  'settings.designSystemsShowHidden': 'Rejtettek megjelenítése',
  'settings.designSystemsSource': 'Forrás',
  'settings.designSystemsSourceLocal': 'Helyi',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsSourceShadcn': 'shadcn',
  'settings.designSystemsShadcnReference': 'shadcn-registry hivatkozás',
  'settings.designSystemsImportShadcn': 'Importálás shadcnból',
  'settings.designSystemsStructure': 'Struktúra',
  'settings.designSystemsModeHybrid': 'Hibrid',
  'settings.designSystemsModeNormalized': 'Normalizált',
  'settings.designSystemsModeVerbatim': 'Változatlan',
  'settings.designSystemsCraft': 'Készítés',
  'settings.designSystemsCraftColor': 'Szín',
  'settings.designSystemsCraftAccessibility': 'Akadálymentesség',
  'settings.designSystemsGithubUrl': 'GitHub URL',
  'settings.designSystemsProjectPath': 'Projekt útvonala',
  'settings.designSystemsImportGithub': 'Importálás GitHubból',
  'settings.designSystemsImportProject': 'Importálás projektből',
  'settings.designSystemsImportedStatus': '{title} importálva',
  'settings.designSystemsViewImported': 'Importált designrendszer megtekintése',
  'settings.designSystemsCategory': 'Kategória',
  'settings.designSystemsAllCategories': 'Minden kategória',
  'settings.designSystemsShowInHomeGallery': 'Megjelenítés a kezdő galériában',
  'settings.projectLocations': 'Projekt helyek',
  'settings.projectLocationsHint': 'Munkaterület tárolási gyökerek',
  'settings.projectLocationsDescription': 'Adj hozzá munkabázisokat, amelyek több Open Design projektmappát is tartalmazhatnak. Az új projektek mappaként jönnek létre a kiválasztott bázison belül.',
  'settings.projectLocationsSaveError': 'Nem sikerült menteni a projekt helyeket. Ellenőrizd, hogy minden útvonal elérhető mappa-e.',
  'settings.projectLocationsSaved': 'Projekt helyek mentve.',
  'settings.projectLocationsScanError': 'Nem sikerült beolvasni a projekt helyeket.',
  'settings.projectLocationsScanComplete': 'Beolvasás kész: {imported} importálva, {existing} már regisztrálva.',
  'settings.projectLocationsNoFolderSelected': 'Nincs kiválasztott mappa.',
  'settings.projectLocationsDuplicate': 'Ez a munkabázis már hozzá van adva.',
  'settings.projectLocationsWorkBaseMeta': 'Munkabázis · a projektek itt almappaként jönnek létre',
  'settings.projectLocationsAddFolder': 'Mappa hozzáadása…',
  'settings.projectLocationsDefaultBadge': 'Alapértelmezett hely',
  'settings.projectLocationsMakeDefault': 'Legyen alapértelmezett',
  'settings.projectLocationsDefaultSaved': 'Az alapértelmezett projekt hely frissítve.',
  'settings.librarySkills': 'Készségek',
  'settings.libraryDesignSystems': 'Tervezőrendszerek',
  'settings.librarySearch': 'Keresés...',
  'settings.libraryAll': 'Összes',
  'settings.libraryPreview': 'Előnézet',
  'settings.libraryPreviewClose': 'Bezárás',
  'settings.libraryLoading': 'Betöltés...',
  'settings.libraryNoResults': 'Nincs a keresésnek megfelelő elem.',
  'settings.libraryEnabled': 'Engedélyezve',
  'settings.libraryDisabled': 'Letiltva',
  'settings.connectorsNavHint': 'Külső rendszerek kapcsolatai',
  'settings.connectorsHint': 'Kezeld az eszköz csatlakozó- és eszközszolgáltató-beállításait.',
  'settings.connectorsComposioApiKey': 'Composio API-kulcs',
  'settings.connectorsSavedTitle': 'Helyi daemonban mentve',
  'settings.connectorsSavedWithTail': 'Mentve · ••••{tail}',
  'settings.connectorsSaved': 'Mentve',
  'settings.connectorsGetApiKey': 'API-kulcs beszerzése',
  'settings.connectorsReplaceKeyPlaceholder': 'Illessz be új kulcsot a mentett cseréjéhez',
  'settings.connectorsApiKeyPlaceholder': 'Composio API-kulcs beillesztése',
  'settings.connectorsClear': 'Törlés',
  'settings.connectorsClearConfirmTitle': 'Törlöd a mentett Composio API-kulcsot?',
  'settings.connectorsClearConfirmBody': 'A kulcs törlése lekapcsolja ehhez a munkaterülethez kapcsolt összes Composio csatlakozót. A csatlakoztatott fiókok, OAuth-engedélyek és eszközhozzáférések mind eltávolításra kerülnek.',
  'settings.connectorsClearConfirmContinue': 'Tovább',
  'settings.connectorsClearFinalTitle': 'Ez minden csatlakozót lekapcsol',
  'settings.connectorsClearFinalBody': 'Nincs visszavonás. Új kulcs beillesztése után minden integrációt újra kell csatlakoztatnod.',
  'settings.connectorsClearFinalConfirm': 'Kulcs törlése és lecsatlakoztatás',
  'settings.connectorsClearArming': 'Egy pillanat…',
  'settings.connectorsClearCancel': 'Mégse',
  'settings.connectorsSaveKey': 'Kulcs mentése',
  'settings.connectorsSaveKeyTitle': 'Kulcs elküldése a helyi daemonhoz',
  'settings.connectorsKeySaving': 'Mentés…',
  'settings.connectorsKeySaved': 'Mentve ✓',
  'settings.connectorsKeyError': 'A kulcs mentése nem sikerült. Ellenőrizd, hogy a helyi daemon fut-e, majd próbáld újra.',
  'settings.connectorsHelpSaved': 'A kulcs feloldja az alábbi katalógust, és a helyi daemonban marad. Illessz be új kulcsot a cseréhez, vagy töröld az eltávolításhoz.',
  'settings.connectorsHelpUnsaved': 'Mentetlen változtatások — kattints a Kulcs mentése gombra, hogy a hitelesítő adat a helyi daemonba kerüljön, és nyíljon a lenti katalógus.',
  'settings.connectorsHelpEmpty': 'Adj hozzá kulcsot az alábbi katalógus feloldásához. A kulcsok helyben, a daemonban tárolódnak, és soha nem mennek át környezeti változókon.',
  'settings.connectorsLoadingSavedKey': 'Mentett kulcs ellenőrzése a helyi daemonban…',
  'settings.autosaveSaving': 'Mentés…',
  'settings.autosaveSaved': 'Minden változtatás mentve',
  'settings.autosaveError': 'A változtatások mentése nem sikerült. A helyi daemon offline lehet.',
  'settings.libraryToggleLabel': 'Átváltás',
  'settings.memory': 'Memória',
  'settings.memoryHint': 'Personal facts auto-extracted from chats',
  'settings.customInstructionsTitle': 'Globális szabályok',
  'settings.customInstructionsHint': 'Rögzített utasítások, amelyeket az OpenDesignnek minden csevegésben követnie kell. Mentsen tényeket, beállításokat és projektkontextust memóriaként.',
  'settings.customInstructionsPlaceholder': 'pl. „Mindig TypeScriptet használj. Részesítsd előnyben a funkcionális komponenseket. Tartsd tömören a válaszokat.”',
  'settings.memoryDescription': 'Auto-extracted facts about you and your preferences. Saved as Markdown files and folded into every chat.',
  'settings.memoryEnabled': 'Engedélyezve',
  'settings.memoryDisabled': 'Letiltva',
  'settings.memoryEnableLabel': 'Memóriainjektálás engedélyezése',
  'settings.memoryDisabledBanner': 'A memória jelenleg KI van kapcsolva. A meglévő tények megőrződnek a lemezen, de nem épülnek be az új csevegésekbe, és az új körök nem nyernek ki semmi újat.',
  'settings.memoryNew': 'Új memória',
  'settings.memoryEdit': 'Szerkesztés',
  'settings.memoryDelete': 'Törlés',
  'settings.memoryPreview': 'Előnézet',
  'settings.memoryEmpty': 'Még nincs memória.',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'A sötét módot részesítem előnyben',
  'settings.memoryName': 'Name',
  'settings.memoryDesc': 'One-line description',
  'settings.memoryBody': 'Memory body (Markdown supported)',
  'settings.memoryBodyHint': 'Lead with the rule itself; add Why and How to apply lines.',
  'settings.memoryStartersLabel': 'Kell egy kiindulópont? Kattintson az űrlap kitöltéséhez:',
  'settings.memoryStarterUserName': 'Saját szerepkör',
  'settings.memoryStarterUserDesc': 'Frontend mérnök vagyok, aki egy SaaS tervezőeszközön dolgozik',
  'settings.memoryStarterUserBody': '- Szerepkör: senior frontend mérnök\n- Stack: React, TypeScript, Vite\n- Terület: dizájn / együttműködési eszközök\n- Időzóna: GMT+8 (Asia/Shanghai)\n\nMikor alkalmazandó: bármilyen csevegés — a példákat webes frontendre építsd.',
  'settings.memoryStarterFeedbackName': 'Felhasználói felület beállításai',
  'settings.memoryStarterFeedbackDesc': 'Sötét mód, nagy törzsszöveg, alacsony információsűrűség',
  'settings.memoryStarterFeedbackBody': '- Téma: alapértelmezetten sötét\n- Törzsszöveg: ≥ 18px\n- Információsűrűség: részesítsd előnyben az üres helyet, kevesebb elem képernyőnként\n\nMiért: kevesebb szemmegerőltetés hosszú munkamenetek során.\nMikor alkalmazandó: amikor felhasználói felületet, weboldalakat vagy diákat generálsz.',
  'settings.memoryStarterProjectName': 'Jelenlegi projekt',
  'settings.memoryStarterProjectDesc': 'Open Design v0.5 — csevegésvezérelt dizájnszerkesztő',
  'settings.memoryStarterProjectBody': '- Cél: a csevegésvezérelt szerkesztő kiadása ebben a negyedévben\n- Prioritások: streaming renderelés, helyi multimodális, offline-first\n- Technológiai készlet: Next.js 16, Express daemon, SQLite\n\nMikor alkalmazandó: bármely, e projektről szóló beszélgetésben.',
  'settings.memorySaveHint': 'Nem mentődik automatikusan — a Create / Save gombbal alkalmazhatod.',
  'settings.memoryIndexSaveHint': 'Az index módosításai nem mentődnek automatikusan — a Save index gombbal alkalmazhatod.',
  'settings.memoryIndexUnsaved': 'Nem mentett módosítások',
  'settings.memoryFlashCreated': '✓ Memória létrehozva',
  'settings.memoryFlashSaved': '✓ Memória mentve',
  'settings.memoryFlashDeleted': '✓ Memória törölve',
  'settings.memoryFlashIndexSaved': '✓ Index mentve',
  'settings.memoryFlashPathCopied': '✓ Útvonal másolva',
  'settings.memoryNameLabel': 'Cím',
  'settings.memoryTypeLabel': 'Típus',
  'settings.memoryDescLabel': 'Leírás',
  'settings.memoryBodyLabel': 'Tartalom',
  'settings.memoryTypeUser': 'Felhasználó',
  'settings.memoryTypeFeedback': 'Visszajelzés',
  'settings.memoryTypeProject': 'Projekt',
  'settings.memoryTypeReference': 'Hivatkozás',
  'settings.memoryIndex': 'MEMORY.md (index)',
  'settings.memoryIndexSave': 'Index mentése',
  'settings.memoryIndexReset': 'Visszaállítás',
  'settings.memoryToastChanged': 'Memória frissítve',
  'settings.memoryToastClickHint': 'Megnyitás',
  'settings.memoryAll': 'Összes',
  'settings.memoryExtractions': 'Kinyerési előzmények',
  'settings.memoryExtractionsHint': 'Recent LLM-backed extraction attempts. Heuristic regex extraction always runs first; LLM extraction runs in the background after each turn.',
  'settings.memoryExtractionsEmpty': 'Még nincsenek kinyerések. A következő csevegési kör feltölti ezt a listát.',
  'settings.memoryExtractionsRefresh': 'Frissítés',
  'settings.memoryExtractionsRefreshing': 'Frissítés…',
  'settings.memoryExtractionPhaseRunning': 'Futtatás…',
  'settings.memoryExtractionPhaseSuccess': 'Sikeres',
  'settings.memoryExtractionPhaseSkipped': 'Kihagyva',
  'settings.memoryExtractionPhaseFailed': 'Sikertelen',
  'settings.memoryExtractionSkipNoProvider': 'Nincs konfigurált API key az LLM-alapú memóriakinyeréshez.',
  'settings.memoryExtractionSkipDisabled': 'A memória le van tiltva.',
  'settings.memoryExtractionSkipEmpty': 'Üres felhasználói üzenet — nincs mit kinyerni.',
  'settings.memoryExtractionSkipNoMatch': 'Egyetlen regex minta sem illeszkedett ebben a körben.',
  'settings.memoryExtractionKindHeuristic': 'regex',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'env',
  'settings.memoryExtractionProviderMediaConfig': 'médiabeállítások',
  'settings.memoryExtractionProviderOverride': 'memóriabeállítások',
  'settings.memoryExtractionProposed': 'javasolt',
  'settings.memoryExtractionWritten': 'kiírva',
  'settings.memoryExtractionDuration': 'in',
  'settings.memoryExtractionDelete': 'Törlés',
  'settings.memoryExtractionsClear': 'Törlés',
  'settings.memoryExtractionsClearTitle': 'Összes kinyerési előzmény törlése',
  'settings.memoryExtractionsClearConfirm': 'Törli az összes kinyerési előzményt? Ezt nem lehet visszavonni.',
  'settings.memoryNoProviderBannerTitle': 'Az LLM-alapú memóriakinyerés nem fut',
  'settings.memoryNoProviderBannerBody': 'Nem található API key a memóriakinyerőhöz. Adjon hozzá egy OpenAI kulcsot a Media providers alatt, vagy állítsa be az ANTHROPIC_API_KEY / OPENAI_API_KEY változót a környezetben az LLM-vezérelt kinyerés engedélyezéséhez. A heurisztikus regex-kinyerés továbbra is aktív.',
  'artifact.odCardTaskBriefChip': 'Memória alkalmazva · összefoglaló megtekintése',
  'artifact.odCardScorecardTitle': 'Önellenőrzés',
  'artifact.odCardScorecardStatusPass': 'Megfelelt',
  'artifact.odCardScorecardStatusPartial': 'Részleges',
  'artifact.odCardScorecardStatusFail': 'Javítandó',
  'artifact.odCardRuleKicker': 'Javasolt szabály',
  'artifact.odCardRuleNameLabel': 'Név',
  'artifact.odCardRuleDescriptionLabel': 'Leírás',
  'artifact.odCardRuleAssertionLabel': 'Teljesülnie kell',
  'artifact.odCardRuleCheckLabel': 'Hogyan ellenőrizd',
  'artifact.odCardRuleRationaleLabel': 'Miért',
  'artifact.odCardRuleKeep': 'Megtartás',
  'artifact.odCardRuleEdit': 'Szerkesztés',
  'artifact.odCardRuleDone': 'Kész',
  'artifact.odCardRuleDiscard': 'Elvetés',
  'artifact.odCardRuleSaving': 'Mentés…',
  'artifact.odCardRuleSaved': '„{name}” mentve szabályként',
  'artifact.odCardRuleError': 'A szabályt nem sikerült menteni. Próbáld újra.',
  'artifact.odCardBrandAssistDone': 'Browser assist confirmed',
  'artifact.odCardBrandAssistKicker': 'Browser assist needed: {reason}',
  'artifact.odCardBrandAssistBody': 'Open the brand site in the browser so Open Design can continue extracting this design system.',
  'artifact.odCardBrandAssistError': 'Could not start browser assist. Try again.',
  'artifact.odCardBrandAssistWorking': 'Starting...',
  'artifact.odCardBrandAssistConfirm': 'Open browser assist',
  'settings.memoryTypeProfile': 'Profil',
  'settings.memoryTypeRule': 'Szabály',
  'settings.memoryTabMemories': 'Emlékek',
  'settings.memoryTabMemoriesCaption': 'Mentett memória megtekintése és kezelése',
  'settings.memoryTabHow': 'Hogyan működik',
  'settings.memoryTabHowCaption': 'A két hurok és vezérlőik',
  'settings.memoryAddDisclosure': 'Emlékek hozzáadása vagy importálása',
  'settings.memoryAddDisclosureHint': 'Profil, kézi bevitel vagy csatlakoztatott alkalmazások',
  'settings.memoryProfileTab': 'Munkaprofil',
  'settings.memoryProfileTabCaption': 'Ki vagy és milyen alapbeállításaid vannak',
  'settings.memoryProfileTitle': 'A munkaprofilod',
  'settings.memoryProfileHint':
    'Néhány tény rólad és az alapbeállításaidról. A memória ezt minden feladat előtt beilleszti, így az ügynök egy rövid kérésből is kikövetkezteti, mire gondolsz.',
  'settings.memoryProfileName': 'Munkaprofil',
  'settings.memoryProfileDescription':
    'Szerepkör, cég, terület, közönség, ízlés és alapbeállítások, amelyeket az asszisztens újra felhasználhat.',
  'settings.memoryProfileSave': 'Profil mentése',
  'settings.memoryProfileSaving': 'Mentés…',
  'settings.memoryProfileSaved': 'Profil mentve',
  'settings.memoryProfileRole': 'Szerepkör',
  'settings.memoryProfileRolePlaceholder': 'pl. Founder, designer, PM',
  'settings.memoryProfileCompany': 'Cég / Csapat',
  'settings.memoryProfileCompanyPlaceholder': 'pl. Acme, growth team',
  'settings.memoryProfileDomain': 'Terület',
  'settings.memoryProfileDomainPlaceholder': 'pl. B2B SaaS, fintech, devtools',
  'settings.memoryProfileAudience': 'Elsődleges közönség',
  'settings.memoryProfileAudiencePlaceholder': 'pl. executives, engineers, end users',
  'settings.memoryProfileAesthetic': 'Esztétika / ízlés',
  'settings.memoryProfileAestheticPlaceholder':
    'pl. clean and editorial, light backgrounds, generous whitespace',
  'settings.memoryProfileDeliverables': 'Alapértelmezett szállítandók',
  'settings.memoryProfileDeliverablesPlaceholder': 'pl. landing pages, decks, one-pagers',
  'settings.memoryProfileLocale': 'Régió / Nyelv',
  'settings.memoryProfileLocalePlaceholder': 'pl. English (US), Simplified Chinese',
  'settings.memoryProfileGoals': 'Aktuális célok',
  'settings.memoryProfileGoalsPlaceholder':
    'pl. ship the new pricing page, raise conversion on the trial flow',
  'settings.memoryHooksTitle': 'Memóriahookok',
  'settings.memoryHooksHint':
    'Válaszd ki, mely memóriarészek fussanak automatikusan. A fenti főkapcsoló mindet kikapcsolja.',
  'settings.memoryHooksProfileLabel': 'Profilom használata',
  'settings.memoryHooksProfileDesc': 'Illeszd be a munkaprofilodat minden feladatba.',
  'settings.memoryHooksRewriteLabel': 'Rövid kérések átírása',
  'settings.memoryHooksRewriteDesc': 'PRE: bővíts ki egy rövid kérést teljes feladat-összefoglalóvá.',
  'settings.memoryHooksVerifyLabel': 'Kimenet önellenőrzése',
  'settings.memoryHooksVerifyDesc': 'POST: ellenőrizd az eredményt a szabályaid alapján, majd mutass egy eredménylapot.',
  'settings.memoryHooksExtractionLabel': 'Tanulás a csevegésekből',
  'settings.memoryHooksExtractionDesc': 'Hasznos tények és preferenciák rögzítése a csevegési körökből.',
  'settings.libraryInstall': 'Telepítés',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'Helyi elérési út',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': 'Telepítés',
  'settings.libraryUninstall': 'Eltávolítás',
  'settings.libraryBuiltIn': 'Beépített',
  'settings.libraryInstalled': 'Telepítve',
  'notify.successTitle': 'Feladat befejezve',
  'notify.failureTitle': 'A feladat meghiúsult',
  'notify.successBody': 'Egy kör befejeződött.',
  'notify.failureBody': 'A feladat hibával ért véget.',
  'updater.available': 'Frissítés érhető el',
  'updater.availableBody': 'Az Open Design {version} elérhető. A telepítő megnyitása előtt letöltődik.',
  'updater.checking': 'Frissítések keresése',
  'updater.download': 'Frissítés letöltése',
  'updater.downloading': 'Frissítés letöltése',
  'updater.downloadingPercent': 'Frissítés letöltése {percent}%',
  'updater.done': 'Kész',
  'updater.failed': 'A frissítés sikertelen',
  'updater.installerOpenBody': 'A telepítő meg van nyitva. Az Open Design kilép, hogy befejezhesse a frissítést.',
  'updater.installerOpened': 'Telepítő megnyitva',
  'updater.later': 'Később',
  'updater.openFailedFallback': 'A telepítő nem nyitható meg.',
  'updater.installRestart': 'Install and restart',
  'updater.installingRestart': 'Installing and restarting...',
  'updater.openInstaller': 'Frissítés telepítése',
  'updater.opening': 'Telepítő megnyitása...',
  'updater.payloadReadyGeneric': 'A new Open Design update is ready. Open Design will close and restart automatically.',
  'updater.payloadReadyVersion': 'Open Design {version} is ready. Open Design will close and restart automatically.',
  'updater.quitButton': 'Kilépés az Open Designból',
  'updater.quitFailedBody': 'A telepítő meg van nyitva, de az Open Design nem tudott kilépni. Az alkalmazás cseréje előtt lépjen ki az Open Designból.',
  'updater.quitFailedTitle': 'Nem sikerült kilépni',
  'updater.quitting': 'Kilépés...',
  'updater.ready': 'Frissítés kész',
  'updater.readyGeneric': 'Elkészült az új verzió. Az Open Design bezárul, és megnyitja a telepítőt.',
  'updater.readyVersion': 'Az Open Design {version} elkészült. Az Open Design bezárul, és megnyitja a telepítőt.',
  'updater.upToDate': 'Már a legújabb verziót használja.',
  'newsletter.label': 'Newsletter (optional)',
  'newsletter.placeholder': 'you@studio.com',
  'settings.memoryModelInlineLabel': 'Memory model',
  'settings.memoryModelInlineSameAsChat': 'Same as chat',
  'settings.memoryModelInlineSameAsChatWithModel': 'Same as chat ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Same as chat ({provider})',
  'settings.memoryModelInlineHintCli': 'Optional. The memory extractor uses an env-var or media-providers API key on this provider; pinning a model here just overrides the auto-pick.',
  'settings.memoryModelInlineHintCliConstrained': 'Optional. Memory will call {provider}; needs an env-var or media-providers API key for that provider, or pick a model below to override.',
  'settings.memoryModelInlineHintByok': 'Optional. Reuses your chat API key on the same provider — picking a different (usually cheaper) model only changes the request body.',
  'settings.memoryModelInlineFlashSaved': 'Saved',
  'settings.memoryModelInlineFlashCleared': 'Cleared',
  'settings.orbit.eyebrow': 'Automatizálás',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': 'Napi csatlakozó-összefoglaló',
  'settings.orbit.lede': 'Gyűjtsd a csatlakozók aktivitását ütemezetten, és tedd közzé az eredményt frissíthető live artifact formában.',
  'settings.orbit.statusOnTitle': 'Az ütemezett napi futások be vannak kapcsolva',
  'settings.orbit.statusOffTitle': 'Az ütemezett napi futások ki vannak kapcsolva',
  'settings.orbit.statusActive': 'Aktív',
  'settings.orbit.statusOff': 'Ki',
  'settings.orbit.runTitle': 'Orbit futás indítása és az élő beszélgetés megnyitása',
  'settings.orbit.running': 'Fut…',
  'settings.orbit.runOpen': 'Futtatás most',
  'settings.orbit.dailySummaryTitle': 'Napi összefoglaló',
  'settings.orbit.dailySummarySub': 'Naponta egyszer fut a beállított helyi időben.',
  'settings.orbit.on': 'Be',
  'settings.orbit.off': 'Ki',
  'settings.orbit.runTimeTitle': 'Futási idő',
  'settings.orbit.runTimeSub': 'Alapértelmezett 08:00. Mentés után érvényesül a daemon ütemezésében.',
  'settings.orbit.runTimeAria': 'Napi Orbit futási idő',
  'settings.orbit.nextRun': 'Következő futás',
  'settings.orbit.nextRunScheduledAfterSave': 'Mentés után ütemezve',
  'settings.orbit.schedule': 'Ütemezés',
  'settings.orbit.pausedManualOnly': 'Szüneteltetve — csak kézi futások',
  'settings.orbit.templateTitle': 'Prompt sablon',
  'settings.orbit.templateMissing': 'A(z) {id} sablon nincs telepítve.',
  'settings.orbit.templateMissingOption': '{id} (hiányzik)',
  'settings.orbit.templateMissingInstall': 'Telepíts Orbit skillt a prompt irányításához.',
  'settings.orbit.templateMissingPickAnother': 'Válassz másik sablont a legördülőből.',
  'settings.orbit.templateResetTitle': 'Visszaállítás erre: {id}',
  'settings.orbit.templateReset': 'Visszaállítás',
  'settings.orbit.templateHelp': 'Irányítsd az Orbit működését skillel — a kiválasztott sablon példa promptja bekerül minden Orbit futásba, hogy az összefoglalók a sablon formáját kövessék.',
  'settings.orbit.templateAria': 'Orbit prompt sablon',
  'settings.orbit.templatesLoading': 'Sablonok betöltése…',
  'settings.orbit.templatesOptgroup': 'Orbit skill sablonok',
  'settings.orbit.lastRun': 'Utolsó futás',
  'settings.orbit.triggerManual': 'Kézi',
  'settings.orbit.triggerScheduled': 'Ütemezett',
  'settings.orbit.meterAria': '{succeeded} sikeres, {skipped} kihagyva, {failed} sikertelen, összesen {checked} ellenőrizve',
  'settings.orbit.countChecked': 'Ellenőrizve',
  'settings.orbit.countSucceeded': 'Sikeres',
  'settings.orbit.countSkipped': 'Kihagyva',
  'settings.orbit.countFailed': 'Sikertelen',
  'settings.orbit.runError': 'Nem sikerült futtatni az Orbit műveletet. Ellenőrizd, hogy a helyi daemon fut-e, és a csatlakozók be vannak-e állítva.',
  'settings.orbit.gateAriaLabel': 'Az Orbit használatához csatlakozók szükségesek',
  'settings.orbit.gateEyebrow': 'Beállítás szükséges',
  'settings.orbit.gateTitle': 'Csatlakoztass egy eszközt az Orbit működéséhez',
  'settings.orbit.gateBody': 'Az Orbit összefoglalja a csatlakozók tevékenységét. Még nem csatlakoztattál semmit — adj hozzá legalább egy integrációt, hogy az Orbitnak legyen miről jelentenie.',
  'settings.orbit.gateBodyNoKey': 'Az Orbit a csatlakozóid tevékenységét összegzi, és a csatlakozók a Composio-n keresztül futnak. Adj hozzá egy Composio API-kulcsot a Csatlakozók alatt, hogy feloldd a katalógust és kiválaszthasd az első integrációd.',
  'settings.orbit.gateAction': 'Csatlakozók megnyitása',
  'settings.orbit.gateActionNoKey': 'Composio beállítása',
  'settings.orbit.gateLoading': 'Csatlakozók ellenőrzése…',
  'settings.orbit.controlsLockedBadge': 'Zárolva',
  'settings.orbit.controlsLockedHint': 'Csatlakoztass egy eszközt az Orbit ütemezésének és sablonjának feloldásához.',
  'settings.orbit.artifactKickerLive': 'élő artifact',
  'settings.orbit.artifactKickerLegacy': 'Régi összefoglaló',
  'settings.orbit.artifactTitle': 'Napi Orbit aktivitási összefoglaló',
  'settings.orbit.artifactMetaLive': 'Csatlakozó-aktivitásból generált frissíthető HTML artifact.',
  'settings.orbit.artifactMetaLegacy': 'A live artifact támogatás engedélyezése előtt készült — futtasd újra az Orbit műveletet egy közzétételéhez.',
  'settings.orbit.copyMarkdownTitle': 'Markdown összefoglaló másolása a vágólapra',
  'settings.orbit.copied': 'Másolva',
  'settings.orbit.copy': 'Másolás',
  'settings.orbit.openArtifact': 'Artefakt megnyitása',
  'settings.orbit.sourceMarkdown': 'Forrás Markdown',
  'settings.memoryModelInlineHintByokNeutral': 'A memória a csevegéstől eltérő modellt használ. Alapértelmezés szerint a csevegési modellt használja.',
  'diagnostics.exportTitle': 'Diagnosztika exportálása',
  'diagnostics.exportButton': 'Diagnosztika exportálása',
  'diagnostics.exportHint': 'A legutóbbi alkalmazásnaplókat és gépinformációkat zip fájlba csomagolja a csapatnak való elküldéshez.',
  'diagnostics.exporting': 'Exportálás…',
  'diagnostics.exportSuccess': 'Diagnosztika mentve: {path}',
  'diagnostics.exportFailed': 'Diagnosztika exportálása sikertelen: {message}',
  'automations.eyebrow': 'Ütemezett Agent-munkamenetek',
  'automations.title': 'Automatizálások',
  'automations.lede': 'Tervezz ismétlődő beszélgetéseket projektmunkához, Orbit összefoglalókhoz és élő tartalmakhoz.',
  'automations.summaryAria': 'Automatizálás-összegzés',
  'automations.metricActive': 'Aktív',
  'automations.metricPaused': 'Szüneteltetve',
  'automations.metricTemplates': 'Sablonok',
  'automations.newAutomation': 'Új automatizálás',
  'automations.yourAutomations': 'Automatizálásaid',
  'automations.loading': 'Betöltés',
  'automations.emptyTitle': 'Még nincs automatizálás',
  'automations.emptyBody': 'Hozz létre egyet sablonból, vagy kezdj üres ütemezéssel.',
  'automations.targetNewEachRun': 'Minden futáshoz új projekt',
  'automations.lastRun': 'Utolsó futás: {time}',
  'automations.openResult': 'Eredmény megnyitása',
  'automations.run': 'Futtatás',
  'automations.runNowTitle': 'Futtasd most és nyisd meg a beszélgetést',
  'automations.history': 'Előzmények',
  'automations.hideHistory': 'Előzmények elrejtése',
  'automations.edit': 'Szerkesztés',
  'automations.pause': 'Szüneteltetés',
  'automations.resume': 'Folytatás',
  'automations.deleteAria': 'Automatizálás törlése',
  'automations.deleteTitle': 'Az automatizálás törlése',
  'automations.deleteConfirm': 'Törlöd ezt az automatizálást? A korábbi futások és projektjeik megmaradnak.',
  'automations.proposalsTitle': 'Fejlesztési javaslatok',
  'automations.proposalsSub': 'Tekintsd át az automatizálás kimenetét, mielőtt módosítja a memóriát, a készségeket vagy a design rendszereket.',
  'automations.proposalsPending': '{n} függőben',
  'automations.apply': 'Alkalmaz',
  'automations.reject': 'Elutasít',
  'automations.proposalsDismissReason': 'Elvetve az Automatizálásokban',
  'automations.templatesTitle': 'Sablonok',
  'automations.templatesSub': 'Az Orbit és az élő tartalmak sablonok ugyanazon az automatizálási folyamaton belül.',
  'automations.templatesCount': '{filtered} / {total}',
  'automations.templateFiltersAria': 'Sablonszűrők',
  'automations.templatesEmptyTitle': 'Ebben a kategóriában még nincs sablon.',
  'automations.templatesEmptyBody': 'Próbálj másik szűrőt, vagy kezdj üres automatizálással.',
  'automations.useTemplate': 'Sablon használata',
  'automations.runHistoryLoading': 'Futási előzmények betöltése...',
  'automations.runHistoryEmpty': 'Még nincs futás.',
  'automations.runHistoryTitle': 'Futási előzmények',
  'automations.runHistoryLatest': 'Legutóbbi 10',
  'automations.crystallize': 'Kikristályosítás',
  'automations.crystallizing': 'Kikristályosítás folyamatban',
  'automations.crystallizeTitle': 'Készíts készség- és memóriajavaslatokat ebből a futásból',
  'automations.crystallizeFailed': 'Crystallize failed: {error}',
  'automations.crystallizePartialSuccess': 'Crystallize created proposals, but Automations could not refresh the proposal list. Review the visible proposals or try refreshing.',
  'automations.crystallizeRefreshFailed': 'Crystallize finished, but Automations could not refresh proposals. Try refreshing before running it again.',
  'automations.crystallizeNoProposals': 'Crystallize finished, but no proposals were returned. Try refreshing or check the run details.',
  'automations.openConversation': 'Beszélgetés megnyitása',
  'automations.runHistoryAria': 'Automatizálás futási előzményei',
  'automations.proposalsAria': 'Automatizálás fejlesztési javaslatai',
  'automations.templatesAria': 'Automatizálási sablonok',
  'automations.runInProgress': 'Folyamatban',
  'automations.scheduleStatusPaused': 'Szüneteltetve',
  'automations.nextRunManualOnly': 'Csak kézi',
  'automations.nextRunScheduled': 'Ütemezve',
  'automations.nextRunAt': 'Következő: {time}',
  'automations.statusSucceeded': 'Sikeres',
  'automations.statusFailed': 'Sikertelen',
  'automations.statusRunning': 'Fut',
  'automations.statusQueued': 'Sorban áll',
  'automations.statusCanceled': 'Megszakítva',
  'automations.kindOrbit': 'Orbit',
  'automations.kindLiveArtifact': 'Élő tartalom',
  'automations.kindAutomation': 'Automatizálás',
  'automations.proposalTargetMemory': 'Memória',
  'automations.proposalTargetDesignSystem': 'Design rendszer',
  'automations.proposalTargetSkill': 'Készség',
  'automations.proposalTargetTemplate': 'Automatizálási sablon',
  'automations.proposalActionCreate': 'Létrehozás',
  'automations.proposalActionUpdate': 'Frissítés',
  'automations.proposalActionMerge': 'Egyesítés',
  'automations.proposalActionMove': 'Áthelyezés',
  'automations.proposalActionDelete': 'Törlés',
  'automations.proposalActionPromote': 'Előléptetés',
  'automations.filterAll': 'Összes',
  'automations.filterOrbit': 'Orbit',
  'automations.filterLiveArtifacts': 'Élő tartalmak',
  'automations.filterMemory': 'Memória',
  'automations.filterDesignSystems': 'Design rendszerek',
  'automations.filterSkills': 'Készségek',
  'automations.filterConnectors': 'Csatlakozók',
  'automations.filterCompression': 'Tömörítés',
  'automations.filterRelease': 'Kiadás',
  'automations.filterQuality': 'Minőség',
  'automations.tpl.memoryRefresh.title': 'Frissítsd a projektmemóriát a legutóbbi munka alapján.',
  'automations.tpl.memoryRefresh.desc': 'Az ismétlődő döntéseket, preferenciákat és visszajelzéseket újrahasznosítható memóriafrissítésekké alakítja.',
  'automations.tpl.designSystemRefresh.title': 'Frissítsd a design rendszereket a leszállított tartalmak alapján.',
  'automations.tpl.designSystemRefresh.desc': 'Újrahasznosítható tokeneket, komponenseket és szabályokat talál a legutóbbi design munkában.',
  'automations.tpl.liveArtifactRegistry.title': 'Auditáld az élő tartalmakat és frissítsd az elavult verziókat.',
  'automations.tpl.liveArtifactRegistry.desc': 'Naprakészen tartja az állandó irányítópultokat, jelentéseket és előnézeteket azok megkettőzése helyett.',
  'automations.tpl.orbitDashboard.title': 'Építs csatlakozó-tevékenységi irányítópultot.',
  'automations.tpl.orbitDashboard.desc': 'A kiválasztott csatlakozókat Orbit-stílusú élő irányítópulttá összesíti.',
  'automations.tpl.releaseNotes.title': 'Készíts kiadási jegyzeteket a leszállított design munkából.',
  'automations.tpl.releaseNotes.desc': 'Összekapcsolja a beolvasztott PR-eket, tartalmakat és termékoldali változásokat kiadási jegyzetekké.',
  'automations.tpl.qualityRegressionWatch.title': 'Figyeld a design és megvalósítási regressziókat.',
  'automations.tpl.qualityRegressionWatch.desc': 'Összehasonlítja a legutóbbi változásokat a referenciaértékekkel, nyomvonalakkal és elfogadott referenciákkal.',
  'automations.tpl.orbitDaily.title': 'Napi csatlakozó-összefoglaló.',
  'automations.tpl.orbitDaily.desc': 'Ütemezetten frissít egy csatlakozó-tevékenységi összefoglalót.',
  'automations.tpl.liveStatusBoard.title': 'Tarts naprakészen egy élő státusztartalmat.',
  'automations.tpl.liveStatusBoard.desc': 'Egyetlen állandó tartalmat frissít ahelyett, hogy minden futáshoz új jelentést hozna létre.',
  'dsManager.areaAria': 'Design rendszerek terület',
  'dsManager.tabDesignSystem': 'Design rendszer',
  'dsManager.tabTemplate': 'Sablon',
  'dsManager.sourceAria': 'Design rendszer forrása',
  'dsManager.templateSourceAria': 'Sablon forrása',
  'dsManager.yourSystems': 'Rendszereid',
  'dsManager.officialPresets': 'Hivatalos előbeállítások',
  'dsManager.enterprise': 'Vállalati',
  'dsManager.yourTemplates': 'Sablonjaid',
  'dsManager.yourSystemsAria': 'Design rendszereid',
  'dsManager.eyebrowDesignSystems': 'Design rendszerek',
  'dsManager.yourSystemsHeading': 'Rendszereid',
  'dsManager.filterAria': 'Design rendszerek szűrése',
  'dsManager.filterAll': 'Összes',
  'dsManager.filterPublished': 'Közzétett',
  'dsManager.filterDraft': 'Vázlat',
  'dsManager.createTitle': 'Új design rendszer létrehozása',
  'dsManager.createBody': 'Tanítsd meg az Open Designnak a márkádat, terméked, kódod, eszközeid és design referenciáid.',
  'dsManager.createAction': 'Létrehozás',
  'dsManager.emptyMine': 'Még nincs design rendszer. Hozz létre egyet valós termékkontextusból, nézd át a vázlatot, majd tedd közzé a jövőbeli projektekhez.',
  'dsManager.badgeDefault': 'Alapértelmezett',
  'dsManager.rowMetaUpdated': 'Te · frissítve {date}',
  'dsManager.edit': 'Szerkesztés',
  'dsManager.openSystem': 'Megnyitás',
  'dsManager.editWithAgent': 'Szerkesztés Agenttel',
  'dsManager.downloadTitle': 'Designrendszer letöltése (.zip + SKILLS.md)',
  'dsManager.downloadAria': '{title} letöltése .zip fájlként',
  'dsManager.downloadFailed': 'A designrendszer letöltése nem sikerült. Próbáld újra.',
  'dsManager.deleteConfirm': 'Törlöd ezt: „{title}”? Ez eltávolítja a designrendszer vázlatát erről az eszközről.',
  'dsManager.makeDefault': 'Beállítás alapértelmezettként',
  'dsManager.statusPublished': 'Közzétett',
  'dsManager.statusDraft': 'Vázlat',
  'dsManager.openSystemAria': '{title} megnyitása',
  'dsManager.deleteSystemAria': '{title} törlése',
  'dsManager.presetsAria': 'Hivatalos design rendszer előbeállítások',
  'dsManager.eyebrowLibrary': 'Könyvtár',
  'dsManager.eyebrowTemplates': 'Sablonok',
  'dsManager.yourTemplatesAria': 'Sablonjaid',
  'dsManager.emptyTemplates': 'Még nincs sablon. Hozz létre egyet bármely generált projektből a Megosztás funkcióval, amint a sablonközzététel engedélyezve van.',
  'dsManager.templateDescFallback': 'Projektből létrehozva',
  'dsManager.comingSoonBadge': 'Hamarosan',
  'dsManager.enterpriseDsTitle': 'Vállalati design rendszerek',
  'dsManager.enterpriseDsBody': 'A megosztott csapat-design rendszerek és a felügyelt márkakönyvtárak hamarosan elérhetők.',
  'dsManager.enterpriseTplTitle': 'Vállalati sablonok',
  'dsManager.enterpriseTplBody': 'A csapat által jóváhagyott sablonok és a szervezetszintű közzététel hamarosan elérhetők.',
  'settings.instructionsTitle': 'Utasítások / szabályok',
  'settings.instructionsSubtitle': 'Rögzített viselkedés, amelyet az asszisztensnek követnie kell',
  'settings.instructionsNavSub': 'Rögzített asszisztens-viselkedés',
  'settings.customInstructionsDesc': 'Rögzített utasítások, amelyeket az Open Design minden csevegésben követ. Ezek nem mentett memóriák; a tényekhez, preferenciákhoz és projektkontextushoz használd a Memóriát.',
  'mcpClient.forwardedToLabel': 'Továbbítva ide:',
  'mcpClient.notForwardedToLabel': 'Nincs továbbítva ide:',
  'mcpClient.forwardedAcpNote': 'A stdio-ként megjelölt ACP adapterek csak a stdio MCP szervereket kapják meg ebből a listából; a HTTP és SSE bejegyzések indításkor elvetésre kerülnek.',
  'mcpClient.notForwardedNote': 'Ezekhez az Agentekhez állítsd be az MCP szervereket az Agent saját konfigurációs fájljában (pl. ~/.codex/config.toml, ~/.gemini/settings.json); az alábbi szerverek ott csendben kihasználatlanok maradnak.',

  // Brands library + extraction
  'brand.libraryTitle': 'Márkacsomag',
  'brand.librarySubtitle': 'Teach Open Design your brand kits — extract one from a website, then apply it in any chat.',
  'brand.newBrand': 'New Brand Kit',
  'brand.searchPlaceholder': 'Search your brand kits…',
  'brand.empty': 'No brand kits yet. Extract one from a website to get started.',
  'brand.colorsCount': '{count} colors',
  'brand.extracting': 'Extracting…',
  'brand.failed': 'Extraction failed',
  'brand.needsInput': 'Needs input',
  'brand.needsInputHint': 'Extraction paused — open the project to finish verification or answer the question.',
  'brand.appliedToChat': 'Using {name}',
  'brand.previewEmpty': 'Select a brand to preview',
  'brand.viewDetails': 'View details',
  'newBrand.title': 'New Brand',
  'newBrand.subtitle': 'Illessz be egy webhelyet, vagy válassz egy márkát alább, és kinyerjük a színeit, betűtípusait és logóját.',
  'newBrand.urlLabel': 'Brand website',
  'newBrand.urlPlaceholder': 'yourcompany.com',
  'newBrand.extract': 'Extract brand',
  'newBrand.cancel': 'Cancel',
  'newBrand.close': 'Close',
  'newBrand.stage1': 'Fetching the site & measuring its design',
  'newBrand.stage2': 'Building a brand preview',
  'newBrand.stage3': 'Deriving & registering the design system',
  'newBrand.measured': '{colors} colors · {fonts} fonts · {logos} logos',
  'newBrand.done': 'Brand ready',
  'brandDetail.identity': 'Identity',
  'brandDetail.designLanguage': 'Design Language',
  'brandDetail.colors': 'Colors',
  'brandDetail.fonts': 'Fonts',
  'brandDetail.tone': 'Tone',
  'brandDetail.aesthetic': 'Aesthetic',
  'brandDetail.tagline': 'Tagline',
  'brandDetail.voice': 'Voice',
  'brandDetail.useInChat': 'Use in new chat',
  'brandDetail.delete': 'Delete brand',
  'brandDetail.back': 'Márkacsomag',
  'brandDetail.refining': 'Refining this brand…',
  'brandDetail.notFound': 'Brand not found.',
  'brandDetail.logo': 'Logo',
  'brandDetail.typography': 'Typography',
  'brandDetail.palette': 'Palette',
  'brandDetail.voiceTone': 'Voice & tone',
  'brandDetail.imageryLayout': 'Imagery & layout',
  'brandDetail.images': 'Images',
  'brandDetail.designSystem': 'Design system',
  'brandDetail.brandAssets': 'Brand assets',
  'brandDetail.openProject': 'Open project',
  'brandDetail.themeLight': 'Light',
  'brandDetail.themeDark': 'Dark',
  'brandDetail.subjects': 'Subjects',
  'brandDetail.treatment': 'Treatment',
  'brandDetail.useLabel': 'Use',
  'brandDetail.avoidLabel': 'Avoid',
  'brandDetail.layoutPosture': 'Layout posture',
  'brandDetail.deleteConfirm': 'Delete "{name}"? This removes the brand and its design system.',
  'brandDetail.viewMore': 'Show all {count}',
  'brandDetail.viewLess': 'Show less',
  'settings.resetOnboarding': 'Reset onboarding',
  'settings.resetOnboardingDesc': 'Replay the first-run setup, including brand extraction.',
  'settings.resetOnboardingButton': 'Reset',
  'onboarding.brandTitle': 'Extract your brand kit',
  'onboarding.brandSubtitle': 'Paste a website and we\'ll turn its brand signals into a reusable brand kit for future work.',
  'onboarding.brandSkip': 'Skip for now',
  'onboarding.brandDone': 'Brand kit extracted',
  'onboarding.buildTitle': 'Hozd létre egyszer, építs vele bárhol',
  'onboarding.buildBody': 'Az Open Design a márkádat újrahasználható dizájnrendszerré alakítja, és mindent, amit építesz, márkahűen és egységesen tart.',
  'onboarding.buildBenefitMemoryTitle': 'One brand memory',
  'onboarding.buildBenefitMemoryBody': 'Colors, type, spacing, components, and voice become a DESIGN.md your agents can reuse.',
  'onboarding.buildBenefitAlignedTitle': 'Every output stays aligned',
  'onboarding.buildBenefitAlignedBody': 'Prototype, slide, PDF, dashboard, and marketing work all pull from the same rules.',
  'onboarding.buildBenefitSourcesTitle': 'Start from what you have',
  'onboarding.buildBenefitSourcesBody': 'Use a GitHub repo, website, existing DESIGN.md, screenshots, fonts, or Figma files.',
  'onboarding.buildPreviewLabel': 'Brand system',
  'onboarding.buildStart': 'Dizájnrendszer létrehozása',
  'onboarding.buildHome': 'Ugrás a főoldalra',
  'dsCreate.referenceLabel': 'Copy from existing design system',
  'dsCreate.referenceLoading': 'Loading DESIGN.md...',
  'dsCreate.referenceLoadFailed': 'Could not load that design system.',
  'dsCreate.heroShowGuideAria': 'Show design system guide',
  'dsCreate.heroHideGuideAria': 'Hide design system guide',
  'dsCreate.heroShowGuideTitle': 'Show guide',
  'dsCreate.heroHideGuideTitle': 'Hide guide',
  'dsCreate.heroGuide': 'Guide',
  'dsCreate.missingSourceError': 'Add a website, DESIGN.md, description, file, Figma source, or notes to create a design system.',
  'dsCreate.continueToGeneration': 'Continue to generation',
  'dsCreate.embeddedTitle': 'Generate from your material',
  'dsCreate.embeddedBody': 'Start with a website or brand reference, then add any source files you already have.',
  'dsCreate.sourceSectionTitle': 'Extract from GitHub, websites, or source material',
  'dsCreate.sourceSectionBody': 'Start with a GitHub repo, website, DESIGN.md, or files that show your style. Open Design first creates a usable system quickly, then AI can refine it inside the project.',
  'dsCreate.githubWebsiteLabel': 'GitHub or website',
  'dsCreate.add': 'Add',
  'dsCreate.startFromBrand': 'Start from a brand',
  'dsCreate.brandPickerSubtitle': 'Search hundreds of brands — pick one and we\'ll add its site as a style reference.',
  'dsCreate.brandPickerQuickPicks': 'Popular brands — click to add',
  'dsCreate.addedSourceLinks': 'Added source links',
  'dsCreate.openSourceLabel': 'Open {label}',
  'dsCreate.removeSourceLabel': 'Remove {label}',
  'dsCreate.addFiles': 'Add files',
  'dsCreate.describeBrand': 'Describe brand',
  'dsCreate.optional': 'optional',
  'dsCreate.describeBrandHelp': 'Brand voice, intro and product context. Used in the fast pass and AI refinement.',
  'dsCreate.companyPlaceholder': 'e.g. Mission Impastabowl: fast-casual pasta restaurant with kiosk, mobile app and website',
  'dsCreate.pasteDesignMd': 'Paste DESIGN.md',
  'dsCreate.pasteDesignMdHelp': 'Paste a DESIGN.md to create directly from tokens, rationale and component guidance.',
  'dsCreate.reference': 'Reference',
  'dsCreate.designMdViewMode': 'DESIGN.md view mode',
  'dsCreate.advancedToggle': 'Advanced — repo, local code, Figma',
  'dsCreate.githubRepo': 'GitHub repo',
  'dsCreate.localCodeLabel': 'Link local code',
  'dsCreate.localCodeHelper': 'Use a folder or selected files from this computer.',
  'dsCreate.localCodePrompt': 'Drag a folder here or browse',
  'dsCreate.uploadFigLabel': 'Upload .fig',
  'dsCreate.uploadFigHelper': 'Decoded on your machine into real tokens, components & assets — no Figma account.',
  'dsCreate.uploadFigPrompt': 'Drop .fig here or browse',
  'dsCreate.figmaUrl': 'Figma URL',
  'dsCreate.figmaPlaceholder': 'https://figma.com/design/… or /file/…',
  'dsCreate.addedFigmaUrls': 'Added Figma URLs',
  'dsCreate.savedFigmaHelp': 'Saved as a Figma design source. The agent uses it as the canonical reference; export a .fig above for a full offline decode.',
  'dsCreate.notes': 'Notes',
  'dsCreate.notesPlaceholder': 'e.g. We use a warm, earthy color palette with rounded corners. Our brand voice is playful but professional...',
  'dsCreate.back': 'Back',
  'dsCreate.generate': 'Generate',
  'dsCreate.libraryPickerTitle': 'Select from library',
  'dsCreate.libraryPickerConfirm': 'Add to assets',
  'dsCreate.designMdPreviewKicker': 'DESIGN SYSTEM',
  'dsCreate.designMdPreviewTitle': 'DESIGN.md preview',
  'dsCreate.componentKit': 'component kit',
  'dsCreate.defaultTheme': 'default theme',
  'dsCreate.componentKitTitle': '{name} — component kit',
  'dsCreate.designMdGeneratedDescription': 'Generated from pasted DESIGN.md tokens, rationale and component guidance.',
  'dsCreate.previewButtons': 'Buttons',
  'dsCreate.previewButtonsHelp': 'Five types across three sizes.',
  'dsCreate.buttonPrimary': 'Primary',
  'dsCreate.buttonDashed': 'Dashed',
  'dsCreate.buttonText': 'Text',
  'dsCreate.buttonLink': 'Link',
  'dsCreate.sizeSmall': 'Small',
  'dsCreate.sizeMedium': 'Medium',
  'dsCreate.sizeLarge': 'Large',
  'dsCreate.previewTypeScale': 'Type scale',
  'dsCreate.extractedTokens': 'Extracted DESIGN.md tokens',
  'brandPicker.heading': 'Indíts egy márkából, amit szeretsz',
  'brandPicker.subtext': 'Kattints bármelyik márkára, hogy a készletét közvetlenül a weboldaláról kinyerd.',
  'brandPicker.quickPicksLabel': 'Népszerű márkák – kattints a kinyeréshez',
  'brandPicker.searchPlaceholder': 'Márkák keresése…',
  'brandPicker.allCategories': 'Mind',
  'brandPicker.extractAction': 'Kinyerés',
  'brandPicker.showMore': 'Több megjelenítése',
  'brandPicker.opening': 'Kinyerés indítása – {brand} megnyitása…',
  'ds.kitVisualize': 'Vizualizálás',
  'ds.kitEdit': 'Szerkesztés',
  'ds.kitSource': 'Forrás',
  'ds.saveDesignMd': 'DESIGN.md mentése',
  'ds.saving': 'Mentés…',
  'ds.copyDesignMd': 'DESIGN.md másolása',
  'ds.editDesignMd': 'DESIGN.md szerkesztése',
  'ds.openDesignMd': 'DESIGN.md megnyitása',
  'ds.copyDesignMdModule': '{module} szakasz másolása',
  'ds.editDesignMdModule': '{module} szakasz szerkesztése',
  'ds.openDesignMdModule': '{module} szakasz megnyitása',
  'ds.uploadMd': 'MD feltöltése',
  'ds.uploadFont': 'Betűfájl hozzáadása',
  'ds.pasteImage': 'Kép beillesztése',
  'ds.refresh': 'Frissítés',
  'ds.download': 'Letöltés',
  'ds.importFolder': 'Mappa importálása',
  'ds.reset': 'Visszaállítás',
  'ds.editingDesignMdHint': 'A Markdown szerkesztése frissíti a megjelenített kitmodulokat.',
  'ds.editingModuleHint': 'Csak a(z) {module} modul szerkesztése történik.',
  'ds.manualEditModuleHint': 'Edit {module} here. Hover this section to reveal controls.',
  'ds.saveModule': 'Modul mentése',
  'ds.uploadLogo': 'Logó feltöltése',
  'ds.uploadImage': 'Kép feltöltése',
  'ds.uploading': 'Feltöltés…',
  'ds.moduleEmptyLogo': 'Még nincs logó',
  'ds.moduleEmptyFonts': 'Nincsenek rögzített betűkészletek.',
  'ds.actionDone': 'Kész',
  'ds.actionFailed': 'Valami hiba történt. Próbáld újra.',
  'ds.uploadDone': 'Feltöltve',
  'ds.uploadFailed': 'A feltöltés nem sikerült. Próbáld újra.',
  'ds.deleteLogo': 'Logó törlése',
  'ds.deleteImage': '{caption} törlése',
  'ds.deleteProjectConfirm': 'Törlöd ezt: „{title}”? Ez végleg eltávolítja a designrendszert és a projektjét erről az eszközről.',
  'ds.deleteProjectAction': '{title} törlése',
  'ds.editColor': '{name} szerkesztése',
  'ds.colorLabel': 'Szín',
  'ds.hexLabel': 'Hex',
  'ds.hexValueLabel': 'Hex érték',
  'ds.saveColor': 'Szín mentése',
  'ds.invalidHexColor': 'Adj meg érvényes Hex színt, például #FF6A3D.',
  'ds.colorSaveFailed': 'Ezt a színt nem sikerült menteni.',
  'ds.colorResetFailed': 'Ezt a színt nem sikerült visszaállítani.',
  'ds.designMdSectionLabel': '{module} DESIGN.md szakasz',
  'ds.kitErrorTitle': 'Ez a nézet hibába ütközött.',
  'ds.kitErrorRetry': 'Újratöltés',
  'ds.shortcutsLabel': 'Billentyűparancsok',
  'ds.shortcutsHint': 'Parancsok: E szerkesztés · C másolás · U feltöltés · R frissítés · ⌫ logó törlése',
  'ds.moduleEmptyImages': 'Még nincsenek képek',
  'ds.noOriginalColor': 'No original color is available for this swatch.',
  'ds.manifestReadFailed': 'Unable to read _ds_manifest.json.',
  'ds.reviewCollapseSection': 'Collapse {title}',
  'ds.reviewExpandSection': 'Expand {title}',
  'ds.reviewNeedsReview': 'Needs review',
  'ds.reviewLooksGood': 'Looks good',
  'ds.reviewActionsLabel': '{title} review',
  'ds.reviewNeedsWorkEllipsis': 'Needs work...',
  'ds.reviewEditFile': 'Edit {file}',
  'ds.reviewFeedbackLabel': 'Tell the agent what to change',
  'ds.reviewFeedbackPlaceholder': 'e.g. tighten spacing in {title}, regenerate this preview...',
  'ds.reviewChangedAfterFeedback': 'This section changed after your feedback. Review it again before publishing.',
  'ds.reviewChangedDuringRun': 'This section changed during the latest run. Review it before publishing.',
  'ds.reviewLastFeedback': 'Last feedback',
  'ds.previewGenerating': 'Generating preview...',
  'ds.creatingProjectTitle': 'Creating your design system...',
  'ds.creatingProjectSubtitle': 'Keep this tab open. You can come back in a few minutes.',
  'ds.generationProgressLabel': 'Design system generation progress {progress}%',
  'ds.publishRepoRequiredTitle': 'Finish importing your GitHub repo before you can publish.',
  'ds.publishDesignSystem': 'Publish design system',
  'ds.unpublishDesignSystem': 'Unpublish design system',
  'ds.published': 'Published',
  'ds.publish': 'Publish',
  'ds.extractionRunningTitle': 'Extracting design system',
  'ds.extractionCompleteTitle': 'Extraction complete',
  'ds.extractionRunningBody': 'Open Design is updating this system in place.',
  'ds.extractionCompleteBody': 'All extracted modules are shown below; empty sections are intentionally blank.',
  'ds.publishCardPublished': 'Your team\'s new projects can use this design system as context by default.',
  'ds.publishCardDraft': 'Your design system is ready, but your feedback will improve it. Publish it when it is ready to use in future projects.',
  'ds.useSystemTitle': 'Use this system',
  'ds.useSystemBody': 'Start a new design that inherits this system\'s colors, type, and components - kept on-brand automatically.',
  'ds.createNewDesign': 'Create new design',
  'ds.openSourceContext': 'Open source context',
  'ds.manifestNeedsAttention': 'Design manifest needs attention',
  'ds.openManifest': 'Open manifest',
  'ds.workspacePreparing': 'Preparing the design system workspace.',
  'ds.workspaceLoadingLabel': 'Design system workspace is loading',
  'ds.sectionQueued': 'Queued',
  'ds.sectionReviewUpdatedFiles': 'Updated files need review',
  'ds.reviewNeedsWork': 'Needs work',
  'ds.sectionRequiredFileMissing': 'Required file missing: {file}',
  'ds.sectionNoFilesYet': 'No files yet',
  'ds.generationSourceTitle': 'Source context',
  'ds.generationSourceDetail': 'Reading linked source context and repository evidence.',
  'ds.generationGuidanceTitle': 'Brand guidance',
  'ds.generationGuidanceDetail': 'Writing DESIGN.md guidance and voice.',
  'ds.generationTokensTitle': 'Design tokens',
  'ds.generationTokensDetail': 'Extracting colors, type, and spacing tokens.',
  'ds.generationPreviewsTitle': 'Preview cards',
  'ds.generationPreviewsDetail': 'Rendering reviewable preview cards.',
  'ds.generationUiKitTitle': 'UI kit',
  'ds.generationUiKitDetail': 'Creating reusable components and patterns.',
  'ds.generationAssetsTitle': 'Brand assets',
  'ds.generationAssetsDetail': 'Collecting logos, fonts, images, and icons.',
  'ds.phaseQueuedTypography': 'Typography queued',
  'ds.phaseQueuedTokens': 'Tokens queued',
  'ds.phaseQueuedSpacing': 'Spacing queued',
  'ds.phaseQueuedUiKit': 'UI kit queued',
  'ds.phaseQueuedAssets': 'Assets queued',
  'ds.phaseReadingTypography': 'Reading typography',
  'ds.phaseReadingTokens': 'Reading tokens',
  'ds.phaseReadingSpacing': 'Reading spacing',
  'ds.phaseReadingUiKit': 'Reading UI kit',
  'ds.phaseReadingAssets': 'Reading assets',
  'ds.phaseWritingTypography': 'Writing typography',
  'ds.phaseWritingTokens': 'Writing tokens',
  'ds.phaseWritingSpacing': 'Writing spacing',
  'ds.phaseBuildingUiKit': 'Building UI kit',
  'ds.phaseUpdatingAssets': 'Updating assets',
  'ds.phaseNeedsAttention': 'Needs attention',
  'ds.phaseUpdated': 'Updated',
  'ds.sectionActivityFromTodo': '{phase}: {todo}',
  'ds.sectionActivityReadFiles': 'Read {files}',
  'ds.sectionActivityPhaseFiles': '{phase}: {files}',
  'ds.sectionRunningReadingContext': 'Reading context for {title}.',
  'ds.sectionRunningNow': '{phase} now.',
  'ds.reviewLastReviewed': 'Last reviewed {time}',
  'ds.agentFeedbackQueued': 'Agent feedback queued',
  'ds.agentFeedbackSent': 'Agent feedback sent',
  'ds.agentFeedbackSentAt': 'Agent feedback sent {time}',
  'ds.agentFeedbackFailedWithError': 'Agent feedback failed: {error}',
  'ds.agentFeedbackFailed': 'Agent feedback failed',
  'ds.agentFeedbackUnknown': 'Agent feedback status unknown',
  'ds.repoConnectBannerTitle': 'Connect your repo to pull aspects of your design system',
  'ds.repoConnectCardTitle': 'Connect your repo',
  'ds.repoConnectPendingBody': 'Checking your GitHub connection...',
  'ds.repoConnectPendingButton': 'Checking GitHub...',
  'ds.repoConnectedTitle': 'GitHub is connected',
  'ds.repoConnectedBody': 'Re-import this repo to pull its files into your design system.',
  'ds.repoImportButton': 'Import repo',
  'ds.repoConnectBannerBody': 'Connect GitHub so Open Design can read your repository and pull colors, type, and components into this design system.',
  'ds.repoConnectCardBody': 'Pull colors, type, and components from your repository into this design system.',
  'ds.repoConnectButton': 'Connect GitHub',
};
